/* eslint-disable @typescript-eslint/naming-convention */

import { type TranslationShape } from './translation-shape'

export const fr: TranslationShape = {
  zod: {
    timezone: {
      regex: 'Le fuseau horaire est invalide',
    },
    postcode: {
      regex: 'Le code postal est invalide',
    },
    notEmpty: 'Ce champ ne peut pas être vide',
    atLeastOneUseCase: 'Au moins un périmètre doit être sélectionné',
    atLeastOneUserPerNotification: 'Chaque notification doit comporter au moins un utilisateur',
    oneSendMethodRequiredPerNotification: 'Chaque notification doit comporter au moins une méthode d’envoi (mail, sms ou appel)',
  },
  common: {
    yes: 'Oui',
    no: 'Non',
    noResult: 'Aucun résultat',
    type: 'Type',
    equipment: 'Équipement',
    building: 'Bâtiment',
    floor: 'Étage',
    space: 'Pièce',
    deselect: 'Désélectionner',
    model: 'Modèle',
    name: 'Nom',
    expandAll: 'Tout déplier',
    collapseAll: 'Tout replier',
    button: {
      add: 'Ajouter',
      cancel: 'Annuler',
      validate: 'Valider',
      save: 'Enregistrer',
      retry: 'Réessayer',
      edit: 'Modifier',
      close: 'Fermer',
      delete: 'Supprimer',
      confirm: 'Confirmer',
      continue: 'Continuer quand même',
    },
    form: {
      timezone: 'Fuseau horaire',
      city: 'Ville',
      postcode: 'Code postal',
      address: 'Adresse',
      lastname: 'Nom',
      firstname: 'Prénom',
      phone: 'Téléphone',
      email: 'Email',
      all: 'Tous',
      all_female: 'Toutes',
      search: 'Rechercher...',
      selectBuilding: 'Sélectionner un bâtiment',
      selectFloor: 'Sélectionner un étage',
      selectSpace: 'Sélectionner une pièce',
      selectSite: 'Sélectionner un site',
      country: 'Pays',
      selectType: 'Sélectionner un type',
    },
    siteName: 'Nom du site',
    site: 'Site',
    users: 'Utilisateurs',
    to: 'au',
    dashboard: 'Tableau de bord',
    energy: 'Énergie',
    usage: 'Usage',
    dju: 'DJU (usage)',
    off: 'Éteint',
    on: 'Allumé',
  },
  badge: {
    group: 'Groupe',
  },
  error: {
    title: 'Oops !',
    description: "Désolé, cette page n'existe pas",
    invalidPostalCode: 'Code postal invalide',
    invalidTimezone: 'Fuseau horaire invalide',
    genericError: 'Oops ! Une erreur est survenue',
    number: 'Nombre invalide',
    devices: "L'alerte doit comporter au moins un équipement",
    alertDeviceDisconnectedAlreadyExists: 'Une alerte de type capteur déconnecté existe déjà pour ce site',
    operatorNotAssignedOnEquipment: 'L’opérateur n’est pas assigné sur un des équipements sélectionnés',
    userForm: {
      mailAlreadyExists: 'Un utilisateur existe déjà avec cette adresse email',
      cognitoUserAlreadyExists:
        'Un compte d’authentification existe déjà pour cette adresse email sans utilisateur associé : contactez Ouisense pour le supprimer',
      sitesRequired: 'Sélectionnez au moins un site pour ce rôle',
      invalidSites: 'Un des sites sélectionnés n’appartient pas à votre entreprise',
      equipmentsRequired: 'Sélectionnez au moins un équipement pour ce rôle',
    },
  },
  login: {
    email: 'Email',
    password: 'Mot de passe',
    passwordConfirm: 'Confirmer le mot de passe',
    passwordPlaceHolder: '••••••••',
    forgottenPassword: 'Mot de passe oublié',
    rememberMe: 'Se souvenir de moi',
    title: 'Bienvenue sur OuiSense',
    submit: 'Se connecter',
    error: {
      title: 'Erreur',
      badUserBadPassword: 'Mail ou mot de passe invalide',
      userAlreadyAuthenticated: 'Vous êtes déjà connecté',
    },
  },
  mySites: {
    title: 'Mes sites',
    addSite: 'Ajouter un site',
    addYourFirstSite: 'Ajouter votre premier site',
    mySitesError: 'Une erreur est survenue lors du chargement de vos sites',
    map: 'Carte des sites',
  },
  site: {
    siteLoadingError: 'Une erreur est survenue lors du chargement des informations du site',
    siteEditError: 'Une erreur est survenue lors de la modification du site',
    uploadPhotoError:
      'Une erreur est survenue lors du téléchargement de votre photo. Veuillez réessayer ultérieurement. Si le problème persiste, contactez-nous',
    uploadPhotoPreviewDialog: {
      title: "Aperçu de l'image",
      previewImageAlt: 'Prévisualisation de la nouvelle image du site',
    },
    tabs: {
      site: 'Informations',
      siteWorkers: 'Intervenants',
      installations: 'Installations',
      works: 'Suivi travaux',
      dailyMonitoring: 'Pilotage quotidien',
      sensors: 'Capteurs',
      myAlerts: 'Mes alertes',
      alertConfiguration: 'Configuration',
      consumption: 'Consommation',
      gateways: 'Bornes',
      reports: 'Rapports',
      reportConfiguration: 'Configuration',
      sitesMap: 'Carte des sites',
      sitesList: 'Liste des sites',
      logbook: 'Main courante',
    },
    notificationConsumption: {
      sensor: 'Capteur',
      location: 'Emplacement',
      sms: 'SMS',
      call: 'Appels',
      mail: 'Emails',
      billable: 'Consommé (SMS + appels)',
      usage: 'Conso / plafond',
      viewHistory: "Voir l'historique",
      warningTitle: 'Plafond de notifications atteint',
      warningDescriptionOne: 'Ce mois-ci, 1 capteur a atteint ou dépassé 80 % de son plafond mensuel de notifications facturées (SMS + appels).',
      warningDescriptionOther: 'Ce mois-ci, {{count}} capteurs ont atteint ou dépassé 80 % de leur plafond mensuel de notifications facturées (SMS + appels).',
      empty: 'Aucune notification facturée ce mois-ci sur ce site.',
      chartTitle: 'Notifications par mois',
      tableTitle: 'Consommation par capteur (mois en cours)',
      scopeAllSite: 'Tout le site',
      month: 'Mois',
      monthlyDetail: 'Détail par mois',
      last12Months: '12 derniers mois',
    },
    nameAndLocation: {
      title: 'Nom et localisation',
      addPhoto: 'Ajouter une photo',
    },
    owner: {
      title: 'Propriétaire',
      siteIsPublic: 'Le site est public :',
    },
    legalResp: {
      title: 'Responsable des installations',
      description:
        "Le responsable des installations peut être le propriétaire des installations, le directeur de l'ERP ou un exploitant si cette responsabilité lui a été contractuellement déléguée",
      radio: {
        owner: 'Propriétaire des installations',
        director: "Directeur de l'établissement",
        operator: 'Exploitant',
      },
      operator: 'Exploitant',
    },
    buildings: {
      title: 'Bâtiments du site',
      addBuilding: 'Ajouter un bâtiment',
      youCannotDeleteThisBuilding: 'Vous ne pouvez pas supprimer un bâtiment ayant des équipements.',
    },
  },
  equipment: {
    tabs: {
      equipmentWithActions: 'Équipements avec actions préventives',
      samplings: 'Points de prélévements',
      equipmentColdStorage: 'Équipements',
      cloudConnector: 'Borne cloud',
    },
    error: {
      cannotGetEquipment: 'Erreur lors du chargement des équipements',
    },
    groupExplanation: "« Groupe » représente un ensemble d'équipements comme les protections anti-retour/clapet de manière à éviter de les ajouter un par un.",
    individual: 'Équipement individuel',
    category: 'Catégorie',
    withActionsEquipment: 'Équipements avec actions',
    action: 'Action',
    equipmentTypes: {
      airConditioning: 'Climatisation',
      production: 'Production',
      distribution: 'Distribution',
      other: 'Autre',
      usage: 'Usage',
      coldPositive: 'Froid positif',
      coldNegative: 'Froid négatif',
      ambient: 'Ambiance',
      meter: 'Compteur',
    },
    actionCategories: {
      sample: 'Prélèvement',
      temperature: 'Température',
      purge: 'Purge',
      waterTreatment: "Traitement de l'eau",
      maintenance: 'Maintenance',
      humidity: 'Humidité',
    },
    conditions: {
      thMixed: 'TH',
      chlorine: 'Chlore',
      sodium: 'Sodium',
      thSoft: 'TH',
      thRaw: 'TH',
      phosphate: 'Phosphate',
      silicate: 'Silicate',
      conductivity: 'Conductivité',
      ph: 'pH',
      iron: 'Fer',
      th: 'TH',
      tac: 'TAC',
      temperature: 'T',
      redox: 'Redox',
      legionella: 'Lp',
      waterConsumption: 'Conso.',
      pressure: 'P',
      flow: 'Débit',
      deltaPressure: 'delta P',
      microbio36: 'Microorganisme aérobie à 36°C',
      microbio22: 'Microorganisme aérobie à 22°C',
      coli: 'Bactéries coliformes',
      escherichia: 'Escherichia coli',
      enterococci: 'Entérocoques',
      pseudomonas: 'Pseudomonas aeruginosa',
      sulfite: 'Bactéries anaérobies sulfito-réductrices',
      staphy: 'Staphylocoques pathogènes',
    },
    actionNames: {
      thMixedReadingSoftener_manual: 'TH eau brute adoucie',
      chlorineReadingSoftener_manual: 'Chlorures eau brute adoucie (si chloration continue)',
      sodiumReadingSoftener_manual: 'Sodium eau brute adoucie',
      thSoftReadingSoftener_manual: 'TH sortie adoucisseur',
      thRawReadingSoftener_manual: 'TH eau brute',
      filterCleaningSoftener_manual: 'Nettoyage ou remplacement des filtres',
      resinCleaningSoftener_manual: 'Nettoyage et désinfection des résines',
      saltTankCleaningSoftener_manual: 'Nettoyage et désinfection du bac à sel ',
      resinCheckSoftener_manual: "Vérification de l'état des résines",
      saltTankcheckSoftener_manual: 'Vérification du niveau de bac à sel',
      maintenanceSoftenerSoftener_manual:
        'Entretien adoucisseur - Contrôle fonctionnement normal / régénération et boîtier de commande (débit, saumurage, fuite chlorure)',
      softenerCheckSoftener_manual: "Vérification des consommables, fonctionnement de l'adoucisseur, suivi et évaluation du traitement",
      regenerationCheckSoftener_manual: 'Contrôle des cycles de régénération/programmateur',
      settingCheckFilmForming_manual: 'Contrôle et vérification des réglages',
      maintenanceGeneralFilmForming_manual: 'Maintenance générale du groupe de dosage (tubing, clapets, membrane, injection…)',
      pulseEmitterCheckFilmForming_manual: 'Test de fonctionnement de l’émetteur d’impulsions du compteur',
      phosphateReadingHotGeneralFlow_manual: 'Phosphate (P2O5)',
      silicateReadingHotGeneralFlow_manual: 'Silicate (SiO2)',
      conductivityReadingHotGeneralFlow_manual: 'Conductivité',
      phReadingHotGeneralFlow_manual: 'pH',
      ironReadingHotGeneralFlow_manual: 'Taux de fer',
      consumptionCheckFilmForming_manual: 'Vérification de la cohérence (conso. d’eau et produit)',
      corrosionCheckSleevesTest_manual: 'Contrôle de la corrosion des manchettes témoins',
      phReadingColdIncoming_manual: 'pH',
      thReadingColdIncoming_manual: 'TH',
      conductivityReadingColdIncoming_manual: 'Conductivité',
      chlorineReadingColdIncoming_manual: 'Taux de chlore libre',
      tacReadingColdIncoming_manual: 'TAC',
      temperatureReadingColdColdIncoming_auto: 'EF - Température - Automatique',
      temperatureReadingColdColdIncoming_manual: 'EF - Température - Manuel',
      microbio36ReadingColdIncoming_manual: 'Potabilité - Microorganisme aérobie à 36°C (D1)',
      microbio22ReadingColdIncoming_manual: 'Potabilité - Microorganisme aérobie à 22°C (D1)',
      coliReadingColdIncoming_manual: 'Potabilité - Bactéries coliformes (D1)',
      escherichiaReadingColdIncoming_manual: 'Potabilité - Escherichia coli (D1)',
      enterococciReadingColdIncoming_manual: 'Potabilité - Entérocoques (D1)',
      pseudomonasReadingColdIncoming_manual: 'Potabilité - Pseudomonas aeruginosa',
      sulfiteReadingColdIncoming_manual: 'Potabilité - Spores de bactéries anaérobies sulfito-réductrices (D1)',
      chemicalD1ReadingColdIncoming_manual:
        'Potabilité - Analyse chimique D1 (température, aspect, couleur, saveur, odeur, turbidité, pH, conductivité, nitrates, chlore libre et total, fer total, aluminium, ammonium)',
      chemicalD2ReadingColdIncoming_manual:
        'Potabilité - Analyse chimique D2 (plomb, fer total, cadmium, antimoine, chlorites, chrome, cuivre, nickel, nitrites, HAP, trihalométhanes, épichlorhydrine, acrylamide et chlorure de vinyle)',
      settingCheckChlorinationStation_manual: 'Contrôle et vérification des réglages',
      maintenanceGeneralChlorinationStation_manual: 'Maintenance & nettoyage du groupe dosage (tubing, clapets, membrane, injection…)',
      cleaningChlorineSensorChlorinationStation_manual: 'Nettoyage et étalonnage de la sonde chlore',
      pulseEmitterCheckChlorinationStation_manual: 'Test de fonctionnement de l’émetteur d’impulsions du compteur',
      chlorineReadingUseLegionella_manual: 'Taux de chlore libre - Point proche ou éloigné (si chloration continue)',
      chlorineReadingUseIndividualBalneo_manual: 'Taux de chlore libre - Point proche ou éloigné (si chloration continue)',
      chlorineReadingUseLegionellaVulnerable_manual: 'Taux de chlore libre - Point proche ou éloigné (si chloration continue)',
      redoxReadingChlorinationStation_manual: 'Indication de la sonde redox',
      consumptionCheckChlorinationStation_manual: 'Vérification de la cohérence (conso. d’eau et produit)',
      probeCheckProbeProduction_manual: 'Vérification des thermomètres (via référence)',
      cleaningDescalingHotCollectiveTank_manual: 'Nettoyage, détartrage et désinfection ',
      anodeCheckHotCollectiveTank_manual: 'Vérification de l’anode sacrificielle',
      drainHotCollectiveTank_manual: 'Chasse fond de ballon (via vanne de vidange)',
      temperatureReadingHotHotCollectiveTank_auto: 'ECS - Température - Automatique',
      temperatureReadingHotHotCollectiveTank_manual: 'ECS - Température - Manuelle',
      legionellaReading2HotHotCollectiveTank_manual: 'ECS - Legionella pneumophila 2ème jet',
      legionellaReading1HotHotCollectiveTank_manual: 'ECS - Legionella pneumophila 1er jet',
      cleaningHeatExchanger_manual: 'Nettoyage, détartrage et désinfection ',
      tightnessCheckHeatExchanger_manual: "Contrôle de l'étanchéité des échangeurs",
      cleaningDescalingColdTank_manual: 'Nettoyage, détartrage et désinfection ',
      cleaningDescalingHotIndividualTank_manual: 'Nettoyage, détartrage et désinfection ',
      anodeCheckHotIndividualTank_manual: 'Vérification de l’anode sacrificielle',
      drainHotIndividualTank_manual: 'Chasse fond de ballon (via vanne de vidange)',
      temperatureReadingHotHotIndividualTank_auto: 'ECS - Température - Automatique',
      temperatureReadingHotHotIndividualTank_manual: 'ECS - Température - Manuelle',
      electricalCheckHotIndividualTank_manual:
        'Ballon électrique : Contrôle serrage connexions électriques, état câblage, coffret de commande et de puissance, anode sacrificielle',
      legionellaReading2HotHotIndividualTank_manual: 'ECS - Legionella pneumophila 2ème jet',
      legionellaReading1HotHotIndividualTank_manual: 'ECS - Legionella pneumophila 1er jet',
      deaeratorCheckDeaeratorDistribution_manual: 'Contrôle des dégazeurs automatiques ',
      thermostatCheckThermostat_manual: 'Contrôle des thermostats',
      changeoverCirculationPump_manual: 'Permutation des pompes de boucle',
      pumpCheckCirculationPump_manual: 'Vérification / Maintenance des pompes',
      waterConsumptionReadingWaterMeter_manual: 'Consommation d’eau : Relevé du compteur d’eau froide',
      tightnessCheckNonReturnProtectionProduction_manual: 'Contrôle étanchéité des protections anti-retour (alimentation EF de la prod. ECS et Retour)',
      checkBackflowPreventerBackflowPreventerGroup_manual: 'Contrôle des disconnecteurs',
      checkProtectionNonReturnProtectionDistribution_manual: 'Contrôle des protections anti-retours (clapets) et remplacement si besoin',
      checkBackflowPreventerBackflowPreventer_manual: 'Contrôle des disconnecteurs',
      temperatureReadingHotHotGeneralFlow_auto: 'ECS - Température - Automatique',
      temperatureReadingHotHotGeneralFlow_manual: 'ECS - Température - Manuelle',
      thMixedReadingHotGeneralFlow_manual: 'TH eau brute adoucie',
      pressureReadingHotGeneralFlow_manual: 'Contrôle de la pression sur départ ECS',
      chlorineReadingHotGeneralFlow_manual: 'Taux de chlore libre sur départ ECS (si chloration continue)',
      legionellaReading2HotHotGeneralFlow_manual: 'ECS - Legionella pneumophila 2ème jet',
      legionellaReading1HotHotGeneralFlow_manual: 'ECS - Legionella pneumophila 1er jet',
      temperatureReadingHotHotGeneralReturn_auto: 'ECS - Température - Automatique',
      temperatureReadingHotHotGeneralReturn_manual: 'ECS - Température - Manuelle',
      thMixedReadingHotGeneralReturn_manual: 'TH eau brute adoucie',
      legionellaReading2HotHotGeneralReturn_manual: 'ECS - Legionella pneumophila 2ème jet',
      legionellaReading1HotHotGeneralReturn_manual: 'ECS - Legionella pneumophila 1er jet',
      chlorineReadingHotGeneralReturn_manual: 'Taux de chlore libre sur retour général ECS (si chloration continue)',
      temperatureReadingHotHotLoopReturn_auto: 'ECS - Température - Automatique',
      temperatureReadingHotHotLoopReturn_manual: 'ECS - Température - Manuelle',
      thMixedReadingHotLoopReturn_manual: 'TH eau brute adoucie',
      flowReadingHotLoopReturn_manual: 'Contrôle du débit retour de boucle ECS',
      legionellaReading2HotHotLoopReturn_manual: 'ECS - Legionella pneumophila 2ème jet',
      legionellaReading1HotHotLoopReturn_manual: 'ECS - Legionella pneumophila 1er jet',
      chlorineReadingHotLoopReturn_manual: 'Taux de chlore libre sur retour de boucle ECS (si chloration continue)',
      temperatureReadingHotHotLoopStart_auto: 'ECS - Température - Automatique',
      temperatureReadingHotHotLoopStart_manual: 'ECS - Température - Manuelle',
      thMixedReadingHotLoopStart_manual: 'TH eau brute adoucie',
      flowReadingHotLoopStart_manual: 'Contrôle du débit départ de boucle ECS',
      legionellaReading2HotHotLoopStart_manual: 'ECS - Legionella pneumophila 2ème jet',
      legionellaReading1HotHotLoopStart_manual: 'ECS - Legionella pneumophila 1er jet',
      chlorineReadingHotLoopStart_manual: 'Taux de chlore libre sur départ de boucle ECS (si chloration continue)',
      temperatureReadingColdColdGeneralFlow_auto: 'EF - Température - Automatique',
      temperatureReadingColdColdGeneralFlow_manual: 'EF - Température - Manuel',
      pressureReadingColdGeneralFlow_manual: 'Contrôle de la pression mise en distribution EF',
      filterCheckLegionellaFilter_manual: 'Contrôle filtres terminaux et changement cartouches si besoin',
      drainLowPointNetwork_manual: 'Chasse : Purge points bas du réseau (bas de colonne)',
      autoFlushCheckAutoFlush_manual: 'Vérification des chasses automatiques',
      temperatureCheckProbeDistribution_manual: 'Vérification sondes de température (via référence étalonnée)',
      deaeratorCheckDeaeratorProduction_manual: 'Vérification purgeurs automatiques, dégazeurs',
      balanceCheckValveDistribution_manual: 'Vérification / ajustement de l’équilibrage du réseau',
      generalCheckValveDistribution_manual: 'Manœuvre et contrôle du bon fonctionnement',
      insultationCheckInsulation_manual: 'Calorifugeage : Vérification visuel de l’état ',
      heatingCordCheckHeatingCord_manual: 'Vérification cordons chauffants',
      purgeUsePurged_manual: "Purge (écoulement d'eau)",
      filterCheckAirConditioning_manual: 'Contrôle visuel filtres et condensas (écoulement et dépôt)',
      filterCleaningAirConditioning_manual: 'Nettoyage et désinfection des filtres',
      tankCleaningAirConditioning_manual: 'Nettoyage et désinfection du bac',
      surfaceCleaningAirConditioning_manual: 'Nettoyage et désinfection des surfaces ',
      legionellaReading2ColdAirConditioning_manual: 'EF - Legionella pneumophila 2ème jet',
      legionellaReading1ColdAirConditioning_manual: 'EF - Legionella pneumophila 1er jet',
      temperatureReadingHotUseLegionella_auto: 'ECS - Température avant mitigeur - Automatique',
      temperatureReadingHotUseLegionella_manual: 'ECS - Température avant mitigeur - Manuelle',
      temperatureReadingColdUseLegionella_auto: 'EF - Température avant mitigeur - Automatique',
      temperatureReadingColdUseLegionella_manual: 'EF - Température avant mitigeur - Manuel',
      temperatureReadingBlendedUseLegionella_auto: 'Eau Mitigée - Température - Automatique',
      temperatureReadingBlendedUseLegionella_manual: 'Eau Mitigée - Température - Manuelle',
      purgeUseLegionella_auto: 'Purge - Action générée en fonction des remontées capteurs',
      purgeUseLegionella_manual: "Purge (écoulement d'eau)",
      legionellaReading2ColdUseLegionella_manual: 'EF - Legionella pneumophila 2ème jet',
      legionellaReading1ColdUseLegionella_manual: 'EF - Legionella pneumophila 1er jet',
      legionellaReading2HotUseLegionella_manual: 'ECS - Legionella pneumophila 2ème jet',
      legionellaReading1HotUseLegionella_manual: 'ECS - Legionella pneumophila 1er jet',
      legionellaReading2BlendedUseLegionella_manual: 'Eau mitigée - Legionella pneumophila 2ème jet',
      legionellaReading1BlendedUseLegionella_manual: 'Eau mitigée - Legionella pneumophila 1er jet',
      descaleShowerFitting_manual: 'Détartrage & désinfection pommes de douche et flexibles (ou remplacement avec désinfection avant pose)',
      descaleTapFitting_manual: 'Détartrage désinfection brise jets et mousseurs (ou remplacement avec désinfection avant pose) ',
      mixerCheckFitting_manual: 'Contrôle du bon fonctionnement mitigeurs et mélangeurs',
      descaleWaterFountainGroup_manual: 'Détartrage et désinfection ',
      microbio36ReadingWaterFountain_manual: 'Potabilité - Microorganisme aérobie à 36°C (D1)',
      microbio22ReadingWaterFountain_manual: 'Potabilité - Microorganisme aérobie à 22°C (D1)',
      coliReadingWaterFountain_manual: 'Potabilité - Bactéries coliformes (D1)',
      escherichiaReadingWaterFountain_manual: 'Potabilité - Escherichia coli (D1)',
      enterococciReadingWaterFountain_manual: 'Potabilité - Entérocoques (D1)',
      pseudomonasReadingWaterFountain_manual: 'Potabilité - Pseudomonas aeruginosa',
      sulfiteReadingWaterFountain_manual: 'Potabilité - Spores de bactéries anaérobies sulfito-réductrices (D1)',
      generalCheckValveUsage_manual: 'Manœuvre et contrôle du bon fonctionnement',
      microbio36ReadingUsePotability_manual: 'Potabilité - Microorganisme aérobie à 36°C (D1)',
      microbio22ReadingUsePotability_manual: 'Potabilité - Microorganisme aérobie à 22°C (D1)',
      coliReadingUsePotability_manual: 'Potabilité - Bactéries coliformes (D1)',
      escherichiaReadingUsePotability_manual: 'Potabilité - Escherichia coli (D1)',
      enterococciReadingUsePotability_manual: 'Potabilité - Entérocoques (D1)',
      pseudomonasReadingUsePotability_manual: 'Potabilité - Pseudomonas aeruginosa',
      sulfiteReadingUsePotability_manual: 'Potabilité - Spores de bactéries anaérobies sulfito-réductrices (D1)',
      enterococciReadingPoolBalneo_manual: 'Piscine - Entérocoques',
      escherichiaReadingPoolBalneo_manual: 'Piscine - Escherichia coli',
      pseudomonasReadingPoolBalneo_manual: 'Piscine - Pseudomonas aeruginosa',
      staphyReadingPoolBalneo_manual: 'Piscine - Staphylocoques pathogènes',
      microbio36ReadingPoolBalneo_manual: 'Piscine - Microorganisme aérobie à 36°C',
      sulfiteReadingPoolBalneo_manual: 'Piscine - Spores de bactéries anaérobies sulfito-réductrices',
      microbio36ReadingUseStdCareWater_manual: 'ESS - Microorganisme aérobie à 36°C',
      microbio22ReadingUseStdCareWater_manual: 'ESS - Microorganisme aérobie à 22°C',
      coliReadingUseStdCareWater_manual: 'ESS - Bactéries coliformes',
      escherichiaReadingUseStdCareWater_manual: 'ESS - Escherichia coli',
      pseudomonasReadingUseStdCareWater_manual: 'ESS - Pseudomonas aeruginosa',
      microbio36ReadingUseBactControlledWater_manual: 'EBC - Microorganisme aérobie à 36°C',
      microbio22ReadingUseBactControlledWater_manual: 'EBC - Microorganisme aérobie à 22°C',
      pseudomonasReadingUseBactControlledWater_manual: 'EBC - Pseudomonas aeruginosa',
      microbioEndoReadingEndoscope_manual: 'Endoscope - Contrôle microbiologique',
      microbioReadingEndoscopeWasherWaterIncome_manual: 'Eau endoscopie - Contrôle microbiologique',
      microbioReadingEndoscopeWasherWaterRinse_manual: 'Eau endoscopie - Contrôle microbiologique',
      microbioReadingDialysisWater_manual: 'Contrôle microbiologique (Microorganisme aérobie, endotoxines)',
      microbioReadingPurifiedWater_manual: 'Contrôle microbiologique (Microorganisme aérobie, endotoxines)',
      changeoverPump_manual: 'Permutation des pompes de boucle',
      pumpCheckPump_manual: 'Vérification / Maintenance des pompes',
      microbio36ReadingUseIndividualBalneo_manual: 'Balneo - Microorganisme aérobie à 36°C',
      microbio22ReadingUseIndividualBalneo_manual: 'Balneo - Microorganisme aérobie à 22°C',
      coliReadingUseIndividualBalneo_manual: 'Balneo - Bactéries coliformes',
      escherichiaReadingUseIndividualBalneo_manual: 'Balneo - Escherichia coli',
      pseudomonasReadingUseIndividualBalneo_manual: 'Balneo - Pseudomonas aeruginosa',
      staphyReadingUseIndividualBalneo_manual: 'Balneo - Staphylocoques pathogènes',
      legionellaReading2ColdUseIndividualBalneo_manual: 'EF - Legionella pneumophila 2ème jet',
      legionellaReading1ColdUseIndividualBalneo_manual: 'EF - Legionella pneumophila 1er jet',
      legionellaReading2HotUseIndividualBalneo_manual: 'ECS - Legionella pneumophila 2ème jet',
      legionellaReading1HotUseIndividualBalneo_manual: 'ECS - Legionella pneumophila 1er jet',
      legionellaReading2BlendedUseIndividualBalneo_manual: 'Eau mitigée - Legionella pneumophila 2ème jet',
      legionellaReading1BlendedUseIndividualBalneo_manual: 'Eau mitigée - Legionella pneumophila 1er jet',
      microbio36ReadingBalneoWhirlpool_manual: 'Balneo - Microorganisme aérobie à 36°C',
      microbio22ReadingBalneoWhirlpool_manual: 'Balneo - Microorganisme aérobie à 22°C',
      coliReadingBalneoWhirlpool_manual: 'Balneo - Bactéries coliformes',
      escherichiaReadingBalneoWhirlpool_manual: 'Balneo - Escherichia coli',
      pseudomonasReadingBalneoWhirlpool_manual: 'Balneo - Pseudomonas aeruginosa',
      staphyReadingBalneoWhirlpool_manual: 'Balneo - Staphylocoques pathogènes',
      legionellaReading2ColdBalneoWhirlpool_manual: 'EF - Legionella pneumophila 2ème jet',
      legionellaReading1ColdBalneoWhirlpool_manual: 'EF - Legionella pneumophila 1er jet',
      legionellaReading2HotBalneoWhirlpool_manual: 'ECS - Legionella pneumophila 2ème jet',
      legionellaReading1HotBalneoWhirlpool_manual: 'ECS - Legionella pneumophila 1er jet',
      legionellaReading2BlendedBalneoWhirlpool_manual: 'Eau mitigée - Legionella pneumophila 2ème jet',
      legionellaReading1BlendedBalneoWhirlpool_manual: 'Eau mitigée - Legionella pneumophila 1er jet',
      legionellaReading2ColdUseLegionellaVulnerable_manual: 'EF - Legionella pneumophila 2ème jet',
      legionellaReading1ColdUseLegionellaVulnerable_manual: 'EF - Legionella pneumophila 1er jet',
      legionellaReading2HotUseLegionellaVulnerable_manual: 'ECS - Legionella pneumophila 2ème jet',
      legionellaReading1HotUseLegionellaVulnerable_manual: 'ECS - Legionella pneumophila 1er jet',
      legionellaReading2BlendedUseLegionellaVulnerable_manual: 'Eau mitigée - Legionella pneumophila 2ème jet',
      legionellaReading1BlendedUseLegionellaVulnerable_manual: 'Eau mitigée - Legionella pneumophila 1er jet',
      airParticleReadingAirSample_manual:
        "Contrôle particulaire (classification particulaire, classe de cinétique d'élimination des particules, vérification des paramètres aérauliques)",
      airMicrobioReadingAirSample_manual: 'Air - Contrôle microbiologique',
      airSurfaceReadingSurfaceSample_manual: 'Surface - Contrôle microbiologique',
      microbioFoodReadingFoodSample_manual: 'Alimentaire - Contrôle microbiologique',
      microbioFoodSurfaceReadingFoodSurface_manual: 'Surface zone alimentaire - Contrôle microbiologique',
      microbioDishWaterReadingDishWater_manual: 'Eau de plonge - Contrôle microbiologique',
      microbioLinenReadingLinenSample_manual: 'Linge - Contrôle microbiologique',
      microbioMilkReadingBibronnerieMilkSample_manual: 'Lait - Contrôle microbiologique',
      microbioSurfaceBibReadingBibronnerieSurfaceSample_manual: 'Bibronnerie Surface - Contrôle microbiologique',
      temperatureReadingHotHotColumnNonLooped_auto: 'ECS - Température - Automatique',
      thMixedReadingHotColumnNonLooped_manual: 'TH eau brute adoucie',
      temperatureReadingHotHotColumnNonLooped_manual: 'ECS - Température - Manuelle',
      temperatureReadingHotUseIndividualBalneo_auto: 'ECS - Température avant mitigeur - Automatique',
      temperatureReadingHotUseIndividualBalneo_manual: 'ECS - Température avant mitigeur - Manuelle',
      temperatureReadingColdUseIndividualBalneo_auto: 'EF - Température avant mitigeur - Automatique',
      temperatureReadingColdUseIndividualBalneo_manual: 'EF - Température avant mitigeur - Manuelle',
      temperatureReadingBlendedUseIndividualBalneo_auto: 'Eau mitigée - Température - Automatique',
      temperatureReadingBlendedUseIndividualBalneo_manual: 'Eau mitigée - Température - Manuelle',
      purgeUseIndividualBalneo_auto: 'Purge - Action générée en fonction des remontées capteurs',
      purgeUseIndividualBalneo_manual: "Purge (écoulement d'eau)",
      temperatureReadingBalneo_auto: 'Bassin balneo - Température quotidienne - Automatique',
      freeChlorineReadingBalneo_auto: 'Bassin balneo - Chlore libre quotidien - Automatique',
      activeChlorineReadingBalneo_auto: 'Bassin balneo - Chlore actif quotidien - Automatique',
      phReadingBalneo_auto: 'Bassin balneo - pH quotidien - Automatique',
      temperatureReadingHotUseLegionellaVulnerable_auto: 'ECS - Température avant mitigeur - Automatique',
      temperatureReadingHotUseLegionellaVulnerable_manual: 'ECS - Température avant mitigeur - Manuelle',
      temperatureReadingColdUseLegionellaVulnerable_auto: 'EF - Température avant mitigeur - Automatique',
      temperatureReadingColdUseLegionellaVulnerable_manual: 'EF - Température avant mitigeur - Manuelle',
      temperatureReadingBlendedUseLegionellaVulnerable_auto: 'Eau mitigée - Température - Automatique',
      temperatureReadingBlendedUseLegionellaVulnerable_manual: 'Eau mitigée - Température - Manuelle',
      purgeUseLegionellaVulnerable_auto: 'Purge - Action générée en fonction des remontées capteurs',
      purgeUseLegionellaVulnerable_manual: "Purge (écoulement d'eau)",
      cleanWaterFountainGroup_manual: 'Désinfection ',
      traceabilityWaterFountainGroup_manual: 'Collecter la fiche de traçabilité',
      cleanWaterFountain_manual: 'Désinfection ',
      descaleWaterFountain_manual: 'Détartrage et désinfection ',
      traceabilityUsePurged_manual: 'Collecter la fiche de traçabilité',
      temperatureReadingHotHeatExchanger_manual: 'ECS - Température - Manuelle',
      temperatureReadingHotHeatExchanger_auto: 'ECS - Température - Automatique',
      rinceBypass_manual: 'Rinçage du bipasse',
      phosphateReadingHotGeneralReturn_manual: 'Phosphate (P2O5)',
      silicateReadingHotGeneralReturn_manual: 'Silicate (SiO2)',
      conductivityReadingHotGeneralReturn_manual: 'Conductivité',
      phReadingHotGeneralReturn_manual: 'pH',
      ironReadingHotGeneralReturn_manual: 'Taux de fer',
      phosphateReadingHotLoopReturn_manual: 'Phosphate (P2O5)',
      silicateReadingHotLoopReturn_manual: 'Silicate (SiO2)',
      conductivityReadingHotLoopReturn_manual: 'Conductivité',
      phReadingHotLoopReturn_manual: 'pH',
      ironReadingHotLoopReturn_manual: 'Taux de fer',
      phosphateReadingHotLoopStart_manual: 'Phosphate (P2O5)',
      silicateReadingHotLoopStart_manual: 'Silicate (SiO2)',
      conductivityReadingHotLoopStart_manual: 'Conductivité',
      phReadingHotLoopStart_manual: 'pH',
      ironReadingHotLoopStart_manual: 'Taux de fer',
      checkFilterWaterFilter_manual: 'Contrôle filtre et encrassement',
      drainHotLoopReturn_manual: 'Chasse sur retour de boucle',
      drainHotLoopStart_manual: 'Chasse sur départ de boucle',
      curveAnalysisCurveTemperature_manual: 'Analyse des courbes de température',
      phReadingColdGeneralFlow_manual: 'pH',
      thReadingColdGeneralFlow_manual: 'TH',
      conductivityReadingColdGeneralFlow_manual: 'Conductivité',
      chlorineReadingColdGeneralFlow_manual: 'Taux de chlore libre',
      tacReadingColdGeneralFlow_manual: 'TAC',
      temperatureReadingColdColdRoomNegative_auto: 'Température - Automatique',
      temperatureReadingColdColdRoomPositive_auto: 'Température - Automatique',
      temperatureReadingColdAmbient_auto: 'Température - Automatique',
      humidityReadingColdColdRoomNegative_auto: 'Humidité - Automatique',
      humidityReadingColdColdRoomPositive_auto: 'Humidité - Automatique',
      humidityReadingColdAmbient_auto: 'Humidité - Automatique',
      samplePdfColdIncoming_manual: 'Prélèvement mixte (PDF)',
      samplePdfHotCollectiveTank_manual: 'Prélèvement mixte (PDF)',
      samplePdfHotIndividualTank_manual: 'Prélèvement mixte (PDF)',
      samplePdfHotGeneralFlow_manual: 'Prélèvement mixte (PDF)',
      samplePdfHotGeneralReturn_manual: 'Prélèvement mixte (PDF)',
      samplePdfHotLoopReturn_manual: 'Prélèvement mixte (PDF)',
      samplePdfAirConditioning_manual: 'Prélèvement mixte (PDF)',
      samplePdfUseLegionella_manual: 'Prélèvement mixte (PDF)',
      samplePdfWaterFountain_manual: 'Prélèvement mixte (PDF)',
      samplePdfUsePotability_manual: 'Prélèvement mixte (PDF)',
      samplePdfPoolBalneo_manual: 'Prélèvement mixte (PDF)',
      samplePdfUseStdCareWater_manual: 'Prélèvement mixte (PDF)',
      samplePdfUseBactControlledWater_manual: 'Prélèvement mixte (PDF)',
      samplePdfEndoscope_manual: 'Prélèvement mixte (PDF)',
      samplePdfEndoscopeWasherWaterIncome_manual: 'Prélèvement mixte (PDF)',
      samplePdfEndoscopeWasherWaterRinse_manual: 'Prélèvement mixte (PDF)',
      samplePdfDialysisWater_manual: 'Prélèvement mixte (PDF)',
      samplePdfPurifiedWater_manual: 'Prélèvement mixte (PDF)',
      samplePdfUseIndividualBalneo_manual: 'Prélèvement mixte (PDF)',
      samplePdfBalneoWhirlpool_manual: 'Prélèvement mixte (PDF)',
      samplePdfUseLegionellaVulnerable_manual: 'Prélèvement mixte (PDF)',
      samplePdfAirSample_manual: 'Prélèvement mixte (PDF)',
      samplePdfSurfaceSample_manual: 'Prélèvement mixte (PDF)',
      samplePdfFoodSample_manual: 'Prélèvement mixte (PDF)',
      samplePdfDishWater_manual: 'Prélèvement mixte (PDF)',
      samplePdfFoodSurface_manual: 'Prélèvement mixte (PDF)',
      samplePdfLinenSample_manual: 'Prélèvement mixte (PDF)',
      samplePdfBibronnerieMilkSample_manual: 'Prélèvement mixte (PDF)',
      samplePdfBibronnerieSurfaceSample_manual: 'Prélèvement mixte (PDF)',
      samplePdfHotLoopStart_manual: 'Prélèvement mixte (PDF)',
    },
    frequencies: {
      daily: '1 jour',
      '3day': '3 jours',
      weekly: '1 semaine',
      fortnightly: '2 semaines',
      monthly: '1 mois',
      '2month': '2 mois',
      '3month': '3 mois',
      '6month': '6 mois',
      yearly: '1 an',
      '2year': '2 ans',
      '5year': '5 ans',
    },
    frequency: 'Fréquence',
    equipmentNames: {
      softener: 'Adoucisseur',
      filmForming: 'Poste Filmogène (anti corrosion / tartre)',
      sleevesTest: 'Manchettes témoin',
      coldIncoming: "Eau d'entrée / Arrivée eau de ville",
      chlorinationStation: 'Poste de désinfection / chloration en continu (chlore)',
      probeProduction: 'Thermomètres/Sondes',
      hotCollectiveTank: 'Ballon collectif ECS',
      heatExchanger: 'Echangeur',
      coldTank: 'Réservoir EF',
      hotIndividualTank: 'Ballon individuel ECS (non bouclé)',
      deaeratorProduction: 'Dégazeur automatique',
      thermostat: 'Thermostat',
      circulationPump: 'Pompe de bouclage',
      waterMeter: "Compteur d'eau",
      nonReturnProtectionProduction: 'Protection anti-retour / clapet',
      backflowPreventerGroup: 'Disconnecteur',
      nonReturnProtectionDistribution: 'Protection anti-retour / clapet',
      backflowPreventer: 'Disconnecteur',
      hotGeneralFlow: 'Départ général ECS',
      hotGeneralReturn: 'Retour général ECS',
      hotLoopReturn: 'Retour de boucle ECS',
      hotLoopStart: 'Départ de boucle ECS',
      coldGeneralFlow: 'Départ distribution EF',
      legionellaFilter: 'Filtres terminaux légionelle',
      lowPointNetwork: 'Points bas du réseau (bas de colonne)',
      autoFlush: 'Chasse automatique',
      probeDistribution: 'Thermomètres/Sondes',
      deaeratorDistribution: 'Dégazeur/Purge automatique',
      valveDistribution: 'Vannes',
      insulation: 'Calorifugeage',
      heatingCord: 'Cordon chauffant',
      usePurged: "Points d'usage / Douches à purger (peu utilisés)",
      airConditioning: 'Climatisation',
      useLegionella: "Point d'usage / Douche standard (hors balneo, vulnérable légio - CLIN)",
      fitting: 'Robinetterie (robinets, douches)',
      waterFountainGroup: 'Fontaines à eau',
      waterFountain: 'Fontaine à eau',
      valveUsage: 'Vannes',
      usePotability: "Point d'usage potabilité",
      poolBalneo: 'Piscine / Bassin balneo',
      useStdCareWater: "Point d'usage - Eau pour Soins Standard (ESS)",
      useBactControlledWater: "Point d'usage - Eau Bactériologiquement Contrôlée (EBC)",
      endoscope: 'Endoscope',
      endoscopeWasherWaterIncome: "Eau d'alimentation pour Laveur Désinfecteur Endoscope (LDE)",
      endoscopeWasherWaterRinse: 'Eau de rinçage terminal pour Laveur Désinfecteur Endoscope (LDE)',
      dialysisWater: "Point du système d'hémodialyse (eau de dialyse)",
      purifiedWater: "Point d'eau purifiée",
      pump: 'Pompe',
      useIndividualBalneo: "Balneo - Point d'usage / douche individuelle",
      balneoWhirlpool: 'Balneo - Bains à remous, douches à jets, jacuzzi, spa',
      useLegionellaVulnerable: "Point d'usage / Douche pour patients vulnérables légio. (CLIN)",
      airSample: "Air d'une Zone à environnement maîtrisée (ZEM)",
      surfaceSample: "Surface d'une Zone à environnement maîtrisée (ZEM)",
      foodSample: 'Aliment (plat)',
      dishWater: 'Eau de plonge',
      foodSurface: 'Surface zone alimentaire',
      linenSample: 'Linge',
      bibronnerieMilkSample: 'Bibronnerie - Lait',
      bibronnerieSurfaceSample: 'Bibronnerie - Surface',
      hotColumnNonLooped: 'Colonne ECS non bouclée',
      bypass: 'Bipasse / Bypass',
      waterFilter: 'Filtre Eau Froide',
      curveTemperature: 'Analyse des courbes de température',
      coldRoomNegative: 'Enceinte Frigorifique Négative',
      coldRoomPositive: 'Enceinte Frigorifique Positive',
      ambient: 'Pièce Enceinte',
      waterMeterMain: 'Compteur d’eau',
      waterMeterSub: 'Sous-compteur d’eau',
      gasMeterMain: 'Compteur de gaz',
      gasMeterSub: 'Sous-compteur de gaz',
      electricityMeterMain: 'Compteur d’électricité',
      electricityMeterSub: 'Sous-compteur d’électricité',
      photovoltaicMeterMain: 'Compteur de production photovoltaïque',
      thermalMeterMain: 'Compteur thermique',
      thermalMeterSub: 'Sous-compteur thermique',
      fuelMeterMain: 'Compteur de fioul',
      fuelMeterSub: 'Sous-compteur de fioul',
      temperatureRoom: 'Température ambiante pièce',
      setPointRoom: 'Point de consigne pièce',
      tempHeatingCircuitSetPoint: 'Température de consigne circuit de chauffage',
      ouisenseTemperatureHeatingCircuitSetPoint: 'Température de consigne circuit de chauffage Ouisense',
      tempHeatingCircuitDeparture: 'Température départ circuit de chauffage',
      temperatureHeatingCircuitDelta: 'Température delta retour circuit de chauffage',
      temperatureHeatingProductionDeparture: 'Température départ chaudière',
      temperatureHeatingProductionSetPoint: 'Température de consigne chaudière',
      electricityPowerMax: 'Puissance électrique maximale',
      electricityPowerAvg: 'Puissance électrique moyenne',
      electricityPowerSubscription: 'Puissance électrique souscrite',
      temperatureCtaBlowing: 'Température soufflage CTA',
      temperatureCtaSetPoint: 'Température de consigne CTA',
      temperatureCtaSetPointWrite: 'Consigne température CTA (écriture)',
      temperatureCtaSetPointWriteBlowing: 'Consigne température soufflage CTA (écriture)',
      airFlowDetectionCta: "Détection de flux d'air CTA",
      temperatureHeatingProductionReturn: 'Température retour chaudière',
      chillerUnit: 'Groupe froid',
      productionCooling: 'Production froid',
      temperatureCoolingDeparture: 'Température départ froid',
      temperatureCoolingReturn: 'Température retour froid',
      defaultChiller: 'Défaut groupe froid',
      defaultFlow: 'Défaut débit',
      temperatureCoolingProductionDeparture: 'Température départ production froid',
      temperatureCoolingProductionReturn: 'Température retour production froid',
      temperatureOutside: 'Température extérieure',
      hygroOutside: 'Hygrométrie extérieure',
      tempCircuitDeparture: 'Température départ circuit',
      tempCircuitSetPoint: 'Température de consigne circuit',
      temperatureCtaRecovery: 'Température de reprise CTA',
      defaultBattery: 'Batterie faible',
      co2: 'CO2',
      co2SetPoint: 'Consigne CO2 CTA',
      speedCtaSetPoint: 'Consigne vitesse CTA',
      mixingAirOutput: 'Caisson sortie',
      mixingAirManualAuto: 'Manuel auto caisson',
      mixingAirManualOutput: 'Sortie caisson en manuel',
      surpressureCtaSetPoint: 'Consigne surpression CTA',
      humidity: 'Humidité',
      connectivityLora: 'Connectivité LoRa',
      deaerator: 'Dégazeur',
      defaultCom: 'Défaut de communication',
      defaultCritical: 'Défaut critique',
      defaultCta: 'Défaut CTA',
      defaultManual: 'Défaut manuel',
      defaultPump: 'Défaut pompe',
      defaultReverseCta: 'Défaut inversion CTA',
      distributionConstant: 'Distribution constante',
      distributionHeating: 'Distribution chauffage',
      electricityMacroMeter: 'Macro-compteur électrique',
      hotWater: 'Eau chaude',
      modeBlowing: 'Mode soufflage',
      modeBlowingCta: 'Mode soufflage CTA',
      modeBlowingCtaSetPoint: 'Consigne mode soufflage CTA',
      modeBlowingSetPoint: 'Consigne mode soufflage',
      modeRecovery: 'Mode reprise',
      modeRecoverySetPoint: 'Consigne mode reprise',
      nonReturnProtection: 'Protection anti-retour',
      onlineCounter: 'Compteur en ligne OuiSense',
      otherDefault: 'Autre défaut',
      probe: 'Sonde',
      productionHeating: 'Production chauffage',
      surpressureCtaAmbient: 'Surpression CTA ambiante',
      tempCircuitReturn: 'Température retour circuit',
      temperatureCtaAmbient: 'Température ambiante CTA',
      tempHeatingCircuitReturn: 'Température retour circuit de chauffage',
      tempPrimary: 'Température départ primaire',
      flow: 'Débit',
      power: 'Puissance',
      volume: 'Volume',
      energy: 'Énergie',
      valve: 'Vanne',
      defaultElec: 'Défaut électrique',
      lightDay: 'Éclairage jour',
      lightNight: 'Éclairage nuit',
      reverseDefaultElec: 'Défaut inversé électrique',
      zoneCta: 'Zone CTA',
      zoneVmc: 'Zone VMC',
      zoneLight: 'Zone éclairage',
      zoneTemperature: 'Zone température',
      macroZoneTemperature: 'Macro zone température',
      zoneBalneo: 'Zone balneo',
      temperatureBalneo: 'Température bassin balneo',
      freeChlorineBalneo: 'Chlore libre bassin balneo',
      activeChlorineBalneo: 'Chlore actif bassin balneo',
      phBalneo: 'pH bassin balneo',
      cloudConnector: 'Borne cloud',
      fanRecovery: 'Ventilateur de reprise',
      fanRecoveryManualAuto: 'Ventilateur de reprise - Manuel/Auto',
      fanRecoveryManualOutput: 'Ventilateur de reprise - Sortie manuelle',
      fanBlowing: 'Ventilateur de soufflage',
      fanBlowingManualAuto: 'Ventilateur de soufflage - Manuel/Auto',
      fanBlowingManualOutput: 'Ventilateur de soufflage - Sortie manuelle',
      batteryHotManualAuto: 'Batterie chaude - Manuel/Auto',
      batteryHotManualOutput: 'Batterie chaude - Sortie manuelle',
      batteryColdManualAuto: 'Batterie froide - Manuel/Auto',
      batteryColdManualOutput: 'Batterie froide - Sortie manuelle',
      batteryChangeoverManualAuto: 'Batterie changeover - Manuel/Auto',
      batteryChangeoverManualOutput: 'Batterie changeover - Sortie manuelle',
      changeoverManualAuto: 'Changeover - Manuel/Auto',
      changeoverOutput: 'Changeover - Sortie',
      damper: 'Volet',
      damperManualAuto: 'Volet - Manuel/Auto',
      mode: 'Mode (chaud / froid)',
      authorizedOff: 'Autorisation arrêt',
      onOffRead: 'Marche/Arrêt (lecture)',
      heatingBoiler: 'Chaudière',
      heatPump: 'Pompe à chaleur',
      distributionChangeover: 'Distribution changeover',
      distributionCold: 'Distribution froid',
      distributionCstHeating: 'Distribution constante chauffage',
      distributionCstChangeover: 'Distribution constante changeover',
      distributionCstCold: 'Distribution constante froid',
      constantSetPointWrite: 'Consigne constante (écriture)',
      shiftSetPoint: 'Décalage loi suiveuse',
      tempBottleSecondaryDeparture: 'Température bouteille départ secondaire',
      tempBottleSecondaryReturn: 'Température bouteille retour secondaire',
      tempBottlePrimaryDeparture: 'Température bouteille départ primaire',
      tempBottlePrimaryReturn: 'Température bouteille retour primaire',
      statePump: 'État pompe',
      manualAutoPump: 'Pompe - Manuel/Auto',
      flowSwitch: 'Contrôleur de débit',
      manualAuto: 'Manuel/Auto',
      status: 'Statut',
      deltaSetPointStart: 'Seuil de démarrage',
      minStopTime: 'Temps minimum d’arrêt',
      minWorkTime: 'Temps minimum de marche',
      aquastatWrite: 'Réglage aquastat (écriture)',
      temperatureDeparture: 'Température départ',
      temperatureReturn: 'Température retour',
      setPointManualOutput: 'Consigne en manuel (sortie)',
      setPointManualAuto: 'Consigne - Manuel/Auto',
      tempCircuitSetPointWrite: 'Température de consigne circuit (écriture)',
      tempCircuitSetPointWriteCold: 'Température de consigne circuit froid (écriture)',
      tempCircuitSetPointWriteHot: 'Température de consigne circuit chaud (écriture)',
      tExtStopPump: 'Température extérieure arrêt pompe',
      tExtStopPumpCold: 'Température extérieure arrêt pompe froid',
      tExtStopPumpHot: 'Température extérieure arrêt pompe chaud',
      modeHotCold: 'Mode chauffage/froid',
      pumpManualAuto: 'Pompe - Manuel/Auto (circuit)',
      v3vOutput: 'V3V - Lecture %',
      v3vManualOutput: 'V3V - Sortie manuelle %',
      v3vManualAuto: 'V3V - Manuel/Auto',
      tempChangeoverCircuitSetPoint: 'Température de consigne circuit changeover',
      tempChangeoverCircuitDeparture: 'Température départ circuit changeover',
      tempChangeoverCircuitReturn: 'Température retour circuit changeover',
      tempColdCircuitSetPoint: 'Température de consigne circuit froid',
      tempColdCircuitDeparture: 'Température départ circuit froid',
      tempColdCircuitReturn: 'Température retour circuit froid',
      // Points Y d'une loi d'eau. Les refs sans suffixe servent la loi d'un circuit chaud seul COMME
      // celle d'un circuit froid seul : leur libellé ne peut pas nommer une température extérieure.
      // Les refs Hot / Cold d'un changeover portent celle de leur régime (abscisses par défaut de la
      // base, cf. HEAT_CURVE_DEFAULT_ABSCISSAS_BY_MODE).
      y1waterLaw: 'Loi d’eau Y1',
      y2waterLaw: 'Loi d’eau Y2',
      y3waterLaw: 'Loi d’eau Y3',
      y4waterLaw: 'Loi d’eau Y4',
      y5waterLaw: 'Loi d’eau Y5',
      y6waterLaw: 'Loi d’eau Y6',
      y7waterLaw: 'Loi d’eau Y7',
      y8waterLaw: 'Loi d’eau Y8',
      y1waterLawHot: 'Loi d’eau chaud Y1 (-15°C)',
      y2waterLawHot: 'Loi d’eau chaud Y2 (-10°C)',
      y3waterLawHot: 'Loi d’eau chaud Y3 (-5°C)',
      y4waterLawHot: 'Loi d’eau chaud Y4 (0°C)',
      y5waterLawHot: 'Loi d’eau chaud Y5 (5°C)',
      y6waterLawHot: 'Loi d’eau chaud Y6 (10°C)',
      y7waterLawHot: 'Loi d’eau chaud Y7 (15°C)',
      y8waterLawHot: 'Loi d’eau chaud Y8 (20°C)',
      y1waterLawCold: 'Loi d’eau froid Y1 (20°C)',
      y2waterLawCold: 'Loi d’eau froid Y2 (22°C)',
      y3waterLawCold: 'Loi d’eau froid Y3 (24°C)',
      y4waterLawCold: 'Loi d’eau froid Y4 (26°C)',
      y5waterLawCold: 'Loi d’eau froid Y5 (28°C)',
      y6waterLawCold: 'Loi d’eau froid Y6 (30°C)',
      y7waterLawCold: 'Loi d’eau froid Y7 (32°C)',
      y8waterLawCold: 'Loi d’eau froid Y8 (34°C)',
      hotDepartureSecondary: 'Température départ ECS secondaire',
      temperatureSetPointDepartureWrite: 'Consigne départ ECS (écriture)',
      temperatureSetPointDepartureRead: 'Consigne départ ECS (lecture)',
      temperatureSetPointTankWrite: 'Consigne ballon (écriture)',
      temperatureSetPointTankRead: 'Consigne ballon (lecture)',
      defaultPumpLoop: 'Défaut pompe bouclage',
      statePumpLoop: 'État pompe bouclage',
      manualAutoPumpLoop: 'Pompe bouclage - Manuel/Auto',
      defaultPumpPrimary: 'Défaut pompe primaire',
      statePumpPrimary: 'État pompe primaire',
      manualAutoPumpPrimary: 'Pompe primaire - Manuel/Auto',
      defaultPumpSecondaryExch: 'Défaut pompe secondaire échangeur',
      statePumpSecondaryExch: 'État pompe secondaire échangeur',
      manualAutoPumpSecondaryExch: 'Pompe secondaire échangeur - Manuel/Auto',
      defaultPumpPrimaryExch: 'Défaut pompe primaire échangeur',
      statePumpPrimaryExch: 'État pompe primaire échangeur',
      manualAutoPumpPrimaryExch: 'Pompe primaire échangeur - Manuel/Auto',
      hotDeparturePrimaryExch: 'Température primaire ECS échangeur',
      hotDepartureSecondaryExch: 'Température secondaire ECS échangeur',
      v3vOutputExch: 'V3V échangeur - Lecture %',
      v3vManualAutoExch: 'V3V échangeur - Manuel/Auto',
      v3vManualOutputExch: 'V3V échangeur - Sortie manuelle %',
      temperatureSetPointExchRead: 'Consigne échangeur (lecture)',
      temperatureSetPointExchWrite: 'Consigne échangeur (écriture)',
      temperatureSecondaryDepartureExch: 'Température départ échangeur',
      onOff: 'Marche/Arrêt',
      modeHeatColdWrite: 'Mode chaud/froid (écriture)',
      modeHeatColdRead: 'Mode chaud/froid (lecture)',
      setPointReadOnly: 'Consigne température eau (lecture)',
      setPointWrite: 'Consigne température eau (écriture)',
      tempEvapIn: 'Température entrée évaporateur',
      tempEvapOut: 'Température sortie évaporateur',
      tempCondIn: 'Température entrée condenseur',
      tempCondOut: 'Température sortie condenseur',
      tempWaterIn: 'Température départ eau',
      tempWaterOut: 'Température retour eau',
      productionHeatPumpChiller: 'Production PAC / GF',
      tempProductionDeparture: 'Température départ production',
      tempProductionReturn: 'Température retour production',
      pressureWaterIn: 'Pression entrée eau',
      pressureWaterOut: 'Pression sortie eau',
      highPressure: 'Pression HP',
      lowPressure: 'Pression BP',
      defaultGeneral: 'Défaut général',
      defaultCodeLast: 'Code dernier défaut',
      defaultGroup: 'Défaut groupe',
      energyMeter: 'Comptage énergie',
      defrostStatus: 'Dégivrage en cours',
      compressorStatus: 'État compresseur',
      defaultFlowSwitch: 'Défaut contrôleur de débit',
      tvoc: 'TVOC',
      temperatureAntiFrost: 'Température antigel',
      temperatureCtaAirOut: 'Température air rejeté',
      temperatureCtaAirIn: 'Température air neuf',
      temperatureCtaAirAmbient: 'Température air ambiant',
      pressureCtaBlowing: 'Pression soufflage',
      pressureCtaRecovery: 'Pression reprise',
      flowCtaBlowing: 'Débit soufflage',
      flowCtaRecovery: 'Débit reprise',
      humidityBlowing: 'Humidité soufflage',
      humidityRecovery: 'Humidité reprise',
      humidityAmbient: 'Humidité ambiance',
      humiditySetPoint: 'Consigne humidité',
      humidificationAnalogOutput: 'Humidification 0-10V - Sortie',
      humidificationAnalogManualAuto: 'Humidification 0-10V - Manuel/Auto',
      humidificationAnalogManualOutput: 'Humidification 0-10V - Sortie manuelle',
      humidificationDigitalOutput: 'Humidification digitale - Sortie',
      humidificationDigitalManualAuto: 'Humidification digitale - Manuel/Auto',
      modeBlowingManualSetPoint: 'Mode soufflage - Consigne en manuel',
      modeRecoveryManualSetPoint: 'Mode reprise - Consigne en manuel',
      co2Output: 'Sortie CO2',
      batteryHotOutput: 'Batterie chaude - Sortie',
      batteryColdOutput: 'Batterie froide - Sortie',
      exchangerOutput: 'Échangeur - Sortie',
      exchangerManualAuto: 'Échangeur - Manuel/Auto',
      exchangerManualOutput: 'Échangeur - Sortie manuelle',
      electricBatteryOutput: 'Batterie électrique - Sortie',
      electricBatteryManualAuto: 'Batterie électrique - Manuel/Auto',
      electricBatteryManualOutput: 'Batterie électrique - Sortie manuelle',
      electricBatteryOutputStageController: 'Batterie électrique - Sortie en étage',
      electricBatteryStatusStage1: 'Batterie électrique - Statut étage 1',
      electricBatteryStatusStage2: 'Batterie électrique - Statut étage 2',
      electricBatteryStatusStage3: 'Batterie électrique - Statut étage 3',
      electricBatteryStatusStage4: 'Batterie électrique - Statut étage 4',
      damperRecovery: 'Registre air repris',
      damperRecoveryManualAuto: 'Registre air repris - Manuel/Auto',
      damperAirOut: 'Registre air rejeté',
      damperAirOutManualAuto: 'Registre air rejeté - Manuel/Auto',
      defaultVMC: 'Défaut VMC',
      forcedRunningGv: 'Marche forcée GV',
      forcedRunningPv: 'Marche forcée PV',
      forcedButtonSpeed1: 'Bouton marche forcée vitesse 1',
      forcedButtonSpeed2: 'Bouton marche forcée vitesse 2',
      forcedButtonSpeed3: 'Bouton marche forcée vitesse 3',
      medicalFluidDefault: 'Défaut fluides médicaux',
      reverseMedicalFluidDefault: 'Défaut inversé fluides médicaux',
      ackGroundAlarm: 'Acquitter alarme terrain',
      positionValve: 'État vanne',
      outdoorIlluminance: 'Luminosité extérieure',
      stateAdditionalExtractor: 'État extracteur additionnel',
      stateElec: 'État électrique',
    },
    addEquipment: 'Ajouter un équipement',
    location: 'Localisation',
    equipmentName: "Nom de l'équipement",
    editLocation: 'Modifier la localisation',
    editEquipment: "Modifier l'équipement",
    fold: 'Plier tout',
    unfold: 'Déplier tout',
    steps: {
      localisation: {
        description: 'Description et localisation',
        addNewFloor: 'Ajouter un étage',
        addNewSpace: 'Ajouter une pièce',
        equipmentName: "Nom de l'équipement",
        equipmentDescription: "Descriptif de l'équipement",
        equipmentNumber: "Numéro de l'équipement",
        spacePosition: 'Position dans la pièce',
        addActions: 'Ajouter/Modifier des actions à cet équipement',
        addPhoto: 'Ajouter une photo',
      },
      devices: {
        description: 'Actions à réaliser',
      },
    },
  },
  dashboard: {
    topBar: {
      search: {
        placeholder: 'Tous les sites',
        noResult: 'Aucun site ne correspond.',
        cannotFindSites: 'Une erreur est survenue lors du chargement des sites.',
      },
    },
    sidebar: {
      site: 'Site',
      patrimony: 'Patrimoine',
      mySites: 'Mes sites',
      myActions: 'Mes actions',
      users: 'Utilisateurs',
      logout: 'Se déconnecter',
      general: 'Général',
      information: 'Informations',
      equipment: 'Équipements',
      actionsAssignation: 'Assignation des actions',
      actionsDone: 'Actions terminées',
      actions: 'Actions',
      nonConformity: 'Non-conformités',
      monitoring: 'Pilotage',
      remoteMonitoring: 'Télésurveillance',
      alerts: 'Alertes',
      devices: 'Capteurs',
      reports: 'Rapports',
      dashboard: 'Tableau de bord',
      usage: 'Mes consommations',
      evolution: 'Évolution',
      meterAnalysis: 'Analyse par compteur',
      production: 'Ma production',
      photovoltaic: 'Photovoltaïque',
      subMeterAnalysis: 'Analyse par sous-compteur',
      supervision: 'Supervision',
      heating: 'Chauffage et ECS',
      airQuality: 'Qualité de l’air',
      airHandlingUnit: 'CTA',
      vmc: 'VMC',
      locationAnalysis: 'Analyse par localisation',
      settings: 'Paramètres',
      tutorials: 'Tutoriels',
      logbook: 'Main courante',
      setPointScheduler: 'Calendrier consignes',
      lighting: 'Éclairage',
      scheduler: 'Calendrier',
      electricalFaults: 'Défauts électriques',
      medicalFluids: 'Fluides médicaux',
      planView: 'Vue plan',
      alarms: 'Alertes et défauts',
      alarmsOngoing: 'Alertes en cours',
      defaultsOngoing: 'Défauts en cours',
      alertsConfiguration: 'Configuration des alertes',
      recommendations: 'Recommandations',
      drift: 'Dérives',
      driftEquipments: 'Équipements',
      driftSettings: 'Réglages en cours',
      driftEquipmentsTitle: 'Dérives équipements',
      driftSettingsTitle: 'Dérives réglages en cours',
      journal: 'Journal',
      temperatureByZone: 'Température zone',
      analysis: 'Analyse',
      modeChoice: 'Choix du mode',
      boilerRoom: 'Chaufferie',
      technicalView: 'Vue technique',
      heatPump: 'PAC / GF',
    },
    module: {
      chooseModule: 'Choisir un module',
      chooseModuleDescription: 'Sélectionnez le module que vous souhaitez utiliser.',
      changeModule: 'Changer de module',
      more: 'Plus',
      energyMonitoring: 'Énergie',
      technicalExploitation: 'GTB',
    },
  },
  underConstruction: {
    title: 'Page en construction',
    description: 'Cette page arrive prochainement.',
    beforeNextHeatingSeason: 'Cette page arrivera avant votre prochaine période de chauffe.',
    beforeEndOfYear: 'Cette page arrivera avant la fin de l’année.',
  },
  filter: {
    datePicker: {
      placeholder: 'Choisir une date',
      last3hours: '3 dernières heures',
      last24hours: '24 dernières heures',
      last1days: '24 dernières heures',
      last30days: '30 derniers jours',
      last7days: '7 derniers jours',
      last90days: '3 derniers mois',
      last365days: 'Dernière année',
      last12months: '12 derniers mois',
      selectRangePlaceholder: 'Choisir une période',
    },
    multiselectLocalisations: {
      expandAll: 'Déplier tout',
      retractAll: 'Plier tout',
      selectAll: 'Sélectionner',
      unSelectAll: 'Désélectionner',
      title: 'Localisation',
    },
    multiselectSubType: {
      title: 'Type de point',
    },
    toggle: {
      ecs: 'ECS',
      ef: 'EF',
    },
  },

  attachments: 'Pièces jointes',
  addFile: 'Ajouter un fichier',
  fileName: 'Nom du fichier',
  fileNameTooLong: 'Le nom du fichier dépasse {{max}} caractères : renommez-le avant de l’ajouter',
  fileDate: 'Date du fichier',
  undefinedFloor: 'Étage non précisé',
  undefinedBuilding: 'Bâtiment',
  devicesAndMonitoring: 'Capteurs et surveillance',
  isEquipmentMonitoredByDevice: "Est-ce qu'un capteur surveille cet équipement ?",
  ifYesPleaseSelectTheDevice: 'Si oui, préciser le nom du capteur',
  selectDevice: 'Sélectionner un capteur',
  selectEquipment: 'Sélectionner un équipement',
  temperaturePosition: 'Où réalisez-vous le relevé de température ?',
  hotWater: 'Eau chaude',
  coldWater: 'Eau froide',
  mixedWater: 'Eau mitigée',
  thisEquipmentCannotHaveDevice: 'Cet équipement ne peut pas avoir de capteur',
  typeOfWater: "Type d'eau",
  delete: 'Supprimer',
  deletingTheEquipment: 'Suppression de l’équipement',
  youAreAboutToDeleteThisEquipment: "Vous êtes sur le point de supprimer l'équipement : <strong>{{equipmentName}}</strong>",
  deletingTheLocation: 'Suppression de la localisation',
  locationNameAlreadyUsed: 'Ce nom de localisation est déjà utilisé',
  youAreAboutToDeleteThisLocation:
    'Vous êtes sur le point de supprimer la localisation : <strong>{{type}} - {{locationName}}</strong> ainsi que les niveaux en dessous rattachés',
  locationDeletionImposibleBecauseEquipment:
    'Suppression de la localisation impossible car un ou plusieurs équipements sont rattachés à cette localisation ou à un de ses niveaux en dessous',
  noDevicesAvailable:
    "Soit vous n'avez pas de capteur OuiSense soit tous vos capteurs sont déjà assignés à un équipement (modifier vos équipements pour en rendre disponible).",
  next: 'Suivant',
  noFiles: 'Aucun fichier',
  actionsToBeDone: 'Actions à réaliser',
  actionsToSelect: 'Actions à sélectionner',
  todayActions: 'Actions configurées à date',
  actions: 'Actions',
  actionCategories: 'Types d’actions',
  procedure: 'Procédure',
  frequency: 'Fréquence',
  nextSchedule: 'Prochaine échéance',
  activated: 'Activée',
  selected: 'Sélectionnée',
  moreActionsHelpText:
    'Si vous souhaitez ajouter des actions dans la librairie OuiSense pour cet équipement, n’hésitez pas à nous contacter (contact@ouisense.io).',
  conformIfCondition: 'Conforme si',
  notConformIfCondition: 'Non conforme si',
  duringTime: 'pendant',
  duringTimeDay_one: 'pendant {{count}} jour',
  duringTimeDay_other: 'pendant {{count}} jours',
  duringTimeMinute_one: 'pendant {{count}} minute',
  duringTimeMinute_other: 'pendant {{count}} minutes',
  duringTimeHour_one: 'pendant {{count}} heure',
  duringTimeHour_other: 'pendant {{count}} heures',
  value: 'Valeur',
  time: 'Temps',
  minutes_one: 'minute',
  minutes_other: 'minutes',
  hours_one: 'heure',
  hours_other: 'heures',
  days_one: 'jour',
  days_other: 'jours',
  conditionIsInvalid: 'Condition invalide',
  valuesMustBeDifferent: 'Les valeurs doivent être différentes',
  pastDate: 'Date est dépassée',
  procedureForAction: "Procédure pour réaliser l'action",
  procedureIncident: "Procédure en cas d'incident",
  theEquipmentWillNotHavePreventiveActions: "L’équipement n'aura pas d’actions préventives",
  theEquipmentWillNotHaveSamplingActions: "L’équipement n'aura pas de prélèvements",
  invalidDate: 'Date invalide',
  siteEditSuccess: 'Site modifié avec succès',
  siteEditError: 'Erreur lors de la modification du site',
  locationAdded: 'Localisation ajoutée avec succès',
  locationEdited: 'Localisation modifiée avec succès',
  procedureEdited: 'Procédure modifiée avec succès',
  saving: 'Enregistrement en cours',
  equipmentAdded: 'Équipement ajouté avec succès',
  actionsConfigured: 'Actions configurées avec succès',
  addSampling: 'Ajouter un prélèvement',
  samplingType: 'Type de prélèvement (Tous)',
  orAddSampling: 'Ou ajouter un point de prélèvement',
  addUser: 'Ajouter un utilisateur',
  firstname: 'Prénom',
  lastname: 'Nom',
  email: 'Email',
  phone: 'Téléphone',
  resetPassword: 'Mot de passe oublié',
  verificationCode: 'Code de vérification',
  useYourCodeByEmail: 'Utilisez votre code reçu par email',
  resetPasswordSuccess: 'Votre mot de passe a été réinitialisé avec succès',
  backToLogin: 'Retourner à la connexion',
  rateLimitError: 'Trop de tentatives de connexion. Veuillez réessayer dans quelques minutes.',
  cannotDeleteEquipmentWithDevices: 'Vous ne pouvez pas supprimer un équipement ayant un capteur assigné. Vous devez désassigner le capteur au préalable.',
  editUser: 'Modifier un utilisateur',
  nonAvailable: 'Non renseigné',
  selectActionsToAssign: 'Sélectionner les actions à assigner',
  nonAssignedDescription:
    'Les actions sans responsable ("$t(nonAssignedAction)") n\'apparaitront dans aucune liste d\'action (et seront donc par conséquent non réalisées).',
  nonAssignedAction: 'À définir',
  assignSelectedActions: 'Assigner les actions sélectionnées aux responsables',
  responsible: 'Responsable',
  selectResponsible: 'Sélectionner les responsables',
  internal: 'Interne',
  external: 'Externe',
  unset: 'Retirer',
  firstResponsible: '1er responsable',
  firstResponsibleDescription: "seules personnes pouvant voir et valider les actions sur l'application",
  secondResponsible: '2ème responsables',
  secondResponsibleDescription: "personnes pouvant voir et valider les actions qui n'ont pas été réalisé dans les temps par les 1er responsables",
  assign: 'Assigner',
  cannotFetchUsers: 'Impossible de récupérer les utilisateurs',
  warning: 'Attention',
  emptyAssignationWarning:
    "Vous n'avez sélectionné aucun responsable, si vous cliquer sur Assigner, les actions sélectionnées seront mises à jour et plus personne ne verra ces actions",
  noResponsibleAssignationWarning:
    "Vous n'avez sélectionné aucun premier responsable, si vous cliquer sur Assigner , les actions sélectionnées seront mises à jour et plus personne ne verra ces actions dans les temps",
  understand: "J'ai compris",
  actionToDo_one: 'Action à faire : {{count}}',
  actionToDo_other: 'Actions à faire : {{count}}',
  actionLate: 'dont {{count}} en retard',
  actionToDoAt: 'À faire le {{at}}',
  toLate: 'En retard',
  toDo: 'À faire',
  done: 'Fait',
  status: 'Statut',
  noActions: 'Aucune action',
  actionDoneAt: 'Terminée le {{at}}',
  actionStatusDone: 'Actions terminées',
  actionStatusOngoing: 'Actions à faire',
  actionStatusLate: 'Actions en retard',
  actionStatusAll: 'Toutes les actions',
  cannotFetchActionReading: "Impossible de récupérer les informations de l'action",
  action: '<strong>Action</strong> : $t(equipment.actionCategories.{{ category }})',
  condition: 'Condition',
  typeValue: 'Indiquer la valeur',
  noValue: 'Pas de valeur',
  conform: 'Conforme',
  nonConform: 'Pas conforme',
  comment: 'Commentaire',
  dateComment: 'DD/MM/YYYY [à] HH:mm',
  incidentToReport: 'Incident à reporter',
  cannotFetchActionReadingFile: "Impossible de récupérer le fichier de l'action",
  equipmentImage: "Image de l'équipement",
  noEquipmentImage: 'Aucune image',
  willReplaceExistingFile: 'Le fichier existant sera remplacé.',
  back: 'Retour',
  preventive: 'Préventive',
  samplings: 'Prélèvement',
  devices: 'Capteurs',
  deletingTheSite: "Suppression d'un site",
  youAreAboutToDeleteThisSite: 'Vous êtes sur le point de supprimer le site : <strong>{{siteName}}</strong>',
  areYouSureYouWantToDeleteThisSite: 'Afin de confirmer la <strong>suppression du site</strong>, veuillez confirmer le nom du site dans le champs ci-dessous',
  warningDeletionSite:
    'La suppresion du site <strong>{{siteName}}</strong> va entraîner la suppression de tous les équipements, localisations et actions associées',
  nameOfTheSiteToRemove: 'Nom du site à supprimer',
  canNotDeleteSiteWithDevices:
    'Suppression du site impossible car un ou plusieurs capteurs sont sont rattachés à ce site, veuillez contacter un administrateur (contact@ouisense.io)',
  atLeastOneBuildingRequired: "Au moins un bâtiment est nécessaire lorsqu'un site détient plusieurs bâtiments.",
  noBuildingAllowed: 'Vous avez spécifié un site sans bâtiment, mais des bâtiments existent pour ce site, veuillez les supprimer au préalable.',
  actionsDoneDetails: 'Détail des actions <u>{{type}}</u> terminées',
  doneAt: 'Fait le',
  notDone: 'Non réalisé',
  details: 'Détail',
  nonApplicable: 'n.a.',
  conformity: 'Conforme',
  nextScheduleAt: 'Échéance le',
  doneStatus: 'Fait dans les temps',
  doneLateStatus: 'Fait en retard',
  notDoneStatus: 'Non réalisé',
  ongoingStatus: 'En cours',
  ongoingLateStatus: 'En retard',
  conformityNotMatchConditionError: `La conformité choisie ainsi que le résulat donné en entrée ne sont pas cohérents`,
  actionsAll: 'Actions (toutes)',
  actionsSelected: 'actions sélectionnées',
  actionSelect: 'Sélectionner une action',
  cannotLoadAddSample: 'Impossible de charger le référentiel',
  cannotLoadSamples: 'Une erreur est survenue au chargement des prélèvements.',
  removeFile: 'Supprimer le fichier',
  removingFile: 'Suppression du fichier',
  removeFileDescription: 'Vous êtes sur le point de supprimer le fichier',
  fileDoesNotExists: "Le fichier n'existe pas",
  fileDeleted: 'Fichier supprimé',
  samplingConformity: 'Conformité des prélèvements',
  samplingDone: 'Prélèvements réalisés',
  temperatureConformity: 'Conformité des relevés de température',
  temperatureDone: 'Relevés de température réalisés',
  purgeDone: 'Purges réalisées',
  actionsConformity: 'Conformité des actions',
  actionsDone: 'Actions réalisées',
  selectFilter: {
    status: '$t(status) ($t(common.form.all))',
    building: '$t(common.building) ($t(common.form.all))',
    floor: '$t(common.floor) ($t(common.form.all))',
    space: '$t(common.space) ($t(common.form.all))',
    category: '$t(equipment.category) ($t(common.form.all, { "context": "female" }))',
    action: '$t(equipment.action) ($t(common.form.all, { "context" : "female" }))',
    responsible: 'Responsable ($t(common.form.all))',
    toDefinedResponsible: 'Responsable à définir',
    conformity: 'Conformité ($t(common.form.all))',
    type: 'Type ($t(common.form.all))',
    equipment: '$t(common.equipment) ($t(common.form.all))',
    devices: '$t(devices) ($t(common.form.all))',
    users: '$t(common.users) ($t(common.form.all))',
    subType: '$t(subType) ($t(common.form.all))',
    frequency: '$t(frequency) ($t(common.form.all_female))',
    site: '$t(sites) ($t(common.form.all))',
    severity: '$t(severity) ($t(common.form.all))',
    energy: '$t(energy) ($t(common.form.all))',
    group: '$t(group) ($t(common.form.all))',
    date: '$t(date) ($t(common.form.all_female))',
    comfort: '$t(comfort) ($t(common.form.all))',
  },
  atLeastValueOrConformity: 'Au moins une valeur ou une conformité doit être renseignée',
  manual: 'manuelles',
  auto: 'automatiques',
  conformityTooltip: "Pour les points d'usage les relevés de température indiqués sont ceux enregistrés au moment du tirage (équivalent aux relevés manuels)",
  deadline: 'Échéance',
  firstResponsibles: 'Premiers responsables',
  secondaryResponsibles: 'Seconds responsables',
  actionDoneBy: 'Action réalisée par',
  actionDoneWithSensors: 'Action réalisée par capteur',
  start: 'Début',
  end: 'Fin',
  darkGreen: 'vert foncé',
  lightGreen: 'vert pâle',
  orange: 'orange',
  red: 'rouge',
  ecs: 'ECS',
  ef: 'EF',
  months: ['Jan', 'Fev', 'Mar', 'Avr', 'Mai', 'Juin', 'Juil', 'Août', 'Sep', 'Oct', 'Nov', 'Déc'],
  weekdays: ['Dim', 'Lun', 'Mar', 'Mer', 'Jeu', 'Ven', 'Sam'],
  weekdaysFull: ['Dimanche', 'Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Samedi'],
  resetZoom: 'Réinitialiser le zoom',
  floorPlanZoomHint: 'Ctrl + molette ou pincement du trackpad pour zoomer',
  exitEditMode: 'Quitter le mode édition',
  internalSiteWorkers: 'Intervenants internes',
  responsiblesContact: 'Contact des personnes responsables',
  team: 'Équipe',
  addWorker: 'Ajouter un intervenant',
  legioConsulting: "Bureau d'étude sanitaire",
  companyName: "Nom de l'entreprise",
  myContracts: 'Mes contrats',
  wrongFileType: "Le type de fichier n'est pas valide",
  dropFiles: 'Ajouter des fichiers en les déposant ici ou cliquer pour les sélectionner',
  dropFile: 'Ajouter un fichier en le déposant ici ou cliquer pour le sélectionner',
  lab1: "Laboratoire d'analyse",
  lab2: "Second laboratoire d'analyse",
  lab3: "Troisième laboratoire d'analyse",
  maintenance: 'Maintenance',
  waterTreatment: "Traitement de l'eau",
  invalidEmail: 'Adresse email invalide',
  invalidPhone: 'Numéro de téléphone invalide',
  installationGeneralDescription: "Description générale de l'installation",
  constructionYear: "Année de construction des réseaux d'eau",
  lastModifYear: 'Année de dernière modification',
  siteType: 'Type de site',
  occupantNumber: "Nombre d'occupants",
  occupantRisk: 'Occupants à risque',
  siteUsage: 'Utilisation du site',
  riskEquipmentDescription: 'Description des équipements à risque formant des aérosols',
  riskEquipmentDescriptionTooltip: 'Distinguer équipement individuel et collectif',
  riskSpecificDescription: 'Identification de bras morts et / ou niches bactériennes',
  siteWaterSource: 'Alimentation en eau du site',
  publicDistribution: 'Distribution publique',
  privateRessource: 'Ressource privée',
  waterSourcePrivateDetails: 'Si ressource privée indiquer',
  waterSourcePrivateExamples: 'Puits, forage, etc.',
  distributedWaterInfo: "Distribution publique : Fiche d'information annuelle de qualité de l'eau distribuée",
  prefectoralAuthorization: 'Ressource privée : Autorisation préféctorale',
  coldWaterNetwork: "Réseau d'eau froide (EF)",
  coldWaterMains: 'Arrivée et stockage EF',
  coldWaterNetworkEquipments: 'Réseau EF',
  coldWaterNetworkEquipmentsTooltip: 'Indiquer matériaux, calorifugeage (intégral, partiel, inexistant), autres',
  waterMainConnector: 'Collecteurs principaux',
  waterColumn: 'Colonnes',
  waterConnector: 'Piquages',
  coldWaterBackflow: "Dispositifs de protection contre les retours d'eau (clapet, disconnecteur) présents à l'amont de :",
  hotWaterNetwork: "Réseau d'eau chaude sanitaire (ECS)",
  hotWaterMains: 'Production et stockage ECS',
  hotWaterMainsTooltip:
    "Indiquer accumulation / semi instantanée / instantanée, nombre de ballons, capacité, disposition (série / parallèle), avec purge d'air ou non, avec vanne de vidange ou non, avec accès ou non, autres équipements (échangeur)",
  hotWaterNetworkEquipments: 'Réseau ECS',
  hotWaterNetworkEquipmentsTooltip: 'Indiquer matériaux, bouclage (et nombre de boucles), calorifugeage, organe de réglage, cordon chauffant, autres',
  hotWaterUsageDetails: 'Points terminaux ECS',
  hotWaterUsageDetailsTooltip: "Indiquer mitigeur en aval de la production / mitigeur à chaque point d'usage / Autres",
  schematicUpToDate: 'Est-ce que les plans enregistrés sont à jour ?',
  myInstallationSchematics: "Mes plans d'installation",
  installationSchematics: 'Plan des installations',
  otherInstallationFiles: "Autres documents liés à l'installation",
  myInstallationAudits: 'Mes diagnostics / audits',
  myInstallationOtherDocuments: 'Mes autres documents',
  invalidYear: "L'année n'est pas valide",
  incident: 'Incident',
  date: 'Date',
  nonConformity: {
    status: {
      notDone: 'Non vu',
      todo: 'En cours',
      done: 'Clôturé',
    },
    type: {
      notDone: 'Non réalisé',
      noConformity: 'Non Conforme',
      incident: 'Remontées terrain',
    },
    bulk: {
      selectAll: 'Tout sélectionner',
      selectRow: 'Sélectionner la ligne',
      updateSelected: 'Mettre à jour ({{count}})',
      dialogTitle: 'Mise à jour groupée',
      dialogDescription: '{{count}} non-conformités sélectionnées',
      success: 'Non-conformités mises à jour',
      error: 'Erreur lors de la mise à jour groupée',
    },
  },
  workSupervision: 'Suivi des travaux',
  workStatus: {
    ongoing: 'En cours',
    todo: 'À faire',
    done: 'Fait',
  },
  works: 'Travaux',
  workSheet: 'Fiche travaux',
  newWorkSheet: 'Nouvelle fiche travaux',
  workName: 'Libellé',
  planningAndBudget: 'Planning et budget',
  budget: 'Budget',
  responsibleContact: 'Nom des responsables',
  responsibleInfo: 'Coordonnées des responsables',
  workCreateSuccess: 'Travaux créés avec succès',
  workCreateError: 'Erreur lors de la création des travaux',
  workEditSuccess: 'Travaux modifiés avec succès',
  workEditError: 'Erreur lors de la modification des travaux',
  incidentSheet: "Fiche d'incident",
  incidentDescription: "Description de l'incident",
  incidentStatus: "Statut de l'incident",
  incidentResolution: "Résolution de l'incident",
  noComment: 'Pas de commentaire',
  noIncident: "Pas d'incident",
  noResp: 'Pas de responsable',
  incidentAttachment: "Pièce jointe liée à l'incident",
  incidentEditSuccess: 'Incident édité avec succès',
  incidentEditError: "Erreur lors de l'édition de l'incident",
  incidentResolutionAndActions: "Causes de l'incident et actions menées",
  responsibles: 'Responsables',
  temperatureEvolution: 'Évolution des températures',
  waterFlowEvolution: "Évolution de la vitesse d'eau",
  humidityEvolution: "Évolution de l'humidité",
  chlorineEvolution: 'Évolution du chlore',
  phEvolution: 'Évolution du pH',
  chlorine: 'Chlore',
  ph: 'pH',
  noCondition: 'Pas de condition',
  unprocessedAlerts: 'Alertes non traitées',
  totalAlerts: 'alertes au total',
  temperature: 'Température',
  airFlow: "Débit d'air",
  illuminance: 'Luminosité',
  power: 'Puissance',
  flowRate: 'Débit',
  volume: 'Volume',
  volumeConsumption: 'Volume circulé',
  energyConsumption: 'Énergie consommée',
  temperatureBlowing: 'Température soufflage',
  temperatureRecovery: 'Température reprise',
  fullscreen: 'Plein écran',
  process: 'Traiter',
  device: 'Capteur',
  confirmAlertQuestion: "Confirmez-vous le traitement de l'alerte ?",
  disableAlertPreference: 'Je souhaite désactiver toutes les alertes de ce capteur pendant',
  disableAlert: {
    oneDay: '1 jour',
    threeDays: '3 jours',
    oneWeek: '1 semaine',
    twoWeeks: '2 semaines',
    oneMonth: '1 mois',
  },
  predefinedComment: 'Motif prédéfini',
  alertPredefinedComment: {
    powerOutage: 'Panne de courant ou enceinte débranchée',
    sensorIssue: 'Problème sur la sonde (déconnectée, fil coupé, etc.)',
    unauthorizedHvacStop: 'Arrêt ou modification non autorisée de la climatisation',
    hvacMaintenance: 'Maintenance sur la climatisation',
    doorLeftOpen: 'Porte restée ouverte',
    temperatureAdjustment: "En cours de réglage de température de l'enceinte",
    equipmentFailure: "Panne de l'équipement",
    unauthorizedSettingChange: "Modification du réglage de l'enceinte non autorisée",
  },
  charts: 'Courbes',
  alerts: 'Alertes',
  pleaseSelectDevices: 'Veuillez sélectionner au moins un capteur (maximum 5)',
  hourlyAverageNotice: {
    title: 'Données moyennées à l’heure.',
    description: 'La période dépasse 7 jours : chaque point représente la moyenne d’une heure.',
    rangeHint: 'Sélectionnez 7 jours ou moins pour afficher toutes les mesures.',
  },
  pleaseSelectEquipments: 'Veuillez sélectionner au moins un équipement',
  pleaseSelectSites: 'Veuillez sélectionner au moins un site',
  actionEditSuccess: 'Action modifiée avec succès',
  actionEditError: "Erreur lors de la modification de l'action",
  devicesSelected: 'capteurs sélectionnés',
  slot: 'Plage',
  addSlot: 'Ajouter une plage',
  editSelectedDays: 'Modifier les jours sélectionnés',
  addAlert: 'Ajouter une alerte',
  alertLabel: {
    temperatureAlert: 'Température',
    waterMovementAlert: 'Mouvement',
    humidityAlert: 'Humidité',
    chlorineAlert: 'Chlore (ppm)',
    phAlert: 'pH',
    co2Alert: 'CO2',
    tvocAlert: 'TVOC',
  },
  alertType: {
    temperature: 'Température',
    frequenceCounter: 'Fréquence de comptage',
    clickCounter: "Compteur d'événements",
    waterMovement: "Mouvement d'eau",
    peopleFlow: 'Flux de personnes',
    touch: 'Contact',
    usage: 'Utilisation',
    waterMovementTemperature: "Mouvement d'eau et température",
    chlorine: 'Chlore',
    ph: 'pH',
  },
  alertSeverity: {
    critical: 'Élevée',
    error: 'Moyenne',
    warning: 'Faible',
  },
  notificationsTo: 'Notifications vers',
  alertDisabled: 'Désactivée',
  alertEnabled: 'Activée',
  alertCustom: 'Activée (personnalisée)',
  alertRemoveWarning: "Êtes-vous sûr de vouloir supprimer l'alerte",
  severity: 'Sévérité',
  conditions: 'Conditions',
  greaterThan: 'Supérieure à',
  lessThan: 'Inférieure à',
  and: 'et',
  or: 'ou',
  minutes: 'minutes',
  hours: 'heures',
  days: 'jours',
  supervisedEquipments: 'Équipements à surveiller',
  notifications: 'Notifications',
  sms: 'SMS',
  call: 'Appel',
  noUser: "Pas d'utilisateur",
  never: 'Jamais',
  anytime: 'Tout le temps',
  custom: 'Personnalisé',
  usersSelected: 'utilisateurs sélectionnés',
  alertParamType: {
    temperatureAlert: 'Température',
    frequenceCounterAlert: 'Fréquence de comptage',
    clickCounterAlert: "Compteur d'événements",
    waterMovementAlert: "Mouvement d'eau",
    waterFlowAlert: "Vitesse d'eau",
    humidityAlert: 'Humidité',
    batteryAlert: 'Batterie faible',
    defaultPumpAlert: 'Défaut pompe',
    defaultComAlert: 'Défaut communication',
    defaultManualAlert: 'Défaut manuel',
    defaultCriticalAlert: 'Défaut critique',
    otherDefaultAlert: 'Autre défaut',
    deviceDisconnectedAlert: 'Capteur déconnecté',
    defaultCtaAlert: 'Défaut CTA',
    defaultElecAlert: 'Défaut électrique',
    defaultChillerAlert: 'Défaut groupe froid',
    defaultFlowAlert: 'Défaut débit',
    defaultGeneralAlert: 'Défaut général',
    defaultVMCAlert: 'Défaut VMC',
    medicalFluidAlert: 'Défaut fluides médicaux',
    defaultReverseCtaAlert: 'Défaut CTA',
    chlorineAlert: 'Alerte chlore',
    phAlert: 'Alerte pH',
    co2Alert: 'CO2',
    tvocAlert: 'TVOC',
  },
  sameAlertMinutes: 'Arrêter les notifications sans retour à la normale pendant',
  alertCreateSuccess: 'Alerte créée avec succès',
  alertCreateError: "Erreur lors de la création de l'alerte",
  deleteAlert: "Suppression de l'alerte",
  alertDeleteSuccess: "L'alerte a été supprimée avec succès",
  alertDeleteError: "Erreur lors de la suppression de l'alerte",
  editAlert: "Modifier l'alerte",
  alertEditSuccess: "L'alerte a été modifiée avec succès",
  alertEditError: "Erreur lors de la modification de l'alerte",
  alertsAll: 'Alertes (toutes)',
  alertsSelected: 'alertes sélectionnées',
  alertsSelect: 'Sélectionner une alerte',
  addComment: 'Ajouter un commentaire',
  send: 'Envoyer',
  toComment: 'Commenter',
  alertAcknowledgeSuccess: 'Alerte traitée avec succès',
  alertAcknowledgeError: "Erreur lors du traitement de l'alerte",
  comments: 'Commentaires',
  assignUserSuccess: 'Responsables assignés avec succès',
  assignUserError: "Une erreur est survenue lors de l'assignation des responsables",
  addCommentSuccess: 'Commentaire ajouté avec succès',
  addCommentError: "Erreur lors de l'ajout du commentaire",
  pagination: {
    displayed: 'Affichés',
    of: 'sur',
    results: 'résultats',
    resultsPerPage: 'Résultats par page',
    page: 'Page',
    goToFirstPage: 'Aller à la première page',
    goToPreviousPage: 'Aller à la page précédente',
    goToNextPage: 'Aller à la page suivante',
    goToLastPage: 'Aller à la dernière page',
  },
  logout: 'Déconnexion',
  logoutMessage: 'Souhaitez-vous vraiment vous déconnecter ?',
  all: {
    masc: 'Tous',
    fem: 'Toutes',
  },
  validateActionSuccess: 'Action validée avec succès',
  validateActionError: "Erreur lors de la validation de l'action",
  waterTreatmentDescription: 'Descriptif des traitements, nom des produits, ECS ou EF',
  softening: 'Adoucissement',
  corrosion: 'Anti corrosion / Filmogène',
  disinfection: 'Désinfection (préciser continue ou discontinue)',
  signal: 'Signal',
  deviceFamily: {
    touch: 'Toucher',
    water: 'Eau',
    proximity: 'Proximité',
    temperature: 'Température',
    airQuality: "Qualité de l'air",
    pir: 'Présence',
    qrCode: 'QR code',
    gateway: 'Borne',
    humidity: 'Humidité',
    electricity: 'Électricité',
    photovoltaic: 'Photovoltaïque',
    fuel: 'Carburant',
    gas: 'Gaz',
    thermal: 'Thermique',
    co2: 'CO2',
    tvoc: 'TVOC',
    chlorine: 'Chlore',
    ph: 'pH',
    default: 'Défaut',
    electricity_other: 'Électricité',
    gas_heating: 'Chauffage (gaz)',
    gas_ecs: 'ECS (gaz)',
    gas_other: 'Gaz',
    thermal_other: 'Thermique',
    thermal_ecs: 'ECS (thermique)',
    thermal_heating: 'Chauffage (thermique)',
    water_other: 'Eau',
  },
  description: 'Description',
  battery: 'Batterie',
  lastReading: 'Dernier relevé',
  subType: 'Sous-type',
  deviceSubType: {
    usageHot: "Point d'usage eau chaude",
    usageCold: "Point d'usage eau froide",
    usageBlended: "Point d'usage eau mitigée",
    supplyHot: 'Départ ECS',
    supplyCold: 'Départ EF',
    flowHot: 'Distribution ECS',
    flowCold: 'Distribution EF',
    boiler: 'Chaudière',
    otherHot: 'Autre eau chaude',
    otherCold: 'Autre eau froide',
    none: 'Aucun',
    butterEggCheese: 'Beurre, oeuf, fromage',
    carriageReturn: 'Retour chariot',
    carriageStart: 'Début chariot',
    dataCenter: 'Centre de données',
    defrosting: 'Décongélation',
    doorMain: 'Porte principale',
    doorWc: 'Porte WC',
    finishedProduct: 'Produit fini',
    food: 'Aliment',
    fruitVegetables: 'Fruit, légume',
    meat: 'Viande',
    medicineAmbient: 'Médicament ambiant',
    medicineCold: 'Médicament froid',
    morgue: 'Morgue',
    needClean: 'Besoin de nettoyage',
    needPaper: 'Besoin de papier',
    negative: 'Négatif',
    packaging: 'Emballage',
    preparation: 'Préparation',
    satisfied: 'Satisfait',
    waste: 'Déchet',
    coldPositive: 'Froid positif',
    coldNegative: 'Froid négatif',
    ambient: 'Ambiant',
    gasMeterMain: 'Compteur de gaz',
    gasMeterSub: 'Sous-Compteur de gaz',
    electricityMeterSub: 'Sous-Compteur d’électricité',
    electricityMeterMain: 'Compteur d’électricité',
    photovoltaicMeterMain: 'Compteur de production photovoltaïque',
    waterMeterMain: 'Compteur d’eau',
    waterMeterSub: 'Sous-Compteur d’eau',
    thermalMeterMain: 'Compteur thermique',
    thermalMeterSub: 'Sous-Compteur thermique',
    fuelMeterMain: 'Compteur de fioul',
    fuelMeterSub: 'Sous-Compteur de fioul',
    defaultBattery: 'Défaut batterie',
    electricityPowerAvg: 'Puissance électrique moyenne',
    electricityPowerMax: 'Puissance électrique maximale',
    electricityPowerSubscription: 'Souscription de puissance électrique',
    heatingCircuit: 'Circuit de chauffage',
    modeBlowingNumber: 'Nombre de mode soufflage',
    modeBlowingString: 'Mode soufflage',
    setPoint: 'Consigne',
    temperatureOutside: 'Température extérieure',
    temperatureRoom: 'Température ambiante',
  },
  deviceConfiguration: "Configuration de l'appareil",
  uncertainty: 'Incertitude',
  tempOffset: 'Décalage de température',
  editDeviceSuccess: 'Configuration du capteur modifiée avec succès',
  editDeviceError: 'Erreur lors de la modification de la configuration du capteur',
  actionValidation: "Validation de l'action",
  reset: 'Réinitialiser',
  sentTo: 'Envoyés à',
  addReportConfiguration: 'Ajouter une configuration',
  editReportConfiguration: 'Modifier une configuration',
  test: 'Tester',
  weekly: 'Hebdomadaire',
  fortnightly: 'Bimensuel',
  monthly: 'Mensuel',
  download: 'Télécharger',
  preview: 'Prévisualiser',
  downloadReportSample: 'Si vous souhaitez tester cette configuration, veuillez sélectionner une plage de dates afin de télécharger une prévisualisation',
  searchBy: 'Rechercher par',
  includeAlerts: 'Inclure le détail des alertes',
  includeDevices: 'Inclure le détail des capteurs (graph)',
  includeActions: 'Inclure le détail des actions',
  usersNotified: 'Utilisateurs notifiés',
  selectUsers: 'Sélectionner les utilisateurs',
  reportAddSuccess: 'Rapport créé avec succès',
  reportAddError: 'Erreur lors de la création du rapport',
  reportConfigurationEditSuccess: 'Configuration du rapport modifiée avec succès',
  reportConfigurationEditError: 'Erreur lors de la modification de la configuration du rapport',
  reportConfigurationAddSuccess: 'Configuration du rapport ajoutée avec succès',
  reportConfigurationAddError: "Erreur lors de l'ajout de la configuration du rapport",
  from: 'Du',
  to: 'au',
  noDateSelected: 'Aucune date sélectionnée',
  reportRemoveWarning: 'Êtes-vous sûr de vouloir supprimer la configuration du rapport',
  deleteReport: 'Suppression de la configuration du rapport',
  reportDeleteSuccess: 'Configuration du rapport supprimée avec succès',
  reportDeleteError: 'Erreur lors de la suppression de la configuration du rapport',
  role: 'Rôle',
  roles: {
    admin: 'Administrateur',
    adminSite: 'Administrateur de site',
    user: 'Utilisateur',
    manager: 'Manager',
    operator: 'Opérateur',
    operatorRestricted: 'Opérateur restreint',
    superAdmin: 'Super administrateur',
    editor: 'Éditeur',
    viewer: 'Lecteur',
  },
  sites: 'Sites',
  energies: 'Énergies',
  energiesSelected: 'énergie(s) sélectionnée(s)',
  meterUsages: 'Usages',
  meterUsagesSelected: 'usage(s) sélectionné(s)',
  equipments: 'Équipements',
  equipmentWithSampling: 'Équipement avec prélèvements',
  equipmentWithAction: 'Équipement avec actions préventives',
  userSitesAssignation: "Assignation de l'utilisateur au(x) site(s)",
  userEquipmentsAssignation: "Assignation de l'utilisateur aux équipements",
  operatorOnlyOneSite: "Un opérateur ne peut être rattaché qu'à un seul site",
  userEditSuccess: 'Utilisateur modifié avec succès',
  userEditError: "Erreur lors de la modification de l'utilisateur",
  userCreateSuccess: 'Utilisateur créé avec succès',
  userCreateError: "Erreur lors de la création de l'utilisateur",
  equipmentsSelected: 'équipement(s) sélectionné(s)',
  showSelectedEquipments: 'Afficher les équipements sélectionnés',
  showAllEquipments: 'Afficher tous les équipements',
  sitesSelected: 'site(s) sélectionné(s)',
  passwordComplexityError: 'Le mot de passe doit contenir au moins 8 caractères, une majuscule, une minuscule, un chiffre et un caractère spécial',
  passwordRule8Chars: '8 caractères minimum',
  passwordRuleLowercase: '1 minuscule',
  passwordRuleUppercase: '1 majuscule',
  passwordRuleNumber: '1 chiffre',
  passwordRuleSpecial: '1 caractère spécial',
  passwordRuleNoEdgeWhitespace: 'Pas d’espace au début ni à la fin',
  passwordEdgeWhitespaceError: 'Le mot de passe ne doit pas commencer ni finir par une espace',
  accessForbidden: "Vous n'avez pas accès à cette page.",
  requestAdmin: ' Veuillez vous adresser à votre administrateur.',
  perimeters: 'Périmètres',
  perimetersNone: 'Aucun périmètre',
  perimetersSelected: 'périmètre(s) sélectionné(s)',
  useCase: {
    legionella: 'Carnet sanitaire',
    coldStorage: 'Chaîne du froid',
    energy: 'GTB',
    airQuality: "Qualité de l'air",
    consumptions: 'Énergie',
  },
  airQualityModule: {
    conformityTitle: 'Tableau de bord',
    conformitySubtitle: 'Nombre de pièces dans la zone de confort',
    roomList: 'Liste des pièces',
    percentageOut: '% hors zone',
    band: 'Statut',
    good: 'Bon',
    fair: 'Moyen',
    poor: 'Mauvais',
    unknown: 'Sans donnée',
    rooms: 'pièces',
    tvoc: 'TVOC',
    settingsTitle: 'Paramètres QAI',
    thresholdsTab: 'Seuils QAI',
    percentageTab: 'Pourcentage hors seuils QAI',
    fairThreshold: 'Seuil moyen',
    poorThreshold: 'Seuil mauvais',
    co2Description: 'Un taux de CO2 élevé est généralement dû à une ventilation insuffisante. Il peut impacter le confort et la concentration.',
    tvocDescription:
      "Les composés organiques volatils (COV) s'évaporent de produits comme les peintures, les produits d'entretien ou le mobilier. Une exposition élevée peut nuire à la santé.",
    humidityDescription: "Une humidité élevée augmente le risque de moisissures et l'inconfort. Une humidité trop basse assèche la peau et les muqueuses.",
    percentageThresholdDescription: "Pourcentage d'heures hors seuils au-delà duquel une pièce est considérée hors zone de confort sur la période analysée.",
    noData: 'Aucune donnée de qualité de l’air sur la période',
    mapTitle: 'Vue plan',
    mapSubtitle: 'État des zones sur les 3 dernières heures — la couleur reflète la moins bonne des trois mesures',
    lastValue: 'Dernière valeur',
    ambientTemperature: 'T ambiante',
    noZones: "Aucune zone avec capteur de qualité de l'air sur ce site",
  },
  noSitesAssigned: "Vous n'êtes rattaché à aucun site.",
  roleAtLeastOneEquipment: 'Un {{role}} doit être rattaché à au moins un équipement',
  nextReportDate: 'Date du prochain rapport',
  deleteUser: 'Suppression de l’utilisateur',
  userDeleteWarning: 'Êtes-vous sûr de vouloir supprimer l’utilisateur',
  userDeleteSuccess: 'Utilisateur supprimé avec succès',
  userDeleteError: 'Erreur lors de la suppression de l’utilisateur',
  optional: 'Optionnel',
  formContainsErrors: 'Le formulaire contient des erreurs',
  pleaseSelectTheDevice: 'Préciser le nom du capteur',
  equipmentNoActionWarning: "Vous n'avez pas sélectionné d'actions pour cet équipement",
  equipmentNoDeviceWarning: "Vous n'avez pas sélectionné de capteur pour cet équipement",
  equipmentNoActionDeviceWarning: "Vous n'avez pas sélectionné d'actions ni de capteur pour cet équipement",
  deviceName: 'Nom du capteur',
  reportNameAndFrequency: 'Nom et fréquence du rapport',
  reportContent: 'Contenu du rapport',
  reportEquipments: 'Sélection des équipements',
  noEquipment: 'Aucun équipement',
  type: 'Type',
  eventType: {
    temperature: 'Température',
    humidity: 'Humidité',
    waterFlow: 'Vitesse',
    waterMovement: "Mouvement d'eau",
    gas: 'Gaz',
    electricity: 'Électricité',
    default: 'Défaut',
    battery: 'Batterie',
    chlorine: 'Chlore',
    ph: 'pH',
    co2: 'CO2',
    tvoc: 'TVOC',
  },
  currentValue: 'Actuelle',
  avg: 'Moyenne',
  min: 'min',
  max: 'max',
  operatorNotAssignedOnEquipmentError: "L'utilisateur {{userMail}} n'est pas assigné à au moins un équipment",
  noNotification: 'Pas de notification',
  viewFullscreen: 'Plein écran',
  printChart: 'Imprimer',
  downloadCSV: 'Télécharger en CSV',
  downloadXLS: 'Télécharger en XLS',
  deleteFileSuccess: 'Fichier supprimé avec succès',
  deleteFileError: 'Erreur lors de la suppression du fichier',
  deleteFile: 'Suppression du fichier',
  deleteFileWarning: 'Êtes-vous sûr de vouloir supprimer le fichier',
  fileType: {
    legioIncident: 'Incident',
    legioSample: 'Prélèvement',
  },
  unassignDevice: 'Désassigner le capteur',
  deviceUnassignedSuccess: 'Capteur désassigné avec succès',
  deviceUnassignedError: 'Erreur lors de la désassignation du capteur',
  loading: 'Chargement',
  period: 'Période',
  equipmentsAll: 'Équipements (tous)',
  fileUploadSuccess: 'Fichier ajouté avec succès',
  fileUploadError: "Erreur lors de l'ajout du fichier",
  noBuilding: 'Aucun bâtiment',
  addBuildingSuccess: 'Bâtiment ajouté avec succès',
  addBuildingError: "Erreur lors de l'ajout du bâtiment",
  deleteBuildingSuccess: 'Bâtiment supprimé avec succès',
  deleteBuildingError: 'Erreur lors de la suppression du bâtiment',
  editBuildingSuccess: 'Bâtiment modifié avec succès',
  editBuildingError: 'Erreur lors de la modification du bâtiment',
  lastComment: 'Dernier commentaire',
  acknowledged: 'Traitée{{suffix}}',
  notAcknowledged: 'Non traitée{{suffix}}',
  severityAll: 'Sévérité (toutes)',
  severitySelected: 'sévérité(s) sélectionnée(s)',
  noDevice: 'Aucun capteur',
  total: 'Total',
  noWaterMovementDuring: "Absence de mouvement d'eau pendant",
  usageTypeMonitoring: "Suivi de la consommation d'{{usageType}}",
  photovoltaicProductionMonitoring: 'Suivi de la production photovoltaïque',
  location: 'Localisation',
  nbBuilding: 'Nb bâtiments',
  nbEquipment: 'Nb équipements',
  supervision: 'Supervision',
  allDay: 'Toute la journée',
  search: 'Rechercher',
  frequencies: {
    perDay: 'Par jour',
    perWeek: 'Par semaine',
    perMonth: 'Par mois',
    perYear: 'Par an',
  },
  stack: 'Grouper',
  selectAll: 'Tout sélectionner',
  unselectAll: 'Tout désélectionner',
  cardView: 'Vue en cartes',
  tableView: 'Vue en tableau',
  usageType: {
    energy: 'Gaz / Électricité',
    water: 'Eau',
  },
  siteAddedSuccess: 'Site ajouté avec succès',
  siteAddedError: "Erreur lors de l'ajout du site",
  energy: 'Énergie',
  energySelected: 'énergie(s) sélectionnée(s)',
  myTotalUsage: 'Ma consommation totale',
  breakdownLocation: 'Répartition par localisation',
  breakdownEnergy: 'Répartition par énergie',
  breakdownUsage: 'Répartition par usage',
  usageEvolution: 'Évolution de la consommation',
  unitType: {
    m3: 'm³',
    kwh: 'KWh',
    mwh: 'MWh',
    gwh: 'GWh',
    liter: 'L',
    literPerDay: 'L/jour',
  },
  usageBySite: 'Classement par site',
  usage: 'Consommation',
  water: 'eau',
  perSquareMeter: 'par m²',
  perBed: 'par lit',
  areaSpace: 'Surface (m²)',
  occupancy: 'Occupation (lits)',
  equipmentEditSuccess: 'Équipement modifié avec succès',
  equipmentEditError: "Erreur lors de la modification de l'équipement",
  equipmentExcludedFromCalculationWarning: 'Cet équipement ne sera pas pris en compte lors du calcul de votre consommation',
  meterType: 'Type de compteur',
  meterConsumption: 'Consommation du compteur',
  year: 'Année',
  consumptionReadings: 'Relevés de consommation',
  referenceYear: 'Année de référence',
  selectReferenceYear: "Sélectionner l'année de référence",
  ecsConsumption: 'Consommation ECS (Eau Chaud Sanitaire)',
  heatingConsumption: 'Consommation chauffage',
  electricityConsumption: 'Consommation électrique',
  january: 'Janvier',
  february: 'Février',
  march: 'Mars',
  april: 'Avril',
  may: 'Mai',
  june: 'Juin',
  july: 'Juillet',
  august: 'Août',
  september: 'Septembre',
  october: 'Octobre',
  november: 'Novembre',
  december: 'Décembre',
  buildingsSelected: 'bâtiment(s) sélectionné(s)',
  floorsSelected: 'étages(s) sélectionné(s)',
  noFloor: "pas d'étage",
  spacesSelected: 'pièce(s) sélectionnée(s)',
  noSpace: 'pas de pièce',
  energyMonitoring: {
    heating: {
      subtitle: 'Moyennes des données calculées sur les deux dernières heures',
    },
  },
  perSite: 'Par site(s)',
  floor: 'étage',
  space: 'pièce',
  filterBy: 'Filtrer par',
  noSite: 'Pas de site',
  pleaseSelectSpaces: 'Veuillez sélectionner au moins une pièce (maximum 5)',
  timeRange: {
    '1h': 'Dernière heure',
    '3h': '3 dernières heures',
    '6h': '6 dernières heures',
    '24h': '24 dernières heures',
    '7d': '7 derniers jours',
    custom: 'Jours personnalisés',
  },
  roomTemperature: 'Température moyenne ambiance',
  heatingCircuits: 'Circuits de chauffage',
  flowStart: 'Départ',
  instruction: 'Consigne',
  history: 'Historique',
  hotLoopStartAndCollectiveTank: 'Départ ECS et ballon ECS',
  hotLoopReturn: 'Retour ECS',
  clickOnColumnForHistory: "Cliquez sur une colonne pour afficher l'historique",
  productionAndGeneralFlow: 'Production - Départ primaire',
  circuit: 'Circuit',
  floorSearch: 'Recherche un étage',
  showInstruction: 'Afficher la consigne',
  showAssignedSpaces: 'Afficher les pièces déjà assignées',
  delta: 'Delta',
  productionWarningDescription: '🚨 = si le Delta T est supérieur à 10°C pendant la période sélectionnée et quand la chaudière est en fonctionnement',
  heatingCircuitsWarningDescription: '🚨 = nombre de circuits dont le Delta T est supérieur à 5°C',
  ecsWarningDescriptionStart: '🚨 départ = nombre de circuits de départ dont la température est inférieure à 55°C',
  ecsWarningDescriptionReturn: '🚨 retour = nombre de circuits de retour dont la température est inférieure à 50°C',
  temperatureOutside: 'Température extérieure',
  showTemperatureOutside: 'Afficher la température extérieure',
  group: 'Groupe',
  newAlert: 'Nouvelle alerte',
  createNewAlert: 'Créer une nouvelle alerte',
  notificationDescription: 'Les notifications seront envoyées aux utilisateurs selon les plages horaires définies ci-dessous',
  sendField: {
    sendSms: 'SMS',
    sendCall: 'appel',
    sendMail: 'email',
  },
  alertActivation: "Activation de l'alerte",
  alertActivationDescription: "L'alerte sera activée uniquement durant les plages horaires définies ci-dessous",
  ambientCO2: 'Ambiance CO₂',
  humidity: 'Humidité',
  blowing: 'Soufflage',
  co2: 'CO₂',
  none: 'Aucun',
  noEquipmentFoundForAirQuality: "Le bâtiment sélectionné ne contient pas d'équipement de qualité de l'air",
  duringPeriod: 'Sur la période',
  frequenciesSelected: 'fréquence(s) sélectionnée(s)',
  allSites: 'Tous les sites',
  comparedToSamePeriod: 'comparé à la même période sur',
  selectYear: 'Sélectionner une année',
  dju: 'DJU',
  normalizeByDJU: 'Normaliser par DJU',
  consumptionEvolution: 'Évolution des consommations',
  consumptionsEvolutionBy: 'Évolution des consommations par {{category}}',
  evolutionPercentage: 'Évolution en %',
  evolutionPercentageByDJU: 'Évolution en % par DJU',
  totalEvolution: 'Évolution totale',
  evolutionFromYearToYear: "Évolution d'une année à l'autre",
  currentPeriod: 'Période actuelle',
  previousPeriod: 'Période précédente',
  showDJU: 'Afficher le DJU',
  sitePrioritization: "Priorisation des sites à potentiel d'économie",
  locationPerformanceOfSites: 'Performance de mes bâtiments',
  evolutionComparedTo: 'Évolution par rapport à ',
  consumptionPerSquareMeter: 'Consommation par m²',
  consumptionPerBed: 'Consommation par lit',
  totalConsumption: 'Consommation totale',
  energyByDjuDisabledDescriptionTooltip:
    'Les DJU sont calculés sur la base de la température extérieure et de la température de référence. Or ces données ne sont disponibles que mensuellement. La normalisation par DJU ne sera donc pas possible si le filtre jour ou semaine est sélectionné.',
  strongImpact: 'Fort impact',
  weakImpact: 'Faible impact',
  strongLeeway: 'forte marge de manœuvre',
  weakLeeway: 'faible marge de manœuvre',
  area: 'Superficie',
  numberBed: 'Nombre de lits',
  comfortTemperature: 'Température de confort',
  day: 'Jour',
  night: 'Nuit',
  both: 'Les deux',
  temperatureBy: 'Température par',
  temperatureDuringDay: 'Température durant la journée',
  temperatureSettings: 'Paramètres de température',
  dayNightRange: 'Plage horaire jour/nuit',
  officeComfortZone: 'Zone de confort (bureau)',
  roomComfortZone: 'Zone de confort (chambre)',
  companySettingsEditSuccess: 'Paramètres modifiés avec succès',
  companySettingsEditError: 'Erreur lors de la modification des paramètres',
  temperaturesInComfortZone: 'Répartition des températures par zone de confort',
  bedroom: 'chambre',
  office: 'bureau',
  percentageOfRoomsInComfortZone: 'Pourcentage de pièces dans la zone de confort',
  insideComfortZone: 'Dans la zone de confort',
  belowComfortZone: 'Inférieur à la zone de confort',
  aboveComfortZone: 'Supérieur à la zone de confort',
  mixedOutsideComfortZone: 'En dehors de la zone de confort (mixte)',
  previous: 'Précédent',
  room: 'Pièce',
  buildings: 'Bâtiments',
  floors_one: 'Étage',
  floors_other: 'Étages',
  percentageThresholdCold: 'Pourcentage de temps au-delà duquel la pièce est considérée comme froide',
  percentageThresholdHot: 'Pourcentage de temps au-delà duquel la pièce est considérée comme chaude',
  everything: 'Tout',
  noSiteTemperatureData: 'Aucun des sites ne dispose de données de température sur la période sélectionnée',
  rooms: 'pièce(s)',
  minimum: 'minimum',
  maximum: 'maximum',
  inAverage: 'de moyenne',
  comfortType: {
    hot: 'Chaud',
    cold: 'Froid',
    comfort: 'OK',
    frost_protection: 'Hors gel',
  },
  comfortZone: 'Zone de confort',
  orderBy: 'Trier par',
  comfort: 'Confort',
  fromHour: 'de',
  toHour: 'à',
  summer: 'Été',
  winter: 'Hiver',
  rangesDefinition: 'Définition des plages',
  seasonRange: 'Plage mensuelle été/hiver',
  percentageOutsideComfortZone: 'Pourcentage de temps hors zone de confort',
  pleaseSelect: {
    site: 'Veuillez sélectionner un <u>site</u>',
    building: 'Veuillez sélectionner un <u>bâtiment</u>',
    floor: 'Veuillez sélectionner un <u>étage</u>',
  },
  comfortMonitoring: 'Pilotage du confort',
  comfortSection: {
    radiator: 'Radiateur',
    vrv: 'VRV',
    fanCoil: 'Ventilo-convecteur',
    heatedFloor: 'Plancher chauffant',
    modeMonitoring: 'Monitoring',
  },
  comfortMode: {
    heat: 'Chaud',
    cool: 'Froid',
  },
  boilerRoomSettings: {
    title: 'Réglages',
    sections: {
      general: 'Général',
      waterLaw: "Loi d'eau",
      waterLawHot: "Loi d'eau chaude",
      waterLawCold: "Loi d'eau froide",
      pump: 'Pompe',
      v3v: 'Vanne 3 voies',
      aquastat: 'Aquastat',
      boilerMode: 'Mode chaudière',
      startThreshold: 'Seuil de démarrage',
      runTimes: 'Temps de marche/arrêt',
      machineState: 'Marche / arrêt',
      machineSetPoint: 'Consigne',
    },
    general: {
      mode: 'Mode',
      modeHot: 'Chaud',
      modeCold: 'Froid',
      modeAuto: 'Auto',
      modeDeadBand: 'Zone morte',
    },
    waterLaw: {
      axisOutdoor: 'Température extérieure (°C)',
      axisSupply: 'Température de départ (°C)',
      description:
        "La loi d'eau est adaptée dynamiquement par rapport aux besoins ambiants (entre -{{marginLow}}°C et +{{margin}}°C). La loi d'eau fixe la consigne de température de départ du circuit selon la température extérieure : plus il fait froid dehors, plus la T départ est chaude. Cliquez sur un point pour saisir sa consigne, ou faites-le glisser verticalement. Pour être enregistrée, la courbe ne doit jamais remonter de gauche à droite : chaque point est inférieur ou égal à son voisin de gauche.",
      descriptionCold:
        "La loi d'eau froide fixe la consigne de température de départ du circuit en rafraîchissement selon la température extérieure : plus il fait chaud dehors, plus la T départ est froide. Cliquez sur un point pour saisir sa consigne, ou faites-le glisser verticalement. Pour être enregistrée, la courbe ne doit jamais remonter de gauche à droite : chaque point est inférieur ou égal à son voisin de gauche.",
      descriptionStatic:
        "La loi d'eau fixe la consigne de température de départ du circuit selon la température extérieure : plus il fait froid dehors, plus la T départ est chaude. Cliquez sur un point pour saisir sa consigne, ou faites-le glisser verticalement. Pour être enregistrée, la courbe ne doit jamais remonter de gauche à droite : chaque point est inférieur ou égal à son voisin de gauche.",
      gtbReady: "À l'enregistrement, cette loi d'eau est aussi écrite sur le régulateur (GTB).",
      gtbMlDriven:
        "Circuit piloté par l'algorithme : cette loi d'eau n'est enregistrée que dans l'application, où elle borne la consigne calculée. Le régulateur garde sa loi de repli.",
      gtbMissingPoints:
        "Points de loi d'eau introuvables sur la GTB ({{found}} sur {{total}}) : cette loi d'eau n'est enregistrée que dans l'application, le régulateur ne la reçoit pas.",
      gtbNoConfig: "Ce site n'a pas de liaison GTB : cette loi d'eau n'est enregistrée que dans l'application.",
      gtbWriteNoConfig: "Loi d'eau enregistrée dans l'application, mais ce site n'a pas de liaison GTB configurée : le régulateur ne la reçoit pas.",
      gtbWriteFailed: "Loi d'eau enregistrée dans l'application, mais son envoi vers le régulateur (GTB) a échoué.",
      gtbWriteThrottled:
        "Loi d'eau enregistrée dans l'application, mais son envoi vers le régulateur (GTB) est trop rapproché du précédent : renvoyez-la dans quelques secondes.",
      active: 'Régime actif',
      invalid: "Loi d'eau non enregistrable : la température de départ ne peut pas augmenter quand la température extérieure augmente.",
      invalidPoint: 'À {{x}} °C extérieur, le départ ({{y}} °C) dépasse celui du point précédent ({{previousY}} °C à {{previousX}} °C extérieur).',
      submitBlocked: "La loi d'eau modifiée n'est pas enregistrable : corrigez-la ou réinitialisez-la pour écrire les réglages.",
      currentOutside: 'T. extérieure',
      computedSetPoint: 'Consigne actuelle',
      currentSupply: 'T. départ mesurée',
      missing:
        "Aucune loi d'eau n'existe pour ce circuit. Elle est créée à la génération de la chaufferie à partir de la loi d'eau par défaut du site : définissez-la dans l'admin, puis regénérez le synoptique.",
      saveSuccess: 'Loi d’eau enregistrée',
      saveError: 'Erreur lors de l’enregistrement de la loi d’eau',
      boundsLegend: 'Plage de régulation (+{{margin}} / -{{marginLow}} °C)',
      editPointTitle: 'À {{x}} °C extérieur',
      editPointLabel: 'Température de départ',
      editPointDecrease: 'Baisser de {{step}} °C',
      editPointIncrease: 'Monter de {{step}} °C',
      editPointViolation: 'Dépasse le point précédent ({{previousY}} °C à {{previousX}} °C extérieur).',
      editPointHintStep: '±{{step}} °C',
      editPointHintNeighbor: 'point voisin',
      editPointHintConfirm: 'valider',
      editPointHintClose: 'fermer',
    },
  },
  // Grammaire commune aux dialogs d'écriture de points d'équipement (forçage CTA, réglages
  // chaufferie) : compteur, resets, submit, toasts de progression et de synchronisation.
  equipmentSettings: {
    submit: 'Écrire les réglages',
    cancel: 'Annuler',
    manualOutput: 'Sortie manuelle',
    editedCount: '{{count}} paramètre modifié',
    editedCount_other: '{{count}} paramètres modifiés',
    noChanges: 'Aucune modification',
    resetAll: 'Tout réinitialiser',
    reset: 'Réinitialiser',
    sendError: "Échec de l'envoi des valeurs",
    skippedWarning: '{{equipment}} ignoré',
    sendTimeout: 'Réponse non reçue, vérifiez les données',
    sendThrottled: 'Forçage trop rapproché, patientez quelques secondes',
    progressInProgress: 'Envoi en cours… {{succeeded}}/{{total}} traités',
    progressDone: '{{succeeded}}/{{total}} réussis',
    progressFailed: '{{failed}} échec(s)',
  },
  // Synchro post-forçage et relecture des données (bandeau, toast, bouton Réactualiser). Vocabulaire : « données »,
  // jamais « valeurs » ni « mesures ».
  forcingToast: {
    inProgress: 'Forçage en cours',
    success: 'Forçage effectué avec succès',
    partial: 'Forçage partiellement appliqué',
    writeFailed: "Erreur d'écriture",
    unconfirmed: 'Valeur non confirmée',
    noValue: '—',
    expand: 'Déplier',
    collapse: 'Replier',
    close: 'Fermer',
  },
  equipmentSync: {
    writeFailed: "Erreur d'écriture",
    writeInProgress: 'En cours',
    recollect: 'Réactualiser',
    recollectCooldown: 'Réactualiser ({{seconds}} s)',
    recollectDisabled: 'Les données sont en cours de rafraîchissement',
    recollectUpdated: 'Données mises à jour',
    recollectPartial: 'Données partiellement mises à jour',
    recollectBusy: 'Les données sont en cours de rafraîchissement. Veuillez patienter.',
    recollectError: 'Erreur lors de la mise à jour des données',
  },
  // Connexion d'un macro-équipement GTB (dernière lecture où la box a répondu). Déconnecté : valeurs masquées,
  // forçages refusés.
  equipmentConnectivity: {
    lastConnectionAt: 'Dernière connexion le {{date}} à {{time}}',
    disconnected: 'Équipement déconnecté',
    forcingDisabled: 'Équipement déconnecté : forçage impossible',
    blocked: 'Équipement déconnecté : aucune connexion depuis le {{date}} à {{time}}. Forçage impossible.',
    blockedUnknownDate: 'Équipement déconnecté. Forçage impossible.',
    writeRefused: "L'équipement est déconnecté : le forçage n'a pas été envoyé.",
  },
  ctaSettings: {
    title: 'Forçage',
    sections: {
      supervision: 'Commande supervision',
      setpointRecovery: 'Consigne T reprise',
      setpointBlowing: 'Consigne T soufflage',
      humidityRecovery: 'Consigne humidité reprise',
      fanRecovery: 'Ventilateur de reprise',
      fanBlowing: 'Ventilateur de soufflage',
      batteryChangeover: 'Batterie changeover',
      electricBattery: 'Batterie électrique',
      batteryHot: 'Batterie chaude',
      batteryCold: 'Batterie froide',
      changeover: 'Changeover',
      damper: 'Registre air neuf',
      mixingAir: 'Caisson de mélange',
    },
  },
  comfortConfiguration: {
    title: 'Configuration du confort',
    selectMode: 'Sélectionner un mode',
    apply: 'Appliquer',
    applying: 'Application…',
    selectedCount: '{{count}} sélectionné(s)',
    emptyState: 'Aucun équipement réversible sur ce site.',
    updateSuccess: 'Mode mis à jour',
    updateError: 'Erreur lors de la mise à jour',
    allBuildings: 'Tous les bâtiments',
    allFloors: 'Tous les étages',
    allTypes: 'Tous les types',
    allModes: 'Tous les modes',
    noCurrentMode: '—',
    enableMode: 'Modifier le mode',
    enableAuthorizedOff: "Modifier l'autorisation de l'occupant sur le ON/OFF",
    authorizedOffAllowed: 'Autorisé',
    authorizedOffForbidden: 'Non Autorisé',
    authorizedOff: 'Occupant autorisé ON/OFF',
    state: 'État',
    stateOn: 'ON',
    stateOff: 'OFF',
    valveOpening: 'Ouverture vanne',
    mode: 'Mode',
    progressInProgress: 'Envoi en cours… {{succeeded}}/{{total}} traités',
    progressDone: '{{succeeded}}/{{total}} réussis',
    progressFailed: '{{failed}} échec(s)',
    failures: 'Échecs',
    retryFailed: 'Réessayer les échecs',
    colEquipment: 'Équipement',
    colBuilding: 'Bâtiment',
    colFloor: 'Étage',
    selectAllPages: 'Sélectionner tous les équipements (toutes les pages)',
  },
  editSetPoint: 'Modifier la consigne',
  editSpaceSetPoint: 'Modifier les consignes de température de la pièce',
  coldSpaces: 'pièces froides',
  hotSpaces: 'pièces chaudes',
  dataLast3HoursBasedOnSettings: 'Données calculées sur les 3 dernières heures sur la base des zones de confort définies en <Link>paramètres</Link>.',
  percentageComfort: '% confort',
  percentageCold: '% froid',
  percentageHot: '% chaud',
  selectUsage: 'Sélectionner un usage',
  meterUsage: 'Usage du compteur',
  meterUsageTypes: {
    heating: 'Chauffage',
    cold: 'Froid',
    ecs: 'Eau chaude sanitaire (ECS)',
    other: 'Autre',
    electricity_other: 'Électricité',
    gas_heating: 'Chauffage (gaz)',
    gas_ecs: 'ECS (gaz)',
    gas_other: 'Gaz',
    thermal_other: 'Thermique',
    thermal_ecs: 'ECS (thermique)',
    thermal_heating: 'Chauffage (thermique)',
    gas: 'Gaz',
    electricity: 'Électricité',
    water: 'Eau',
    thermal: 'Thermique',
  },
  consumptionEcs: 'Consommation ECS mensuelle (KWh)',
  consumptionOther: 'Consommation autre mensuelle (KWh)',
  myConsumptionDju: 'Ma consommation (DJU)',
  usageEvolutionDju: 'Évolution de la consommation des usages (DJU)',
  evolutionFromYearToYearDju: "Évolution d'une année à l'autre (DJU)",
  comparedTo: 'comparé à',
  comparedToFem: 'comparée à',
  anErrorOccured: 'Une erreur est survenue. Service indisponible.',
  difference: 'Différence',
  accessAndRestrictions: 'Accès et restrictions',
  roleDescription: {
    admin: "Accès total à l'application",
    adminSite: "Accès total à l'application avec visibilité restreinte au site",
    manager: "Accès total à l'application avec visibilité restreinte sur les équipements du site",
    operator: "Accès restreint à l'application avec visibilité restreinte sur les équipements du site",
    operatorRestricted: 'Accès en lecture seule avec visibilité restreinte sur les équipements du site',
  },
  pleaseSelectSite: 'Veuillez sélectionner un site',
  visibility: 'Visibilité',
  roleAtLeastOneSite: 'Un {{role}} doit être assigné à au moins un site',
  myReports: 'Mes rapports',
  userNotAssignedToEquipmentWarning: "Attention ! L'utilisateur n'est assigné à aucun équipement sur les sites suivants:",
  ambiance: 'Ambiance',
  recovery: 'Reprise',
  speed: 'Vitesse',
  pressure: 'Pression',
  flow: 'Débit',
  blowingAvg: 'En marche',
  blowingMode: 'Mode de soufflage',
  surpressure: 'Surpression',
  changeover: 'Changeover',
  fan: 'Ventilateur',
  damper: 'Registre air neuf',
  mixingAir: 'Caisson de mélange',
  defaults: 'Défauts',
  ctaRunning: 'Marche',
  ctaStopped: 'Arrêt',
  faultActive: 'Défaut actif',
  faultOk: 'Aucun défaut',
  noChartSelected: 'Sélectionnez au moins un graphique à afficher',
  co2Avg: 'Moyenne',
  co2Max: 'Max',
  airUnitAutocompleteSuffix: 'site, bâtiment, étage, cta',
  seeAllAlerts: 'Voir toutes les alertes',
  last24Hours: 'Dernières 24 heures',
  week: 'Semaine',
  logSupervision: 'Suivi des mains courantes',
  logSheet: 'Fiche de main courante',
  newLogSheet: 'Nouvelle main courante',
  logStatus: {
    todo: 'À faire',
    ongoing: 'En cours',
    done: 'Clôturée',
  },
  logCreateSuccess: 'Main courante créée avec succès',
  logCreateError: 'Erreur lors de la création de la main courante',
  logEditSuccess: 'Main courante modifiée avec succès',
  logEditError: 'Erreur lors de la modification de la main courante',
  logDoneAt: 'Clôturée le',
  logCreatedAt: 'Créée le',
  workCreatedAt: 'Créé le',
  category: 'Catégorie',
  duplicate: 'Dupliquer',
  scheduleCreateSuccess: 'Calendrier créé avec succès',
  scheduleCreateError: 'Erreur lors de la création du calendrier',
  scheduleEditSuccess: 'Calendrier modifié avec succès',
  scheduleEditError: 'Erreur lors de la modification du calendrier',
  scheduleDeleteSuccess: 'Calendrier supprimé avec succès',
  scheduleDeleteError: 'Erreur lors de la suppression du calendrier',
  scheduleMigrateSuccess: 'Pièces migrées avec succès',
  scheduleMigrateError: 'Erreur lors de la migration des pièces',
  migrate: 'Migrer',
  migrateSchedule: 'Migrer les pièces',
  migrateScheduleDescription: 'Basculez toutes les pièces d’un calendrier vers un autre calendrier du même type.',
  migrateScheduleSource: 'Calendrier source',
  migrateScheduleSourcePlaceholder: 'Sélectionner le calendrier à vider',
  migrateScheduleTarget: 'Calendrier cible',
  migrateScheduleTargetPlaceholder: 'Sélectionner le calendrier de destination',
  migrateScheduleShowSpaces_one: 'Voir la pièce à migrer ({{count}})',
  migrateScheduleShowSpaces_other: 'Voir les pièces à migrer ({{count}})',
  migrateScheduleNoSpaces: 'Aucune pièce à migrer',
  migrateScheduleDerogationWarning:
    'Certaines pièces sont en dérogation. La migration annulera ces dérogations : le calendrier de destination reprendra la main.',
  migrateScheduleAuthorizedOffWarning:
    'Le calendrier de destination n’a pas de plage « autorisé à couper ». Les pièces migrées perdront cette autorisation et leurs points seront relâchés.',
  migrateScheduleConfirmEmpty: 'Migrer',
  migrateScheduleConfirm_one: 'Migrer la {{count}} pièce',
  migrateScheduleConfirm_other: 'Migrer les {{count}} pièces',
  spacesCountBadgeEmpty: 'Aucune pièce',
  spacesCountBadge_one: '{{count}} pièce',
  spacesCountBadge_other: '{{count}} pièces',
  newSchedule: 'Nouveau calendrier',
  alreadyAssigned: {
    building: 'Bâtiment déjà assigné',
    floor: 'Étage déjà assigné',
    space: 'Pièce déjà assignée',
  },
  pleaseCompleteAllRequiredFields: 'Veuillez compléter tous les champs obligatoires',
  setPointMapMustCoverAllHours: 'Le calendrier des consignes doit couvrir toutes les heures de la journée',
  usePeriods: 'Utiliser des périodes',
  defaultPeriodTab: 'Par défaut',
  addPeriod: 'Période',
  periodName: 'Nom de la période',
  periodNamePlaceholder: 'Optionnel',
  periodStartDate: 'Début',
  periodEndDate: 'Fin',
  periodRecurring: 'Chaque année',
  removePeriod: 'Supprimer la période',
  periodActive: 'Période en cours',
  periodInvalidBounds: 'Les dates de la période sont invalides',
  periodsOverlap: 'Les périodes « {{a}} » et « {{b}} » se chevauchent',
  confirmDisablePeriodsTitle: 'Désactiver les périodes',
  confirmDisablePeriodsDescription:
    'Les grilles de toutes les périodes de ce calendrier seront supprimées. La grille par défaut sera conservée et appliquée en permanence.',
  targetSchedulePeriodsHint: 'Le calendrier cible applique des périodes : les espaces migrés les adopteront.',
  customizeDuringPeriod: 'Personnaliser pendant cette période',
  typeFollowsDefaultDuringPeriod: 'Ce calendrier suit sa grille par défaut pendant cette période.',
  periodNeedsOneType: 'Une période doit personnaliser au moins un calendrier',
  atLeastOneEquipmentMustBeSelected: 'Au moins un équipement doit être sélectionné',
  deleteSchedule: 'Suppression du calendrier',
  scheduleDeleteWarning: 'Êtes-vous sûr de vouloir supprimer le calendrier',
  calendarName: 'Nom du calendrier',
  calendarDescription: 'Description du calendrier',
  illuminanceControlEnabled: 'Pilotage par la luminosité extérieure',
  illuminanceLowThreshold: 'Seuil bas (lux)',
  illuminanceHighThreshold: 'Seuil haut (lux)',
  illuminanceControlHelp:
    "Les plages ON décidées dans le calendrier sont des plages d'autorisation, l'allumage et l'extinction sur ces plages se feront en fonction des seuils haut et bas de luminosité extérieure.",
  illuminanceThresholdsInvalid: 'Le seuil bas doit être strictement inférieur au seuil haut',
  illuminanceThresholdLow: 'Seuil bas',
  illuminanceThresholdHigh: 'Seuil haut',
  luxValue: '{{value}} lux',
  illuminanceAuthorizedWindow: 'Allumage selon la luminosité',
  showOutdoorIlluminance: 'Afficher la luminosité extérieure',
  comfortCalendarAuthorizedOffHint: "Cliquez une plage pour régler la température et l'autorisation de l'occupant à utiliser le ON/OFF sur ce créneau.",
  calendar: 'Calendrier',
  information: 'Informations',
  createCalendar: 'Créer le calendrier',
  applySameTimeSlotsToSelectedDays: 'Appliquer les mêmes plages horaires aux jours sélectionnés',
  editSchedule: 'Modifier le calendrier',
  createdAt: 'Créé le',
  updatedAt: 'Modifié le',
  calendarTemperatureError: 'La consigne doit être comprise entre {{min}} et {{max}}°C',
  derogate: 'Déroger',
  setPointDerogation: 'Dérogation de consigne',
  duration: 'Durée',
  indefinitely: 'Indéfiniment',
  derogationCreateSuccess: 'Dérogation créée avec succès',
  derogationCreateError: 'Erreur lors de la création de la dérogation',
  derogationNoScheduleError: 'Cette pièce doit être associée à un calendrier pour pouvoir la mettre en dérogation',
  isDerogation: 'En dérogation',
  resetSetPoint: 'Réinitialiser la consigne',
  setPointResetSuccess: 'Consigne réinitialisée avec succès',
  setPointResetError: 'Erreur lors de la réinitialisation de la consigne',
  schedules: 'Calendriers',
  assigned: 'Assigné',
  spaces_one: 'Pièce',
  spaces_other: 'Pièces',
  noSchedule: 'Non assigné',
  cancelDerogation: 'Annuler la dérogation',
  resetDerogationWarning: {
    duration: "Cette pièce est actuellement en dérogation de consigne {{type}} jusqu'au <strong>{{date}}</strong>.",
    durationIndefinite: 'Cette pièce est actuellement en dérogation de consigne {{type}}, et ce <strong>indéfiniment</strong>.',
    value_heating: 'La consigne dérogée est de <strong>{{value}}°C</strong>.',
    confirmation: 'Souhaitez-vous annuler la dérogation et réinitialiser la consigne {{type}} ?',
    value_lighting: 'La pièce est actuellement {{value}}.',
    type_heating: 'de chauffage',
    type_lighting: "d'éclairage",
  },
  until: "jusqu'au",
  onTotalOf: 'sur un total de',
  onTotalOfFiltered: 'sur un total de (filtré)',
  alertsExceptBattery: 'Alertes (hors batterie faible)',
  batteryAlerts: 'Alertes batterie faible',
  markAsDone: 'Clôturer',
  logMarkAsDoneSuccess: 'Main courante clôturée avec succès',
  logMarkAsDoneError: 'Erreur lors de la clôture de la main courante',
  consumption: 'Consommation',
  editDjuMonthlySuccess: 'DJU modifiés avec succès',
  editDjuMonthlyError: 'Erreur lors de la modification des DJU',
  consumptionEditSuccess: 'Consommation modifiée avec succès',
  consumptionEditError: 'Erreur lors de la modification de la consommation',
  addYear: 'Ajouter une année',
  importDjuMonthlySuccess: 'DJU importé avec succès',
  importDjuMonthlyError: "Erreur lors de l'importation du DJU",
  importDjuMonthlyLoading: 'Importation du DJU en cours...',
  hideDjuValues: 'Masquer le DJU',
  showDjuValues: 'Afficher le DJU',
  editDjuValues: 'Modifier le DJU',
  doYouWantToAutoFillDjuValues: 'Voulez-vous importer automatiquement les valeurs du DJU ?',
  importDju: 'Importer le DJU',
  doYouWantToManuallyFillDjuValues: 'Voulez-vous renseigner manuellement les valeurs du DJU ?',
  manualInput: 'Renseigner manuellement',
  everyFieldIsRequired: 'Chaque champ est obligatoire',
  noDjuForYear: "aucun DJU pour l'année en question n'a été renseigné. Veuillez l'importer afin d'avoir accès aux données deconsommation normalisées.",
  dataConsumptionBasedOnOuisenseData: 'données de consommation par défaut basées sur les relevés de Ouisense.',
  addConsumptionYear: 'Ajouter une année de consommation',
  chooseYear: "Choisir l'année",
  climaticRigour: 'Rigueur climatique',
  addDju: 'Ajouter un DJU',
  validation: 'Validation',
  import: 'Import',
  pleaseInputClimaticRigourForAllMonths: "Veuillez renseigner la <strong>rigueur climatique</strong> (DJU) pour tous les mois de l'année {{year}}.",
  pleaseInputConsumptionForAllMonths: "Veuillez renseigner votre <strong>consommation</strong> ({{unit}}) pour tous les mois de l'année {{year}}.",
  noCompanySettingsError:
    "Votre organisation ne dispose pas des paramètres nécessaires pour afficher les données de confort. Veuillez contacter l'administrateur de votreorganisation.",
  noDeviceForSpaceError: "Aucun capteur n'est associé à cette pièce. Veuillez contacter l'administrateur de votre organisation.",
  dataLast3HoursBasedOnSetPoint: 'Données calculées sur les 3 dernières heures sur la base de la consigne définie par le <Link>calendrier de consignes</Link>.',
  dataLast3Hours: 'Données calculées sur les 3 dernières heures.',
  comfortRangeBasedOnSetPoint: 'La zone de confort est calculée en fonction du point de consigne (dans un delta de -{{min}} °C et +{{max}} °C).',
  editConsumptionYear: "Modifier l'année de consommation {{year}}",
  month: 'Mois',
  pleaseSelectAValidDateRange: 'Veuillez sélectionner une période valide',
  editReferenceYearSuccess: 'Année de référence modifiée avec succès',
  editReferenceYearError: "Erreur lors de la modification de l'année de référence",
  editDju: 'Modifier le DJU',
  pleaseSelectReferenceYear: "Veuillez sélectionner l'année qui servira de référence aux calculs de consommation.",
  noAvailableYearPleaseAddDju: 'Aucune année disponible. Veuillez ajouter un DJU.',
  currentReferenceYear: 'Année de référence actuelle: ',
  energyType: 'Type d’énergie',
  meter: 'Compteur',
  subMeter: 'Sous-compteur',
  shortMonths: {
    january: 'Jan',
    february: 'Fév',
    march: 'Mar',
    april: 'Avr',
    may: 'Mai',
    june: 'Juin',
    july: 'Juil',
    august: 'Aoû',
    september: 'Sep',
    october: 'Oct',
    november: 'Nov',
    december: 'Déc',
  },
  frostProtection: 'Hors gel',
  percentageFrostProtection: '% hors gel',
  comfortStatusDescription:
    'calculé à partir de la température de la pièce et des zones de confort définies en paramètres, le statut indique si la pièce était en-dessous, au-dessus ou dans la zone de confort, ou si la consigne était en-dessous du seuil de protection antigel.',
  percentageComfortDescription: "pourcentage de temps durant lequel la pièce s'est trouvée dans la zone de confort.",
  percentageHotDescription: 'pourcentage de temps durant lequel la température de la pièce était au-dessus de la zone de confort.',
  percentageColdDescription: 'pourcentage de temps durant lequel la température de la pièce était en-dessous de la zone de confort.',
  percentageFrostProtectionDescription: 'pourcentage de temps durant lequel la consigne de la pièce était en-dessous du seuil de protection antigel (16°C).',
  spacesAssignment: 'Assignation des pièces',
  hourZonesDefinition: 'Définition des plages horaires',
  schedule: 'Calendrier',
  scheduleDetails: 'Détails du calendrier',
  summary: 'Résumé',
  chart: 'Graphique',
  available_one: 'disponible',
  available_other: 'disponibles',
  floor_one: 'étage',
  floor_other: 'étages',
  space_one: 'pièce',
  space_other: 'pièces',
  selected_fem_one: 'sélectionnée',
  selected_fem_other: 'sélectionnées',
  selected_masc_one: 'sélectionné',
  selected_masc_other: 'sélectionnés',
  calendarTemperatureStepError: 'La consigne doit être un entier ou avoir une valeur décimale de {{step}}°C',
  noDju: 'DJU manquant',
  toDefined: 'à définir',
  pleaseSelectionAComparisonRange: 'Veuillez sélectionner une période de comparaison.',
  periodToCompare: 'Période à comparer',
  comparisonPeriod: 'Période de comparaison',
  current_masc: 'Actuel',
  spaceAssignScheduleSuccess: 'Pièce associée au calendrier avec succès',
  spaceAssignScheduleError: "Erreur lors de l'association de la pièce au calendrier",
  spaceReassignScheduleSuccess: 'Pièce réassociée au calendrier avec succès',
  spaceReassignScheduleError: 'Erreur lors de la réassociation de la pièce au calendrier',
  assignSpaceToSchedule: 'Sélectionner un nouveau calendrier à associer à la pièce',
  assignSpaceToSelectedSchedule: 'Associer la pièce au calendrier sélectionné',
  unassignSpace: 'Désassocier la pièce du calendrier',
  unassignSpaceWarning: 'Êtes-vous sûr de vouloir désassocier la pièce <strong>{{spaceName}}</strong> du calendrier <strong>{{scheduleName}}</strong> ?',
  spaceUnassignScheduleSuccess: 'Pièce désassociée du calendrier avec succès',
  spaceUnassignScheduleError: 'Erreur lors de la désassociation de la pièce du calendrier',
  spaceUnassignScheduleTooltip:
    'Impossible de désassocier la pièce du calendrier car celui-ci ne contient qu’une seule pièce. Veuillez d’abord associer une autre pièce à ce calendrier ou supprimer le calendrier.',
  editFloorPlan: 'Modifier le plan de l’étage',
  replaceFloorPlanDialog: {
    title: 'Impossible de remplacer le plan',
    description: "Vous ne pouvez pas télécharger un nouveau plan tant que des pièces sont associées. Veuillez d'abord supprimer toutes les pièces.",
  },
  replaceFloorPlan: 'Remplacer le plan',
  uploadFloorPlan: 'Charger un plan (png/pdf)',
  erase: 'Effacer',
  select: 'Sélectionner',
  confirmChanges: 'Confirmer les modifications',
  cancelChanges: 'Annuler les modifications',
  image: 'Image',
  settings: 'Paramètres',
  spaceOpacity: 'Opacité de la pièce',
  zoomSensitivity: 'Sensibilité du zoom',
  zoomSensitivityDescription: 'Plus bas = plus rapide · Plus élevé = plus lent',
  imageOpacity: 'Opacité du plan',
  defaultZoom: 'Zoom par défaut',
  defaultZoomDescription: "Niveau de zoom initial à l'ouverture du plan",
  defaultZoomAuto: 'Auto',
  tooltipMinWidth: 'Largeur min. des étiquettes',
  floorPlanCard: {
    setpoint: 'Csg',
    vsSetpoint: 'vs Csg',
    mode: 'Mode',
    modeHeat: 'Chauffage',
    modeCool: 'Refroidissement',
    state: 'État',
    on: 'Marche',
    off: 'Arrêt',
    day: 'Jour',
    night: 'Nuit',
    dayShort: 'J',
    nightShort: 'N',
    seeMore: 'Voir plus',
    seeLess: 'Réduire',
    detail: 'Détail',
    states: 'États',
    faults: 'Défauts',
    noData: 'sans donnée',
    noRecentData: 'Aucune donnée récente',
    outOf: 'sur',
    activeFaults_one: 'défaut actif',
    activeFaults_other: 'défauts actifs',
    points_one: 'point',
    points_other: 'points',
    lastReading: 'Dernière température relevée',
    noReading24h: 'Aucun relevé sur les dernières 24 h',
    hotWater: 'Eau chaude sanitaire (ECS)',
    coldWater: 'Eau froide sanitaire (EFS)',
    blendedWater: 'Eau mitigée (mélange ECS / EFS)',
    density: 'Densité des étiquettes',
    densityDescription:
      "Auto : chaque zone affiche l'étiquette la plus riche qui tient dans son contour au zoom courant, et la recalcule à chaque zoom. Par défaut : Auto sur les plans de confort, Complètes sur les autres.",
    densityAuto: 'Auto',
    densityChip: 'Puces',
    densityCompact: 'Compactes',
    densityFull: 'Complètes',
  },
  shrink: 'Réduire',
  rotate: 'Pivoter',
  scale: 'Redimensionner',
  trim: 'Rogner',
  dimensions: 'Dimensions',
  revert: 'Rétablir',
  redo: 'Refaire',
  editRoom: 'Modifier la pièce',
  currentTemp: 'T° actuelle',
  currentSetPoint: 'Csg actuelle',
  setpoint: 'Consigne',
  noRoomsMatch: 'Aucune pièce trouvée',
  apply: 'Appliquer',
  floorPlanLoaded: 'Plan chargé',
  noFloorPlan: 'Aucun plan',
  noRoomSelected: 'Aucune pièce sélectionnée',
  eraser: 'Gomme',
  crop: 'Recadrer',
  cancelCrop: 'Annuler le recadrage',
  confirmCrop: 'Confirmer le recadrage',
  readOnly: 'Lecture seule',
  editing: 'Édition',
  deleteAllRooms: 'Supprimer toutes les pièces',
  deleteRoomDialog: {
    title: 'Supprimer la pièce',
    description: 'Cette action est irréversible. La pièce sera définitivement supprimée.',
    confirm: 'Supprimer',
  },
  deleteAllRoomsDialog: {
    title: 'Supprimer toutes les pièces',
    description: 'Cette action est irréversible. Toutes les pièces seront définitivement supprimées.',
    confirm: 'Tout supprimer',
  },
  deletePlanDialog: {
    title: 'Supprimer le plan',
    description: 'Cette action est irréversible. Le plan et toutes les pièces associées seront définitivement supprimés.',
    confirm: 'Supprimer le plan',
  },
  confirmLeaveDialog: {
    title: 'Modifications non enregistrées',
    description: 'Vous avez des modifications non enregistrées. Si vous quittez cette page, elles seront perdues.',
    stay: 'Rester sur la page',
    leave: 'Quitter sans enregistrer',
  },
  createSiblingSlotDialog: {
    title: 'Créer le créneau d’éclairage manquant ?',
    description:
      'Cet espace possède un créneau d’éclairage non assigné. Voulez-vous créer automatiquement une pièce avec la même forme à cet emplacement pour le créneau manquant ?',
    confirm: 'Oui, créer',
    decline: 'Non, creuser uniquement',
  },
  avgTemp: 'T° moy',
  avgSetPoint: 'Csg moy',
  roomType: {
    office: 'Bureau',
    room: 'Chambre',
  },
  polygon: 'Polygone',
  rectangle: 'Rectangle',
  comfortable_one: 'confortable',
  comfortable_other: 'confortables',
  lightingBucket: {
    dayLit: 'Allumé (jour)',
    nightLit: 'Allumé (nuit)',
  },
  electricalFaultBucket: {
    fault: 'En défaut',
    ok: 'OK',
    noData: 'Sans donnée',
  },
  electricalStateBucket: {
    on: 'On',
    off: 'Off',
  },
  electricalFaultCard: {
    noRecentData: 'Aucune donnée récente',
    points: 'Points',
    faultsGroup: 'Défauts',
    statesGroup: 'États',
    activeFaults_one: '{{count}} défaut actif sur {{total}} points',
    activeFaults_other: '{{count}} défauts actifs sur {{total}} points',
    noData: 'Sans donnée',
    moreItems: '+{{count}} autres',
    clickForDetail: 'Cliquer pour le détail',
    history: 'Historique',
    selectPoint: 'Sélectionnez un point pour afficher son historique.',
  },
  alarmCategory: {
    heatingCoolingCircuit: 'Circuits de chauffage / froid',
    boiler: 'Chaudière',
    hotWater: 'ECS',
    cta: 'CTA',
    electricalBoard: 'TD',
    medicalFluid: 'Fluides médicaux',
    chiller: 'Groupe froid',
    heatPump: 'PAC',
    vrv: 'VRV',
    battery: 'Batterie',
    other: 'Autre',
  },
  alarms: {
    title: 'Alertes en cours',
    defaultsTitle: 'Défauts en cours',
    ongoingAlarms: 'Alertes en cours',
    historyTitle: 'Historique des alertes',
    noOngoingAlarm: 'Aucune alerte en cours',
    noHistory: 'Aucune alerte sur la période',
    unattachedPoints: 'Points non rattachés',
    noLocation: 'Sans localisation',
    pointsState: 'État des points',
    noFaultPoint: 'Aucun point de défaut',
    lastSeenAt: 'Dernière remontée : {{date}}',
    alarmCount_one: '{{count}} alerte',
    alarmCount_other: '{{count}} alertes',
    defaultCount_one: '{{count}} défaut',
    defaultCount_other: '{{count}} défauts',
    faultPointCount_one: '{{count}} point de défaut surveillé',
    faultPointCount_other: '{{count}} points de défaut surveillés',
    configuredCount_one: '{{count}} alerte configurée',
    configuredCount_other: '{{count}} alertes configurées',
    equipmentCount_one: '{{count}} équipement',
    equipmentCount_other: '{{count}} équipements',
    pointCount_one: '{{count}} point',
    pointCount_other: '{{count}} points',
    ok: 'OK',
    sinceDuration: 'depuis {{duration}}',
    point: 'Point',
    appeared: 'Apparue',
    disappeared: 'Disparue',
    duration: 'Durée',
    category: 'Catégorie',
    categoryAll: 'Toutes les catégories',
    categorySelected: 'catégories sélectionnées',
  },
  ofTotal: 'du total',
  unsavedChanges: 'Vous avez des modifications non enregistrées',
  editImage: 'Modifier l’image',
  drawPolygon: 'Dessiner un polygone',
  drawRectangle: 'Dessiner un rectangle',
  editRoomShapes: 'Modifier les contours des pièces',
  editRoomCards: 'Modifier les étiquettes',
  deleteRooms: 'Supprimer les pièces',
  floorPlanSelect: 'Sélection du plan',
  renderingPages: 'Chargement des pages',
  page: 'Page',
  loadingPDF: 'Chargement du PDF',
  floorPlanLoadedSuccess: 'Plan chargé avec succès',
  floorPlanLoadedError: 'Erreur lors du chargement du plan',
  roomDetection: {
    offerTitle: 'Détecter les pièces automatiquement ?',
    offerDescription:
      'Les noms des pièces sont lus sur le plan et comparés aux {{count}} pièces de cet étage ; le contour de chaque pièce reconnue est tracé et affecté. Les pièces non reconnues se placent ensuite d’un clic.',
    detect: 'Détecter',
    later: 'Plus tard',
    detectByClick: 'Détecter une pièce d’un clic',
    inProgress: 'Détection des pièces',
    reading: 'Lecture des noms sur le plan…',
    detecting: 'Tracé des contours…',
    allPlaced: '{{count}} pièces placées',
    somePlaced: '{{count}} pièces placées, {{remaining}} à placer d’un clic',
    nonePlaced: 'Aucun nom de pièce reconnu sur le plan : placez les pièces d’un clic',
    noRoom: 'Aucune pièce fermée autour de ce point',
    leak: 'Cet espace est ouvert sur le reste du plan : dessinez son contour à la main',
    failed: 'La détection a échoué',
  },
  spacesEditedSuccess: 'Modifications des pièces réussies',
  spacesEditedError: 'Erreur lors de la modification des pièces',
  deleteFloorPlan: 'Supprimer le plan',
  floorPlanDeletedSuccess: 'Plan supprimé avec succès',
  floorPlanDeletedError: 'Erreur lors de la suppression du plan',
  floorPlanNotFound: 'Plan non trouvé',
  spaceSelection: 'Sélection de la pièce',
  selectSpace: 'Sélectionner une pièce',
  selectSlot: "Créneau d'éclairage",
  lightDay: 'Jour',
  lightNight: 'Nuit',
  reassign: 'Réaffecter',
  confirmStealSpace: {
    title: 'Pièce déjà assignée',
    description: 'La pièce "{{name}}" est déjà assignée à un autre polygone. Ce polygone sera supprimé si vous continuez.',
  },
  noRoomsYet: 'Aucune pièce disponible',
  assignedRooms: 'Pièces affectées',
  unassignedRooms: 'Pièces non affectées',
  unassignedRoomHint: 'Dessinez une zone sur le plan pour affecter cette pièce',
  useToolbarToAddRooms: 'Utilisez la barre d’outils pour ajouter des pièces.',
  toGetStarted: 'pour commencer',
  upload: 'Charger',
  holePolygon: 'Trou (poly)',
  holeRectangle: 'Trou (rect)',
  drawHolePolygon: 'Dessiner un trou (poly)',
  drawHoleRectangle: 'Dessiner un trou (rect)',
  noFloorPlanForThisLocation: 'Aucun plan disponible pour cet emplacement.',
  noSensorOnPlan: 'Aucun capteur localisé sur un étage.',
  waterType: {
    hot: 'Eau chaude sanitaire (ECS)',
    cold: 'Eau froide sanitaire (EFS)',
    blended: 'Eau mitigée',
  },
  sensorPlanCard: {
    identity: 'Informations',
    history: 'Historique de température',
    equipmentType: "Type d'équipement",
    waterType: 'Réseau',
    openEquipment: "Voir la fiche de l'équipement",
    noRecentReading: 'Aucun relevé récent',
    noData: 'Aucune donnée sur la période sélectionnée',
    unknownWaterType: 'Non renseigné',
    sensors_one: 'capteur',
    sensors_other: 'capteurs',
  },
  configureFloorPlan: 'Configurer le plan de l\u2019étage',
  howToDrawPolygonLabel: 'Dessiner un polygone',
  howToDrawPolygonDesc: 'Icône polygone → placez les points → cliquez sur le premier pour fermer',
  howToEditShapeLabel: 'Modifier la forme',
  howToEditShapeDesc: 'Modifier les calques → glissez les sommets pour remodeler',
  howToDeleteRoomLabel: 'Supprimer une pièce',
  howToDeleteRoomDesc: 'Supprimer les calques → cliquez sur la forme à supprimer',
  howToSelectRoomLabel: 'Sélectionner une pièce',
  howToSelectRoomDesc: 'Cliquez sur une forme pour modifier ses propriétés',
  scheduleType: {
    heating: 'Radiateur',
    lighting: 'Éclairage',
    cta: 'CTA',
    ctaSpeed: 'Vitesse',
    ctaPressure: 'Pression',
    ctaCo2: 'CO2',
    ctaReturnTempSetpoint: 'Température',
    vrv: 'VRV / Ventilo',
    heatedFloor: 'Plancher chauffant',
    temperature: 'Température',
    authorizedOff: 'Autorisation occupant ON/OFF',
    authorizedOffOn: 'Autorisé',
    authorizedOffOff: 'Non autorisé',
  },
  calendarType: 'Type de calendrier',
  available: 'Disponible',
  lighting: 'Éclairage',
  turnedOn_masc_one: 'allumé',
  turnedOn_masc_other: 'allumés',
  turnedOn_fem_one: 'allumée',
  turnedOn_fem_other: 'allumées',
  turnedOff_masc_one: 'éteint',
  turnedOff_masc_other: 'éteints',
  turnedOff_fem_one: 'éteinte',
  turnedOff_fem_other: 'éteintes',
  nextLightChangeAt: 'Prochain changement : {{state}} à {{hour}}h (dans {{delta}})',
  nextLightChangeNone: "Aucun changement prévu aujourd'hui",
  nextSetPointChangeAt: 'Prochain changement : {{value}} à {{hour}}h (dans {{delta}})',
  nextSetPointChangeNone: "Aucun changement prévu aujourd'hui",
  evolution: 'Évolution',
  nbSpaces: 'Nb de pièces',
  machineDiagram: {
    zoom: {
      zoomIn: 'Zoom avant',
      zoomOut: 'Zoom arrière',
      resetZoom: 'Réinitialiser le zoom',
      fullscreen: 'Plein écran',
      exitFullscreen: 'Quitter le plein écran',
      menu: 'Niveau de zoom',
      resetView: 'Réinitialiser la vue',
      shortcutEnter: 'Entrée',
      fitContent: 'Ajuster au dessin',
      fitPageWidth: 'Ajuster à la largeur de la page',
      fitPage: 'Ajuster à la page',
    },
    // Libellés de refs propres au synoptique, qui l'emportent sur equipment.equipmentNames (cf.
    // equipmentRefLabel). Le vocabulaire du dessin technique est plus précis que celui des listes
    // d'équipements du reste de l'application, où le même ref se lit dans un autre contexte.
    equipmentRefOverrides: {
      damper: 'Registre air neuf',
      damperManualAuto: 'Registre air neuf - Manuel/Auto',
    },
    ctaType: {
      ctaAmbient: 'Ambiance CTA',
      ctaBlowing: 'Soufflage CTA',
      ctaRecovery: 'Reprise CTA',
      defaultAdditionalExtractor: 'Défaut extracteur additionnel',
      defaultCtaAirFlow: "Défaut débit d'air",
      defaultCtaAntifreeze: 'Défaut antigel',
      defaultCtaBlowing: 'Défaut CTA soufflage',
      defaultCtaCriticalAlarm: 'Alarme critique',
      defaultCtaElec: 'Défaut batterie électrique',
      defaultCtaElectricBatteryOverHeating: 'Défaut surchauffe batterie électrique',
      defaultCtaFire: 'Défaut incendie',
      defaultCtaRecovery: 'Défaut CTA reprise',
      defaultCtaSmoke: 'Défaut détection de fumées',
      defaultFilterBlowing: 'Défaut filtre soufflage',
      defaultFilterRecovery: 'Défaut filtre reprise',
      defaultComAirAmbient: 'Défaut COM T° air ambiant',
      defaultComAirIn: 'Défaut COM T° air neuf',
      defaultComAirOut: 'Défaut COM T° air rejeté',
      defaultComAntifreeze: 'Défaut COM antigel',
      defaultComBlowing: 'Défaut COM soufflage',
      defaultComCo2: 'Défaut COM CO2',
      defaultComFlowBlowing: 'Défaut COM débit soufflage',
      defaultComFlowRecovery: 'Défaut COM débit reprise',
      defaultComHumidityAmbient: 'Défaut COM humidité ambiance',
      defaultComHumidityBlowing: 'Défaut COM humidité soufflage',
      defaultComHumidityRecovery: 'Défaut COM humidité reprise',
      defaultComPressureBlowing: 'Défaut COM pression soufflage',
      defaultComPressureRecovery: 'Défaut COM pression reprise',
      defaultComRecovery: 'Défaut COM reprise',
    },
    history: {
      undo: 'Annuler',
      redo: 'Rétablir',
    },
    toolbar: {
      openLeftSidebar: 'Ouvrir la barre des composants',
      closeLeftSidebar: 'Fermer la barre des composants',
      openRightSidebar: 'Ouvrir le panneau de propriétés',
      closeRightSidebar: 'Fermer le panneau de propriétés',
      duplicate: 'Dupliquer la sélection',
      delete: 'Supprimer la sélection',
      bringToFront: 'Mettre au premier plan',
      sendToBack: "Mettre à l'arrière-plan",
    },
    equipmentsPanel: {
      title: 'Équipements',
      search: 'Chercher un équipement…',
      empty: "Aucun point n'est encore lié aux composants de ce synoptique.",
    },
    propertiesPanel: {
      styleTab: 'Style',
      configTab: 'Réglages',
      backToEquipments: 'Retour à la liste des équipements',
    },
    editor: {
      linePlaceFirstAnchor: 'Cliquez pour poser la première ancre de la ligne',
      linePlaceNextAnchor: 'Cliquez pour ajouter une ancre — double-clic ou Entrée pour terminer',
      lineCancel: 'Annuler le tracé de ligne',
      shapeDrawHint: 'Cliquez-glissez pour dessiner la forme — Maj pour contraindre',
      shapeCancel: 'Annuler le tracé de la forme',
      anchorSupply: 'Départ',
      anchorReturn: 'Retour',
    },
    viewer: {
      reset: 'Réinitialiser',
      add: 'Ajouter',
      noEquipment: 'Aucun équipement. Cliquez sur « Ajouter ».',
      equipmentRefPlaceholder: 'Aucun équipement',
      // Nom d'instance d'un point d'extracteur additionnel simulé ; sans nom, la clé reste brute (extracteur seul).
      noInstance: '— Sans nom d’instance —',
      show: 'Afficher',
      hide: 'Masquer',
      delete: 'Supprimer',
      valuePlaceholder: 'Valeur',
      true: 'Vrai',
      false: 'Faux',
      faultOk: 'OK (0)',
      faultPresent: 'Défaut (1)',
      kpi: {
        supervisionCommand: 'Commande supervision',
        airFlowFault: "Défaut débit d'air",
        antifreezeFault: 'Défaut antigel',
        criticalAlarmFault: 'Alarme critique',
        inFault: 'En défaut',
        ok: 'OK',
        on: 'ON',
        off: 'OFF',
        regulationOn: 'Régulation sur',
        blowing: 'Soufflage',
        recovery: 'Reprise',
      },
    },
    // Bouton de filtre des barres latérales (composants à gauche, équipements à droite).
    filter: {
      label: 'Filtrer',
      showAll: 'Tout afficher',
    },
    library: {
      search: 'Chercher...',
      createComponent: 'Créer un composant',
      builtinComponent: 'Composant par défaut (non modifiable)',
      editCustomComponent: 'Modifier ce composant custom',
      statusCard: 'Carte d’état',
      verticalGauge: 'Jauge verticale',
      badge: 'Badge',
      textBox: 'Zone de texte',
      familyWidgets: 'Widgets',
      familyBoilerRoom: 'Chaufferie',
      familyCta: 'CTA',
      familyGeneral: 'Général',
      familyCustom: 'Personnalisés',
      familyDrawing: 'Dessin',
      line: 'Ligne',
      arrow: 'Flèche',
      airFlow: 'Flux d’air',
      pipeHot: 'Tuyau chaud',
      pipeCold: 'Tuyau froid',
      pipeChangeover: 'Tuyau changeover',
      rectangle: 'Rectangle',
      ellipse: 'Ellipse',
      deleteCustomComponent: 'Supprimer ce composant',
    },
    // Sauvegarde d'une sélection comme composant « groupe » réutilisable.
    saveGroup: {
      action: 'Enregistrer comme composant',
      title: 'Enregistrer comme composant',
      count_one: '{{count}} élément sera enregistré',
      count_other: '{{count}} éléments seront regroupés',
      nameLabel: 'Nom du composant',
      namePlaceholder: 'Ex. Cartouche registre + voyant',
      cancel: 'Annuler',
      save: 'Enregistrer',
    },
    valueCondition: {
      label: 'Affiché si',
      title: "Restreint l'affichage à cet état du point ; sans condition, la présence du point suffit",
      valuePlaceholder: 'Valeur',
      operatorEq: 'égal à',
      operatorNe: 'différent de',
      operatorGt: 'supérieur à',
      operatorGte: 'supérieur ou égal à',
      operatorLt: 'inférieur à',
      operatorLte: 'inférieur ou égal à',
      faultPresent: 'Défaut présent',
      faultAbsent: 'Pas de défaut',
    },
    conditions: {
      and: 'ET',
      noEquipment: 'Aucun équipement',
      anyValue: '— Toute valeur —',
      removeCondition: 'Retirer cette condition',
      addConditionTitle: "Ajouter une condition d'équipement (ET)",
      addConditionAriaLabel: "Ajouter une condition d'équipement",
      ctaFaultType: 'Type défaut CTA',
      ctaFaultTypeTitle: 'Type de défaut CTA',
      typePlaceholder: '— Type —',
      valueCondition: 'Condition de valeur pour {{ref}}',
      // Phrase de synthèse sous les conditions de visibilité ; `andWord` relie les équipements listés.
      alwaysVisible: 'Le composant sera toujours visible.',
      visibleIf_one: 'Le composant sera visible si l’équipement {{equipments}} est remonté.',
      visibleIf_other: 'Le composant sera visible si les équipements {{equipments}} sont remontés.',
      andWord: 'et',
      // Composant à instances (extracteur additionnel) : l'instance choisie tient lieu de condition.
      visibleIfInstance: 'Le composant sera visible si « {{instance}} » est remonté.',
      visibleIfAnyInstance: 'Le composant sera visible dès qu’un équipement est remonté — le premier trouvé s’il y en a plusieurs.',
    },
    customDialog: {
      stepComponents: 'Composants',
      stepConditions: 'Conditions',
      stepName: 'Nom',
      editTitle: 'Modifier le composant custom',
      createTitle: 'Créer un composant custom',
      noComponentSelected: 'Aucun composant sélectionné.',
      nameLabel: 'Nom du composant custom',
      namePlaceholder: 'Ex. Registre + voyant défaut',
      previous: 'Précédent',
      save: 'Enregistrer',
      create: 'Créer',
      next: 'Suivant',
    },
    footer: {
      all: 'Tous',
      statusCard: 'Carte d’état',
      gauge: 'Gauge',
      badge: 'Badge',
      textBox: 'Zone de texte',
      editCustomComponent: 'Modifier le composant custom',
      showOnCanvas: 'Afficher sur le canvas',
      hideFromCanvas: 'Masquer du canvas',
      visibility: 'Visibilité',
      resetSize: 'Taille native',
      rotate: 'Rotation +90°',
      flipHorizontal: 'Flip horizontal',
      flipVertical: 'Flip vertical',
      showHeader: 'Afficher le bandeau',
      headerColor: 'Couleur du bandeau',
      headerColorAuto: 'Automatique',
      flowHeaderColors: 'Couleur par flux',
      flowHeaderColorsHint: 'Désactivé : la couleur choisie est déclinée, pleine sur le premier flux, pâle sur le second.',
      headerColors: {
        blue: 'Bleu',
        green: 'Vert',
        gray: 'Gris',
        orange: 'Orange',
        red: 'Rouge',
        violet: 'Violet',
      },
      compositeLayers: 'Couches composite (px natifs)',
      valueRef: 'EquipmentRef qui fournit la valeur affichée',
      value: 'Valeur',
      // Sélecteur d'instance des composants à instances (extracteur additionnel), à la place des conditions par ref.
      extractorInstance: 'Extracteur',
      extractorInstanceFirst: '— Premier trouvé —',
      extractorInstanceTitle: 'Extracteur additionnel lu par le composant, quand la CTA en porte plusieurs',
      // Zone de texte dynamique : l'instance est requise (sans elle, aucun extracteur n'est désigné).
      extractorInstancePlaceholder: '— Extracteur —',
      dynamicEquipment: 'Équipement',
      fanCardBehaviourHint:
        'Visible si le débit (fanBlowing / fanRecovery) OU le mode du flux (fanBlowingManualAuto / fanRecoveryManualAuto) est remonté. Avec le débit : variateur + jauge. Sans lui : le badge Auto/Manuel passe dans la carte.',
      fanBehaviourHint:
        "Visible si le débit (fanBlowing / fanRecovery) OU le mode du flux (fanBlowingManualAuto / fanRecoveryManualAuto) est remonté. L'hélice tourne sauf si le ventilateur est à l'arrêt.",
      line: 'Ligne',
      lineAnchors: '{{count}} ancres',
      deleteLine: 'Supprimer la ligne',
      textContent: 'Texte',
      textContentPlaceholder: 'Saisissez un texte libre…',
      componentLabel: 'Libellé',
      componentLabelPlaceholder: 'Libellé affiché au-dessus (optionnel)…',
      shape: {
        rect: 'Rectangle',
        ellipse: 'Ellipse',
      },
    },
    // Types de zone de texte (cf. TextBoxKind) : personnalisée (texte libre), dynamique (valeur d'un
    // équipement) ou défaut pompe (compteur de défauts sur ref figé).
    // Sélecteur de type d'une carte d'état, posé au-dessus des onglets du panneau de propriétés : une
    // carte posée depuis les widgets n'a pas encore de type, et n'affiche donc rien tant qu'il manque.
    statusCardType: {
      placeholder: 'Choisir un type',
      hint: 'Choisissez d’abord un type de carte pour régler ses équipements.',
    },
    badgeType: {
      placeholder: 'Choisir un type',
      hint: 'Choisissez d’abord un type de badge pour régler ses équipements.',
      pumpMode: 'Mode pompe',
      pumpModeHint:
        'Point non saisi : manualAutoPump, ou pumpManualAuto sous une distribution chauffage, changeover ou froid — posé à la génération de la chaufferie.',
    },
    textBoxKind: {
      label: 'Type',
      custom: 'Personnalisé',
      dynamic: 'Dynamique',
      pump: 'Défaut pompe',
      dynamicHint: 'Affiche le nom de l’équipement choisi (equipmentName). Une condition de valeur, dans Visibilité, limite l’affichage à un état donné.',
      pumpHint:
        'Affiche le nombre de défauts de pompe (defaultPump) et n’apparaît qu’en présence d’au moins un défaut. Contenu et équipements figés : seul le style s’édite.',
    },
    // Pastilles ON/OFF posées par-dessus un composant : chaque volute de la pompe double, le coin de
    // l'extracteur d'air (cf. OnOffBadge).
    onOffBadge: {
      on: 'On',
      off: 'Off',
    },
    // Badge Marche/Arrêt du bandeau des modules de chaufferie générée (cf. RunStateBadge).
    statusBadge: {
      running: 'Marche',
      stopped: 'Arrêt',
      auto: 'Auto',
      manual: 'Manuel',
    },
    // Note de fonctionnement du composant pompe double, dans le panneau d'édition.
    pumpInfo: {
      title: 'Fonctionnement',
      refs: 'Les points ne se saisissent pas ici : la pompe lit d’office statePump (marche) et defaultPump (défaut), liés au circuit à la génération du synoptique.',
      hotWater: 'Sur un module d’eau chaude sanitaire, ce sont les points de bouclage qui sont lus : statePumpLoop et defaultPumpLoop.',
      twins:
        'Le composant représente deux pompes jumelées. Les deux équipements d’un même point étant indistinguables, les valeurs vraies sont comptées et attribuées de haut en bas : une seule pompe en marche anime la volute du haut.',
      badges:
        'Un badge On / Off s’affiche près de chaque volute dès que le point de marche est remonté. Sans donnée, aucun badge : la pompe est dessinée à l’arrêt sans que ce soit une mesure.',
      faults: 'Les défauts allument les voyants rouges du dessin. Pour afficher leur nombre, posez une zone de texte de type « Défaut pompe ».',
    },
    // Note de fonctionnement du composant ventilateur de CTA, dans le panneau d'édition. Contrairement à la
    // pompe et à l'extracteur, son point se choisit au-dessus (Soufflage / Reprise) : la note dit ce qu'il
    // déclenche. Les balises <code> sont rendues par ComponentInfoSection (Trans).
    fanInfo: {
      title: 'Fonctionnement',
      flow: 'Le flux se choisit ci-dessus : <code>fanBlowing</code> (soufflage) ou <code>fanRecovery</code> (reprise).',
      rotation: "L'hélice tourne dès que le débit est supérieur à 0, et reste figée à 0.",
      modeFallback:
        "Quand le débit n'est pas remonté, le mode du flux (<code>fanBlowingManualAuto</code> / <code>fanRecoveryManualAuto</code>) prend le relais : seul « Arrêt » fige l'hélice, tous les autres modes (Auto, Réduit, Normal, Boost, Manuel en %) la font tourner.",
      fault:
        'Le voyant du moteur suit le défaut CTA du flux choisi, <code>defaultCta::defaultCtaBlowing</code> ou <code>defaultCta::defaultCtaRecovery</code> : compteur de défauts, 0 = OK, sinon défaut. Il passe au rouge dès le premier.',
      drawing:
        "Sans aucune donnée, le ventilateur est dessiné à l'arrêt, voyant vert : hélice figée et ternie, anneau gris. L'état de marche reste donc lisible sur une capture ou un export, où l'animation disparaît.",
    },
    // Note de fonctionnement du composant extracteur d'air de CTA, dans le panneau d'édition. Les balises
    // <code> sont rendues par ComponentInfoSection (Trans) : elles mettent en évidence les clés d'état lues.
    extractorInfo: {
      title: 'Fonctionnement',
      refs: "Les points ne se saisissent pas ici : l'extracteur lit d'office deux clés d'état, fixées par le composant. Quand la CTA porte plusieurs extracteurs, celui qui est lu se choisit ci-dessus ; sans choix, le premier remonté.",
      stateKey: "<code>stateAdditionalExtractor</code> : booléen, vrai = en marche. L'hélice tourne tant qu'il est vrai.",
      faultKey:
        "<code>defaultCta::defaultAdditionalExtractor</code> : compteur de défauts, 0 = OK, sinon défaut. Le voyant passe au rouge dès le premier ; si ce point n'est pas remonté, il n'est pas dessiné.",
      drawing: "Sans donnée, l'extracteur est dessiné à l'arrêt, sans voyant.",
    },
    pipeChangeoverInfo: {
      title: 'Fonctionnement',
      mode: "La couleur du tuyau n'est pas un réglage : elle suit le mode de la CTA, lu sur <code>changeoverManualAuto</code>.",
      heating: 'Mode <code>Chauffage</code> : le tuyau est rouge.',
      cooling: 'Mode <code>Refroidissement</code> : le tuyau est bleu.',
      auto: 'Tout autre mode (<code>Auto</code>), ou point non remonté : le tuyau reste rouge. Il ne disparaît jamais — une canalisation manquante laisserait un trou dans le synoptique.',
      style:
        "La section « Style » n'expose donc ni couleur ni style réactif, qui déferaient cette bascule. Restent l'épaisseur, le style de ligne, les flèches et le plan (z).",
    },
    // Habillage des boîtes du synoptique (status cards, zones de texte), cf. SurfaceStyleControls.
    surface: {
      fill: 'Fond',
      fillNone: 'Aucun',
      fillWhite: 'Blanc',
      fillGlass: 'Verre dépoli',
      fillOpacity: 'Opacité du fond',
      radius: 'Arrondi des coins',
      border: 'Bordure',
      shadow: 'Ombre',
    },
    // Contrôles de style de dessin (formes, lignes, texte).
    style: {
      title: 'Style',
      stroke: 'Contour',
      fill: 'Remplissage',
      none: 'Aucun',
      cornerRadius: 'Rayon des angles',
      arrowStart: 'Flèche au départ',
      arrowEnd: 'Flèche à l’arrivée',
      routingStraight: 'Trait droit (sans coude)',
      // Libellés des contrôles de trait, affichés au-dessus de chacun dans le panneau d'édition.
      strokeWidth: 'Épaisseur',
      strokeDash: 'Trait',
      arrows: 'Flèches',
      routing: 'Tracé',
      format: 'Mise en forme',
      alignment: 'Alignement',
      fontSize: 'Taille',
      bold: 'Gras',
      italic: 'Italique',
      alignLeft: 'Aligner à gauche',
      alignCenter: 'Centrer',
      alignRight: 'Aligner à droite',
      color: {
        label: 'Couleur',
        neutral: 'Neutre',
        ink: 'Encre',
        hot: 'Chaud',
        cold: 'Froid',
        chilled: 'Départ eau froide',
        chilledReturn: 'Retour eau froide',
        ok: 'OK',
        warning: 'Alarme',
      },
      dash: {
        solid: 'Plein',
        dashed: 'Tirets',
        dotted: 'Points',
      },
      // Mode « flux d'air » d'une ligne : bande dégradée avec pointe, suivant le tracé de la ligne.
      flow: {
        label: 'Flux d’air',
        chaud: 'Air chaud',
        froid: 'Air froid / extérieur',
        repris: 'Air repris',
        width: 'Épaisseur',
        radius: 'Arrondi',
        opacity: 'Opacité',
      },
    },
    // Alignement d'une multi-sélection.
    align: {
      left: 'Aligner à gauche',
      hcenter: 'Centrer horizontalement',
      right: 'Aligner à droite',
      top: 'Aligner en haut',
      vcenter: 'Centrer verticalement',
      bottom: 'Aligner en bas',
    },
    // Surcharges de style conditionnelles (le style réagit à l'état des équipements).
    stateStyles: {
      title: 'Style réactif',
      empty: 'Aucune surcharge. Ajoutez une règle pour faire réagir le style à l’état des équipements.',
      when: 'Règle {{index}}',
      add: 'Ajouter une règle',
      remove: 'Supprimer la règle',
      pulse: 'Clignoter tant que la règle est active',
    },
    statusCardFields: {
      temperature: 'Température',
      humidity: 'Humidité',
      setpoint: 'Consigne',
      mode: 'Mode',
      airDamper: 'Registre',
      mixingAir: 'Caisson de mélange',
      fan: 'Ventilateur',
      flowBlowing: 'Soufflage',
      flowRecovery: 'Reprise',
      batteryChangeover: 'Batterie changeover',
      changeover: 'Changeover',
      changeoverOutput: 'Sortie changeover',
      v3vManualAuto: 'Manuel/Auto',
      v3vOutput: 'Sortie %',
      supplyTemperature: 'Mesure départ',
      supplySetpoint: 'Consigne départ',
      returnTemperature: 'Mesure retour',
      returnSetpoint: 'Consigne retour',
      inletPressure: 'Pression entrée',
      outletPressure: 'Pression sortie',
      showDelta: 'Afficher l’écart',
      flowOrientation: 'Disposition',
      flowSideBySide: 'Départ et retour côte à côte',
      flowStacked: 'Départ au-dessus du retour',
      pumpFaultDefault: 'Point de défaut',
      pumpMode: 'Mode pompe',
      horizontalContent: 'Mesures côte à côte',
      cardDirection: 'Sens de la card',
      gaugeScaleLeft: 'Échelle à gauche, valeur à droite',
      gaugeScaleRight: 'Échelle à droite, valeur à gauche',
    },
    statusCard: {
      temperatureRecovery: 'T reprise',
      temperatureBlowing: 'T soufflage',
      temperature: 'Température',
      temperatureSupply: 'T départ',
      temperatureReturn: 'T retour',
      pressureInlet: 'P entrée',
      pressureOutlet: 'P sortie',
      deltaTemperature: 'ΔT',
      deltaPressure: 'ΔP',
      faultSummary: 'Défauts',
      faultLastCode: 'Code tournant actif alarme',
      heatMeter: 'Compteur',
      waterQuality: 'Qualité de l’eau',
      waterQualityTemperature: 'T bassin',
      waterQualityPh: 'pH',
      waterQualityFreeChlorine: 'Chlore libre',
      waterQualityActiveChlorine: 'Chlore actif',
      pump: 'Pompe',
      pumpNoFault: 'Aucun défaut',
      humidityRecovery: 'H reprise',
      humidityBlowing: 'H soufflage',
      humidity: 'Humidité',
      humidityShort: 'H:',
      modeRecovery: 'Mode reprise',
      modeBlowing: 'Mode soufflage',
      modeCta: 'Mode CTA',
      mode: 'Mode',
      airDamper: 'Registre air neuf',
      airDamperShort: 'Registre',
      mixingAir: 'Caisson de mélange',
      mixingAirShort: 'Caisson mél.',
      recycledAirShort: 'Air repris:',
      freshAirShort: 'Air neuf:',
      fanBlowing: 'Ventilateur de soufflage',
      fanBlowingShort: 'Vent. soufflage',
      fanRecovery: 'Ventilateur de reprise',
      fanRecoveryShort: 'Vent. reprise',
      fan: 'Ventilateur',
      battery: 'Batterie Changeover V3V',
      batteryChangeover: 'Séquence',
      changeover: 'Changeover',
      electricBattery: 'Batterie élec.',
      batteryHot: 'Batterie Chaude V3V',
      batteryCold: 'Batterie Froide V3V',
      v3v: 'V3V',
      pumpFault: 'Défaut pompe',
      pumpFaultCount_one: '{{count}} défaut',
      pumpFaultCount_other: '{{count}} défauts',
      sequence: 'Séquence',
      card: 'Carte d’état',
      temperatureShort: 'T:',
      setpointShort: 'Csg:',
      statusShort: 'Statut:',
      open: 'Ouvert',
      closed: 'Fermé',
      noConfiguration: 'Aucune configuration',
      missingType: 'Type non défini',
      settings: 'Paramètres',
    },
    catalog: {
      temperature: 'Température',
      temperatureSupply: 'T départ',
      temperatureReturn: 'T retour',
      temperatureFlow: 'T départ/retour',
      pressureFlow: 'P entrée/sortie',
      heatMeter: 'Compteur',
      waterQuality: 'Qualité de l’eau Balnéo',
      pump: 'Pompe',
      faultSummary: 'Défauts',
      humidity: 'Humidité',
      mode: 'Mode',
      airDamper: 'Registre air neuf',
      mixingAir: 'Caisson de mélange',
      fan: 'Ventilateur',
      battery: 'Batterie Changeover V3V',
      electricBattery: 'Batterie électrique',
      batteryHot: 'Batterie Chaude V3V',
      batteryCold: 'Batterie Froide V3V',
      v3v: 'V3V',
      pumpFault: 'Défaut pompe',
    },
    componentLabels: {
      airDamperHorizontal: 'Registre Ouvert/Fermé (H)',
      airDamperVertical: 'Registre Ouvert/Fermé (V)',
      airDamperMixingHorizontal: 'Registre mélange (H)',
      airDamperMixingVertical: 'Registre mélange (V)',
      airDamperMixingInvertedHorizontal: 'Registre mélange inversé (H)',
      airDamperMixingInvertedVertical: 'Registre mélange inversé (V)',
      valve3Way: 'V3V',
      decouplingBottle: 'Bouteille de découplage',
      flowSwitch: 'Contrôleur de débit',
      airExtractor: "Extracteur d'air de CTA",
      fanLeft: 'Ventilateur de CTA (G)',
      fanRight: 'Ventilateur de CTA (D)',
      heatPump: 'Pompe à chaleur',
      pumpDouble: 'Pompe double',
      pumpSingle: 'Pompe simple',
      airHot: 'Flux air chaud',
      airCold: 'Flux air froid / extérieur',
      airReturn: 'Flux air repris',
      airHotCold: 'Flux air chaud / froid (selon le mode)',
      antifreeze: 'Sonde antigel',
      antifreezeThermostat: 'Thermostat antigel',
      smokeDetector: 'Détecteur de fumée',
      pressureProbe: 'Sonde de pression',
      temperatureProbe: 'Sonde de température',
      ctaShell: 'Coque de CTA',
      ctaShellCorner: 'Coque de CTA coudée',
      ctaShellSingle: 'Coque de CTA simple',
      variableSpeedDrive: 'Variateur de vitesse',
      forcedRunButton: 'Bouton de marche forcée',
      indicatorGreen: 'Voyant vert',
      indicatorBlue: 'Voyant bleu',
      batteryCold: 'Batterie froide',
      batteryCold2Hot: 'Batterie froid/chaud',
      batteryElectric: 'Batterie électrique',
      batteryHot: 'Batterie chaude',
      bagFilterLeft: 'Filtre à poches (G)',
      bagFilterRight: 'Filtre à poches (D)',
      // Composants retirés de la palette ou internes à un autre composant, encore posés dans des
      // synoptiques existants : ils doivent s'y nommer plutôt qu'exposer leur id.
      fanCasingLeft: 'Caisson de ventilateur (G)',
      fanCasingRight: 'Caisson de ventilateur (D)',
      fanBlades: 'Hélice de ventilateur',
      fanAnimatedLeft: 'Ventilateur animé (G)',
      fanAnimatedRight: 'Ventilateur animé (D)',
      boiler: 'Chaudière',
      chiller: 'Groupe froid',
      plateExchanger: 'Échangeur à plaques',
      dhwTank: 'Ballon ECS',
      co2Probe: 'Sonde CO2',
      humidityProbe: "Sonde d'humidité",
      pressureProbeLegacy: 'Sonde de pression (ancienne)',
    },
    damper: {
      open: 'Ouvert',
      closed: 'Fermé',
    },
    airFlow: {
      detected: "Débit d'air détecté",
      none: "Pas de débit d'air",
    },
    flowSwitch: {
      detected: 'Débit détecté',
      none: 'Pas de débit',
    },
    forcedButton: {
      on: 'Marche',
      off: 'Arrêt',
    },
    // Libellés des voyants de défaut CTA partagés (ref defaultCta), indexés par ctaType.
    faultLabels: {
      defaultAdditionalExtractor: 'Extracteur additionnel',
      defaultCtaAntifreeze: 'Antigel',
      defaultCtaBlowing: 'Disjonction soufflage',
      defaultCtaElectricBatteryOverHeating: 'Surchauffe batterie électrique',
      defaultCtaRecovery: 'Disjonction reprise',
    },
    derogation: {
      label: 'Dérog',
      reset: 'Lever la dérogation',
      resetTooltip: 'Ce point déroge au calendrier. Cliquer pour revenir au calendrier.',
      untilTooltip: 'Dérogation active jusqu’au {{date}}. Cliquer pour revenir au calendrier.',
      resetError: 'Échec de la levée de la dérogation.',
      confirmTitle: 'Lever la dérogation ?',
      confirmMessage: 'Le point reviendra à la valeur définie par son calendrier. Voulez-vous continuer ?',
    },
    calendar: {
      label: 'Calendrier',
      tooltip: 'Ce point est piloté par un calendrier.',
      valueLabel: 'Consigne du calendrier : {{value}}',
    },
    // Acquittement des défauts terrain du régulateur CTA (point ackGroundAlarm). Impulsion : ON puis
    // relâchement du niveau de priorité 30 s plus tard, orchestré côté backend.
    ackGroundAlarm: {
      label: 'Acquitter',
      tooltip: 'Acquitter le défaut critique',
      confirmTitle: 'Acquitter le défaut critique ?',
      confirmMessage:
        "Attention les défauts terrain sont des défauts importants et potentiellement bloquants pour des raisons de sécurité (antigel ou débit d'air par exemple). Voulez-vous acquitter ces défauts ? Auquel cas la CTA ne sera plus bloquée et tentera un redémarrage)",
      confirm: 'Oui',
      cancel: 'Non',
      loading: 'Acquittement en cours…',
      success: 'Acquittement envoyé. La CTA va tenter un redémarrage.',
      error: "Échec de l'acquittement du défaut critique.",
      writeFailed: "L'acquittement n'a pas pu être écrit sur la GTB : le défaut critique est probablement toujours actif. Réessayez ou contactez le support.",
    },
  },
  synoptic: {
    vmc: {
      title: 'Synoptique VMC',
      manage: {
        title: 'Configuration des étages',
        action: 'Configuration',
      },
      sectionLabel: 'Coupe du {{name}}',
      floorCount_one: '{{count}} étage',
      floorCount_other: '{{count}} étages',
      chart: 'Graphique',
      chartSheet: {
        noVmc: 'Aucune VMC dans ce bâtiment.',
        noFault: 'Sain',
        noFaultPoint: "Cette VMC ne remonte pas de point de défaut : il n'y a rien à tracer.",
      },
      filter: {
        all: 'Tous les bâtiments',
      },
      untitledFloor: 'Étage sans nom',
      state: {
        fault: 'Défaut',
      },
      kpi: {
        running: 'VMC en marche',
        faults: 'Défauts VMC',
      },
      configuration: {
        unassignedTitle: 'VMC sans étage',
        allAssigned: 'Toutes les VMC sont rattachées à un étage.',
        addFloor: 'Ajouter un étage',
        removeFloor: "Supprimer l'étage",
        reorder: "Réordonner l'étage",
        floorName: 'Nom',
        floorNamePlaceholder: 'Ex. R+2, RDC, Sous-sol',
        untitledWarning: 'Étage sans nom',
        roof: 'Toiture',
        underground: 'Sous-sol',
        groundLevel: 'Niveau du sol',
        detachVmc: 'Retirer {{name}} de cet étage',
        noFloor: 'Aucun étage défini pour ce bâtiment.',
        dropHere: 'Déposez une VMC ici',
        saved: 'Configuration enregistrée',
        saveError: "La configuration n'a pas pu être enregistrée",
      },
      empty: {
        title: 'Aucun bâtiment sur ce site',
        description: 'Le synoptique VMC se dessine à partir des bâtiments du site. Ajoutez-en un dans les localisations pour commencer.',
        noVmc: {
          title: 'Aucune VMC sur ce site',
          description: "Le synoptique VMC se dessine à partir des VMC importées pour ce site. Aucune n'a été trouvée.",
        },
        noneAssigned: {
          title: "Vos VMC ont besoin d'être localisées",
          description: 'Cliquez ici pour commencer la configuration',
          action: 'Configurer mes VMC',
        },
      },
    },
    breadcrumb: {
      admin: 'Admin',
      list: 'Synoptiques',
      create: 'Nouveau synoptique',
    },
    list: {
      pageTitle: 'Synoptiques',
      mySynoptics: 'Mes synoptiques',
      add: 'Ajouter',
      columnName: 'Nom',
      columnVersion: 'Version',
      columnType: 'Type',
      columnCategory: 'Catégorie',
      columnEquipmentRefs: 'Usage',
      equipmentRefsEmpty: 'Non défini',
      columnCreatedAt: 'Créé le',
      tabSchema: 'Schéma',
      tabModule: 'Module',
      filterTypeAll: 'Tous les types',
      filterCategoryAll: 'Toutes les catégories',
      filterEquipmentRefAll: 'Tous les usages',
    },
    // Textes qui NOMMENT le domaine PAC / groupe froid : tout le reste des pages à modules est commun
    // aux catégories et vit sous boilerRoom (cf. ModuleSynopticDomain.labels).
    heatPumpChiller: {
      viewEmpty: 'Aucun synoptique PAC / GF pour ce site.',
      viewEmptyHint: 'Générez un synoptique pour visualiser vos pompes à chaleur et groupes froids.',
      manageEmpty: 'Aucun synoptique PAC / GF.',
      generateBreadcrumb: 'Génération PAC / GF',
      generateSuccess: 'Synoptique PAC / GF généré',
      kpiRunning: 'État',
      kpiMode: 'Mode',
      kpiSetpoint: 'Consigne',
      chartWaterPressure: 'Pressions d’eau',
      chartRefrigerantPressure: 'Pressions HP / BP',
      chartEvaporator: 'Évaporateur',
      chartCondenser: 'Condenseur',
    },
    boilerRoom: {
      breadcrumb: 'Génération chaufferie',
      stepInfos: 'Informations',
      stepInfosDescription: 'Nom et site',
      stepComposition: 'Composition',
      stepCompositionDescription: 'Modules et équipements',
      stepPreview: 'Visualisation',
      stepPreviewDescription: 'Aperçu du synoptique',
      editInfos: 'Modifier les infos',
      infosTitle: 'Informations du synoptique',
      siteChangeWarning: 'Changer de site réinitialisera les liaisons d’équipements.',
      site: 'Site',
      sitePlaceholder: 'Choisir un site',
      equipment: 'Équipement',
      equipmentSelectPlaceholder: 'Choisir un équipement',
      clearEquipment: 'Détacher l’équipement',
      points: 'Points',
      equipmentPlaceholder: 'Non lié',
      noEquipmentForRef: 'Aucun équipement de ce type sur ce site.',
      noEquipmentBinding: 'Ce module n’est pas configuré pour être relié à un équipement',
      unbindEquipment: 'Délier l’équipement',
      modules: 'Modules (de gauche à droite)',
      addModule: 'Ajouter un module',
      editModule: 'Éditer',
      dragModule: 'Glisser pour réordonner',
      unnamedModule: 'Nouveau module',
      addModuleTitle: 'Ajouter un module',
      stepModule: 'Module',
      stepModuleDescription: 'Choix du module',
      stepEquipment: 'Équipement',
      stepEquipmentDescription: 'Rattachement et libellé',
      addModuleSubmit: 'Ajouter {{moduleName}}',
      noCompatibleEquipment: 'Aucun équipement compatible sur ce site.',
      loadingData: 'Chargement des données…',
      preview: 'Aperçu',
      previewTitle: 'Prévisualisation',
      module: 'Module',
      modulePlaceholder: 'Choisir un module',
      moduleCategoryProduction: 'Production',
      moduleCategoryDistribution: 'Distribution',
      moduleCategoryDhw: 'ECS',
      moduleCategoryOther: 'Autre',
      instanceLabel: 'Libellé',
      instanceLabelPlaceholder: 'Ex. Radiateurs RDC',
      rowToHigh: 'Passer en rangée haute',
      rowToLow: 'Passer en rangée basse',
      duplicateLabels: 'Deux modules portent le même libellé : les libellés doivent être uniques.',
      standaloneSingleModule: 'Hors réseau, un synoptique porte un seul module : retirez les autres.',
      noModules: 'Aucun module {{category}} en base — créez d’abord des modules (type Module, catégorie {{category}}).',
      invalidModule: 'Module non conforme : {{issues}}',
      incompatibleModule: 'Module incompatible avec ce synoptique : {{reason}}',
      faultKpis: 'KPI défauts / alarmes',
      faultKpisHint: 'Choisissez les défauts et alarmes à afficher en cartes au-dessus du synoptique dans la vue technique.',
      primaryTemperature: 'KPI T départ primaire',
      primaryTemperatureHint:
        'Choisissez le circuit de chauffage dont la température de départ primaire s’affiche en carte au-dessus du synoptique dans la vue technique.',
      primaryTemperaturePlaceholder: 'Aucun circuit',
      clearPrimaryTemperature: 'Retirer la KPI T départ primaire',
      addFaultKpi: 'Ajouter un défaut ou une alarme',
      removeFaultKpi: 'Retirer ce KPI',
      noFaultKpiCandidates: 'Aucun point de défaut ou d’alarme sur ce site.',
      inlineTag: 'en ligne',
      cappedCollectors: 'Terminer les collecteurs sur ce module',
      cappedCollectorsHint: 'Les collecteurs s’arrêtent au dernier module au lieu de déborder vers la droite : le flux continue uniquement dans les modules.',
      networked: 'Mise en réseau des modules',
      locationDerived: 'Hors réseau, la localisation (bâtiment, étage) est celle de l’équipement rattaché au module.',
      networkedHint:
        'Les modules sont raccordés à des collecteurs départ / retour. Désactivez pour un équipement autonome (ex. une PAC seule) : le module s’affiche seul, sans collecteur.',
      previewEmpty: 'Choisissez au moins un module pour voir l’aperçu du synoptique.',
      incompleteTitle: 'Composition incomplète',
      incompleteUnbound_one: 'Le module {{modules}} n’a pas d’équipement rattaché : sélectionnez-en un pour passer à la visualisation.',
      incompleteUnbound_other: 'Les modules {{modules}} n’ont pas d’équipement rattaché : sélectionnez-en un pour chacun pour passer à la visualisation.',
      incompleteNoCandidate_one: 'Le module {{modules}} n’a aucun équipement compatible sur ce site : retirez-le ou choisissez un autre module.',
      incompleteNoCandidate_other: 'Les modules {{modules}} n’ont aucun équipement compatible sur ce site : retirez-les ou choisissez d’autres modules.',
      incompleteIncompatible_one: 'Le module {{modules}} est incompatible avec la mise en réseau choisie : retirez-le ou choisissez un autre module.',
      incompleteIncompatible_other: 'Les modules {{modules}} sont incompatibles avec la mise en réseau choisie : retirez-les ou choisissez d’autres modules.',
      submit: 'Générer',
      success: 'Synoptique de chaufferie généré',
      error: 'Échec de la génération',
      view: {
        generate: 'Générer un synoptique',
        toSynoptic: 'Vers {{name}}',
        empty: 'Aucun synoptique de chaufferie pour ce site.',
        emptyHint: 'Générez un synoptique pour visualiser votre chaufferie.',
        noValue: '--',
        kpiFault: 'En défaut',
        kpiOk: 'OK',
        manage: 'Gérer les synoptiques',
      },
      manage: {
        title: 'Gestion des synoptiques',
        empty: 'Aucun synoptique de chaufferie.',
        columnLocation: 'Localisation',
        columnEquipments: 'Équipements',
        columnNetwork: 'Mise en réseau',
        networked: 'En réseau',
        standalone: 'Autonome',
        notLocated: 'Non localisé',
        tabList: 'Synoptiques',
        tabNavigation: 'Navigation',
      },
      graph: {
        labelField: 'Libellé du bouton',
        panelDescription: 'Configurez les boutons de navigation affichés sur ce synoptique.',
        groupMain: 'Navigation principale',
        groupSecondary: 'Navigation secondaire',
        noModule: 'Ce synoptique n’a aucun module.',
        noTarget: 'Aucun',
        staleModuleHint: 'Lien orphelin : le module « {{module}} » ne fait plus partie de ce synoptique.',
        updateLoading: 'Enregistrement…',
        updateSuccess: 'Lien mis à jour',
        updateError: 'Échec de la mise à jour du lien',
        emptyGraphs: 'Aucun synoptique localisé dans un bâtiment : la navigation se configure par bâtiment.',
        previewLabel: 'Aperçu du parcours du bâtiment {{building}}',
        unlocatedHint_one: '{{count}} synoptique de ce site n’est pas localisé dans un bâtiment : localisez-le pour pouvoir le relier aux autres.',
        unlocatedHint_other: '{{count}} synoptiques de ce site ne sont pas localisés dans un bâtiment : localisez-les pour pouvoir les relier aux autres.',
        directionForward: 'Vers la droite',
        directionBackward: 'Vers la gauche',
        targetPlaceholder: 'Choisir un synoptique',
        labelPlaceholder: 'Nom du synoptique cible',
        deleteLink: 'Supprimer le lien',
        createLoading: 'Création du lien…',
        createSuccess: 'Lien créé',
        createError: 'Échec de la création du lien',
        deleteLoading: 'Suppression du lien…',
        deleteSuccess: 'Lien supprimé',
        deleteError: 'Échec de la suppression du lien',
      },
    },
    form: {
      name: 'Nom',
      namePlaceholder: 'Nom du synoptique',
      version: 'Version',
      category: 'Catégorie',
      categoryCta: 'CTA',
      categoryBoilerRoom: 'Chaufferie',
      categoryHeatPumpChiller: 'PAC / GF',
      type: 'Type',
      typeSchema: 'Schéma',
      typeComponent: 'Module',
      moduleKind: 'Sous-type',
      moduleKindBranch: 'Ancré',
      moduleKindInline: 'En ligne',
      connection: 'Branchement',
      connectionBoth: 'Départ + retour',
      connectionSupply: 'Départ seul',
      connectionReturn: 'Retour seul',
      connectionNone: 'Aucun',
      temperature: "Régime d'eau",
      temperatureHot: 'Chaud',
      temperatureCold: 'Froid',
      equipmentRefs: 'Usage',
      equipmentRefFamilyProduction: 'Production',
      equipmentRefFamilyDistribution: 'Distribution',
      equipmentRefFamilyHeatPumpChiller: 'PAC / Groupe froid',
      editMode: 'Mode édition',
      viewMode: 'Mode aperçu',
      save: 'Enregistrer',
      createSubmit: 'Créer',
      editInfos: 'Modifier les infos',
      actionsMenu: 'Actions du synoptique',
      infosTitle: 'Informations du synoptique',
      stepInfos: 'Informations',
      stepInfosDescription: 'Identité du synoptique',
      stepComposition: 'Composition',
      stepCompositionDescription: 'Éditeur du diagramme',
    },
    create: {
      success: 'Synoptique créé',
      error: 'Échec de la création',
    },
    edit: {
      save: 'Enregistrer',
      saveSuccess: 'Synoptique enregistré',
      saveError: "Échec de l'enregistrement",
    },
    duplicate: {
      trigger: 'Dupliquer',
      dialogTitle: 'Dupliquer le synoptique',
      nameLabel: 'Nom du nouveau synoptique',
      namePlaceholder: 'Nom du synoptique',
      submit: 'Dupliquer',
      defaultNameSuffix: '(copie)',
      success: 'Synoptique dupliqué',
      error: 'Échec de la duplication',
    },
    delete: {
      trigger: 'Supprimer',
      title: 'Supprimer le synoptique',
      confirmPrefix: 'Confirmer la suppression de ',
      confirmSuffix: ' ?',
      loading: 'Suppression…',
      success: 'Synoptique supprimé',
      error: 'Échec de la suppression',
    },
  },
  gtbDashboard: {
    sections: {
      health: 'Santé du bâtiment',
      families: 'État par famille',
      followUp: 'Suivi',
      activity: 'Activité récente',
    },
    common: {
      alerts_one: '{{count}} alerte',
      alerts_other: '{{count}} alertes',
      faults_one: '{{count}} défaut',
      faults_other: '{{count}} défauts',
      ok: 'OK',
      noData: '—',
      unavailable: 'Données indisponibles',
      error: 'Erreur de chargement',
      updatedAt: 'Actualisé à {{time}}',
    },
    health: {
      title: 'Santé du bâtiment',
      alerts: {
        label: 'Alertes en cours',
        caption: '{{unacknowledged}} non acquittées · {{critical}} élevées',
      },
      defaults: {
        label: 'Défauts en cours',
        caption_one: 'sur {{count}} point surveillé',
        caption_other: 'sur {{count}} points surveillés',
      },
      outdoorTemperature: {
        label: 'Température extérieure',
      },
      outdoorHumidity: {
        label: 'Humidité extérieure',
      },
      indoorHumidity: {
        label: 'Humidité intérieure',
        caption_one: 'moyenne · {{count}} sonde',
        caption_other: 'moyenne · {{count}} sondes',
      },
      freshness: {
        minutes: 'il y a {{count}} min',
        hours: 'il y a {{count}} h',
      },
      detail: {
        lastValue: 'Dernière mesure',
        stale: 'Aucune mesure depuis plus de 3 h',
        history: 'Historique',
        noDevice: 'Aucun capteur rattaché à cette sonde',
      },
    },
    boilers: {
      title: 'Chaudières',
      link: 'Pilotage chauffage',
      subtitle_one: '{{count}} départ production',
      subtitle_other: '{{count}} départs production',
      averageLabel: 'T° de départ · moyenne',
      minMax: 'min {{min}} · max {{max}}',
      moreDepartures_one: '+ {{count}} autre',
      moreDepartures_other: '+ {{count}} autres',
    },
    hotWater: {
      title: 'Eau chaude sanitaire',
      link: 'Pilotage chauffage',
      subtitle_one: '{{count}} circuit ECS',
      subtitle_other: '{{count}} circuits ECS',
      averageLabel: 'T° de départ ECS · moyenne',
      minMax: 'min {{min}} · max {{max}}',
      moreDepartures_one: '+ {{count}} autre',
      moreDepartures_other: '+ {{count}} autres',
      departuresTitle: 'Départs',
      returnsTitle: 'Retours',
      thresholdHint: 'Seuil {{threshold}} °C',
      belowThreshold_one: '{{count}} circuit sous le seuil',
      belowThreshold_other: '{{count}} circuits sous le seuil',
      noCircuit: 'Aucun point sur ce site',
    },
    circuits: {
      title: 'Circuits de chauffage',
      link: 'Pilotage chauffage',
      subtitle_one: '{{count}} circuit régulé',
      subtitle_other: '{{count}} circuits régulés',
      averageLabel: 'T° de départ · moyenne',
      minMax: 'min {{min}} · max {{max}}',
      moreDepartures_one: '+ {{count}} autre',
      moreDepartures_other: '+ {{count}} autres',
    },
    cta: {
      title: 'CTA',
      link: 'Vue technique',
      subtitle_one: '{{count}} centrale',
      subtitle_other: '{{count}} centrales',
      runningLabel: 'centrales en marche',
      totalSuffix: '/ {{total}}',
      running: 'En fonctionnement',
      stopped: 'À l’arrêt',
      stoppedBadge: 'Arrêt',
      disconnected: 'Déconnectées',
      disconnectedBadge: 'Déconnectée',
      countFraction: '{{count}} / {{total}}',
      columnName: 'Nom',
      columnBlowing: 'Soufflage',
      columnRecovery: 'Reprise',
      columnStatus: 'Statut',
      mobileTemperatures: 'Souffl. {{blowing}} · Repr. {{recovery}} °C',
    },
    heatPump: {
      title: 'PAC',
    },
    coldCircuits: {
      title: 'Circuits froid',
    },
    zoneComfort: {
      title: 'Température par zone',
      link: 'Vue plan',
      subtitle_one: '{{count}} zone',
      subtitle_other: '{{count}} zones',
      inComfort: 'en confort',
      kpi: {
        value: '{{value}} %',
        label_one: '{{count}} zone en confort',
        label_other: '{{count}} zones en confort',
        outOfComfort_one: '{{count}} hors confort',
        outOfComfort_other: '{{count}} hors confort',
        ringLabel: '{{value}} % des zones en confort',
      },
      table: {
        emitterHeader: 'Émetteur',
        zonesHeader: 'Zones',
        comfortHeader: 'Confort',
        derogationHeader: 'Dérog.',
        calendarHeader: 'Calend.',
      },
      calendars: {
        title: 'Calendriers',
        hint: 'Calendriers de chauffage du site, groupes de confort compris',
        link: 'Tous les calendriers',
        empty: 'Aucun calendrier de chauffage',
        more_one: '+ {{count}} autre',
        more_other: '+ {{count}} autres',
        zonesWithout_one: '{{count}} zone sans calendrier',
        zonesWithout_other: '{{count}} zones sans calendrier',
      },
      setpointBars: {
        title: 'Pièces par consigne',
        hint: 'Nombre de pièces selon leur consigne actuelle, par type d’émetteur',
        single_one: '{{count}} pièce, consigne {{setpoint}}',
        single_other: '{{count}} pièces, toutes à {{setpoint}}',
        exact: '{{value}} °C',
        lessOrEqual: '≤ {{value}} °C',
        greaterOrEqual: '≥ {{value}} °C',
      },
    },
    zoneDayNight: {
      title: 'Températures jour / nuit',
      sectionTitle: 'Moyennes des 7 derniers jours',
      link: 'Analyse',
      dayHeader: 'Jour',
      nightHeader: 'Nuit',
      roomLabel: 'Chambres',
      officeLabel: 'Bureaux',
      roomCount_one: '{{count}} chambre',
      roomCount_other: '{{count}} chambres',
      officeCount_one: '{{count}} bureau',
      officeCount_other: '{{count}} bureaux',
      value: '{{value}} °C',
      reduced: 'réduit {{value}} °C',
      noReduction: 'pas de réduit',
    },
    electrical: {
      title: 'Défauts électriques',
      link: 'Vue plan',
      subtitle_one: '{{boardCount}} tableau · {{pointCount}} points',
      subtitle_other: '{{boardCount}} tableaux · {{pointCount}} points',
      okLabel: 'points OK',
      faultBadge: 'En défaut',
      okOthers_one: '{{count}} autre point · OK',
      okOthers_other: '{{count}} autres points · OK',
      allOk_one: '{{count}} point · OK',
      allOk_other: '{{count}} points · OK',
      noData_one: '{{count}} sans donnée',
      noData_other: '{{count}} sans donnée',
    },
    medicalFluids: {
      title: 'Fluides médicaux',
      link: 'Vue plan',
      subtitle_one: '{{count}} point surveillé',
      subtitle_other: '{{count}} points surveillés',
      okLabel: 'points OK',
      faultBadge: 'En défaut',
      okOthers_one: '{{count}} autre point · OK',
      okOthers_other: '{{count}} autres points · OK',
      allOk_one: '{{count}} point · OK',
      allOk_other: '{{count}} points · OK',
      noData_one: '{{count}} sans donnée',
      noData_other: '{{count}} sans donnée',
    },
    lighting: {
      title: 'Éclairage',
      link: 'Calendriers',
      activeSchedules: 'Calendriers actifs',
      litZones: 'Zones allumées',
      litZonesLabel: 'zones allumées',
      litZonesValue: '{{lit}} / {{total}}',
      schedulesChip_one: '{{count}} calendrier',
      schedulesChip_other: '{{count}} calendriers',
    },
    derogations: {
      compactTitle: 'Dérogations',
      compactLabel: 'consignes forcées en cours',
      detailTitle: 'Dérogations en cours',
      detailSubtitle: 'Consignes forcées à la main, par famille',
      chipNoEndDate_one: '{{count}} sans date de fin',
      chipNoEndDate_other: '{{count}} sans date de fin',
      familyZoneComfort: 'Température par zone {{count}}',
      familyLighting: 'Éclairage {{count}}',
      noEndDate: 'Sans date de fin',
      noEndDateValue: '{{count}} · {{name}}',
      noEndDateEmpty: '0',
      nextEnd: 'Prochaine fin',
      nextEndToday: "aujourd'hui {{time}}",
      nextEndTomorrow: 'demain {{time}}',
      nextEndOther: '{{date}}',
      none: 'Aucune dérogation en cours',
      listValueTemperature: '{{value}} °C',
      listNoEndDate: 'sans date de fin',
      listMore_one: '+ {{count}} autre',
      listMore_other: '+ {{count}} autres',
    },
    logbook: {
      title: 'Main courante',
      link: 'Journal',
      subtitle: 'Dernières interventions',
      empty: 'Aucune intervention enregistrée',
      entryMeta: '{{date}} · {{company}}',
      ongoingLabel_one: 'intervention en cours',
      ongoingLabel_other: 'interventions en cours',
      lastEntry: 'Dernière : {{name}}',
    },
    alertsPerMonth: {
      title: 'Alertes par mois',
      link: 'Alertes en cours',
      subtitle: '6 derniers mois',
      avgAckDelay: "Délai moyen d'acquittement",
      avgAckDelayChip: 'Acquittement moyen {{delay}}',
      monthLabel_one: 'alerte en {{month}}',
      monthLabel_other: 'alertes en {{month}}',
      tooltip_one: '{{month}} : {{count}} alerte',
      tooltip_other: '{{month}} : {{count}} alertes',
    },
  },
}

export default fr
